// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"blONj":[function(require,module,exports,__globalThis) {
require("43bcfdbc0ccf4aef").init();
require("ec55a082a83ae6ec").init();

},{"43bcfdbc0ccf4aef":"j4RmI","ec55a082a83ae6ec":"3MPZP"}],"j4RmI":[function(require,module,exports,__globalThis) {
exports.init = function() {
    var $ = require("aa0688f50e4fb55a");
    window.$ = window.jQuery = $;
    var govukFrontend = require("7383e74cfb640cdf");
    govukFrontend.initAll();
    var cookies = require("d236d34f2b3d1e27");
    window.getCookie = cookies.getCookie;
    window.hideCookieBanner = cookies.hideCookieBanner;
    window.cookiesPage = cookies.cookiesPage;
    cookies.cookieBanner();
    var commonGaEvents = require("b2b68002b085cc18");
    window.gaEventValidationError = commonGaEvents.gaEventValidationError;
    window.gaEventBackLink = commonGaEvents.gaEventBackLink;
    window.gaEventExitPage = commonGaEvents.gaEventExitPage;
    window.gaEventOfflineFormDownload = commonGaEvents.gaEventOfflineFormDownload;
    window.gaEventOfflineFormDownloadVoluntary = commonGaEvents.gaEventOfflineFormDownloadVoluntary;
    window.gaEventContactLocalElectoralRegistrationOffice = commonGaEvents.gaEventContactLocalElectoralRegistrationOffice;
    window.gaEventErrorPage = commonGaEvents.gaEventErrorPage;
    window.gaEventSubmitButtonClick = commonGaEvents.gaEventSubmitButtonClick;
    window.setTimeoutWarning = require("262c37d85085cb4").setTimeoutWarning;
    window.commonPages = {
        manualAddress: require("23573a978ac41d75").manualAddress,
        addressAnalytics: require("abd6c5b1e402a8e0").addressAnalytics,
        contact: require("de1886bdb81758fc").contact,
        nino: require("ea83e09195f620ac").nino,
        dateOfBirth: require("e0cca570f06e0a2d").dateOfBirth,
        privacy: require("18303b3b7cb7ff13").privacy,
        uploadDocuments: require("7fcdb55136b6992b").uploadDocuments,
        uploadDocumentsPreSelected: require("7eb843cf56faa2dd").uploadDocumentsPreSelected,
        nationalityAutocomplete: require("e9259d26af04d197").nationalityAutocomplete,
        countryOfResidenceAutocomplete: require("e9259d26af04d197").countryOfResidenceAutocomplete,
        nationalityButtons: require("90e65de4a762db46").nationalityButtons,
        submitForm: require("73a906dbb8372a9c"),
        duplicateApplication: require("bb2b858ec94d2bee").duplicateApplication,
        photoUpload: require("3f33a8bf3e0d5339").photoUpload,
        photoCheck: require("662c404477013bcc").photoCheck,
        confirmation: require("8be37babaa975ec4").confirmation,
        name: require("59ee4c0d8948105f").name,
        survey: require("1ddf51a4e49351d4").survey
    };
    window.decodeHtml = function(html) {
        if ('DOMParser' in window) {
            var doc = new DOMParser().parseFromString(html, "text/html");
            return doc.documentElement.textContent;
        }
        return html;
    };
};

},{"aa0688f50e4fb55a":"6BKaU","7383e74cfb640cdf":"1iBFx","d236d34f2b3d1e27":"a9jtk","b2b68002b085cc18":"6XZMm","262c37d85085cb4":"gQRIW","23573a978ac41d75":"3znqW","abd6c5b1e402a8e0":"5JmtR","de1886bdb81758fc":"lvv9g","ea83e09195f620ac":"1C2yv","e0cca570f06e0a2d":"eDLOo","18303b3b7cb7ff13":"7uULM","7fcdb55136b6992b":"l0PXW","7eb843cf56faa2dd":"7yULf","e9259d26af04d197":"7HrKf","90e65de4a762db46":"eDJCS","73a906dbb8372a9c":"lkTgn","bb2b858ec94d2bee":"gNFpA","3f33a8bf3e0d5339":"fEH4m","662c404477013bcc":"1kSxw","8be37babaa975ec4":"9tPHN","59ee4c0d8948105f":"bVALN","1ddf51a4e49351d4":"4seUS"}],"6BKaU":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
/*!
 * jQuery JavaScript Library v3.7.1 -ajax,-ajax/jsonp,-ajax/load,-ajax/script,-ajax/var/location,-ajax/var/nonce,-ajax/var/rquery,-ajax/xhr,-manipulation/_evalUrl,-deprecated/ajax-event-alias,-effects,-effects/animatedSelector,-effects/Tween
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */ (function(global, factory) {
    "use strict";
    if ((0, _typeOf._)(module.exports) === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket trac-14549 for more info.
    module.exports = global.document ? factory(global, true) : function(w) {
        if (!w.document) throw new Error("jQuery requires a window with a document");
        return factory(w);
    };
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : undefined, function(window1, noGlobal) {
    // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
    // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
    // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
    // enough that all such attempts are guarded in a try block.
    "use strict";
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    var flat = arr.flat ? function flat(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    var support = {};
    var isFunction = function isFunction(obj) {
        // Support: Chrome <=57, Firefox <=52
        // In some browsers, typeof returns "function" for HTML <object> elements
        // (i.e., `typeof document.createElement( "object" ) === "function"`).
        // We don't want to classify *any* DOM node as a function.
        // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
        // Plus for old WebKit, typeof returns "function" for HTML collections
        // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
        return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
    };
    var isWindow = function isWindow(obj) {
        return obj != null && obj === obj.window;
    };
    var document = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document;
        var i, val, script = doc.createElement("script");
        script.text = code;
        if (node) for(i in preservedScriptAttributes){
            // Support: Firefox 64+, Edge 18+
            // Some browsers don't support the "nonce" property on scripts.
            // On the other hand, just using `getAttribute` is not enough as
            // the `nonce` attribute is reset to an empty string whenever it
            // becomes browsing-context connected.
            // See https://github.com/whatwg/html/issues/2369
            // See https://html.spec.whatwg.org/#nonce-attributes
            // The `node.getAttribute` check was added for the sake of
            // `jQuery.globalEval` so that it can fake a nonce-containing node
            // via an object.
            val = node[i] || node.getAttribute && node.getAttribute(i);
            if (val) script.setAttribute(i, val);
        }
        doc.head.appendChild(script).parentNode.removeChild(script);
    }
    function toType(obj) {
        if (obj == null) return obj + "";
        // Support: Android <=2.3 only (functionish RegExp)
        return (typeof obj === "undefined" ? "undefined" : (0, _typeOf._)(obj)) === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj === "undefined" ? "undefined" : (0, _typeOf._)(obj);
    }
    /* global Symbol */ // Defining this global in .eslintrc.json would create a danger of using the global
    // unguarded in another place, it seems safer to define global only for this module
    var version = "3.7.1 -ajax,-ajax/jsonp,-ajax/load,-ajax/script,-ajax/var/location,-ajax/var/nonce,-ajax/var/rquery,-ajax/xhr,-manipulation/_evalUrl,-deprecated/ajax-event-alias,-effects,-effects/animatedSelector,-effects/Tween", rhtmlSuffix = /HTML$/i, // Define a local copy of jQuery
    jQuery = function jQuery1(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function toArray() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function get(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function pushStack(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function each(callback) {
            return jQuery.each(this, callback);
        },
        map: function map(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function slice1() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function first() {
            return this.eq(0);
        },
        last: function last() {
            return this.eq(-1);
        },
        even: function even() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function odd() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function eq(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function end() {
            return this.prevObject || this.constructor();
        },
        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push: push,
        sort: arr.sort,
        splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if ((typeof target === "undefined" ? "undefined" : (0, _typeOf._)(target)) !== "object" && !isFunction(target)) target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function error(msg) {
            throw new Error(msg);
        },
        noop: function noop() {},
        isPlainObject: function isPlainObject(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function isEmptyObject(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function globalEval(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function each(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // Retrieve the text value of an array of DOM nodes
        text: function text(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += jQuery.text(node);
            if (nodeType === 1 || nodeType === 11) return elem.textContent;
            if (nodeType === 9) return elem.documentElement.textContent;
            if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        },
        // results is for internal usage only
        makeArray: function makeArray(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function inArray(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        isXMLDoc: function isXMLDoc(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            // Assume HTML when documentElement doesn't yet exist, such as inside
            // document fragments.
            return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
        },
        // Support: Android <=4.0 only, PhantomJS 1 only
        // push.apply(_, arraylike) throws on ancient WebKit
        merge: function merge(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function grep(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function map(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function isArrayLike(obj) {
        // Support: real iOS 8.2 only (not reproducible in simulator)
        // `in` check used to prevent JIT error (gh-2145)
        // hasOwn isn't used here due to false negatives
        // regarding Nodelist length in IE
        var length = !!obj && "length" in obj && obj.length, type = toType(obj);
        if (isFunction(obj) || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var pop = arr.pop;
    var sort = arr.sort;
    var splice = arr.splice;
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");
    // Note: an element does not contain itself
    jQuery.contains = function(a, b) {
        var bup = b && b.parentNode;
        return a === bup || !!(bup && bup.nodeType === 1 && // Support: IE 9 - 11+
        // IE doesn't have `contains` on SVG.
        (a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
    };
    // CSS string/identifier serialization
    // https://drafts.csswg.org/cssom/#common-serializing-idioms
    var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function fcssescape(ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === "\0") return "\uFFFD";
            // Control characters and (dependent upon position) numbers get escaped as code points
            return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\" + ch;
    }
    jQuery.escapeSelector = function(sel) {
        return (sel + "").replace(rcssescape, fcssescape);
    };
    var preferredDoc = document, pushNative = push;
    (function() {
        var i, Expr, outermostContext, sortInput, hasDuplicate, push = pushNative, // Local document vars
        document, documentElement, documentIsHTML, rbuggyQSA, matches, // Instance-specific data
        expando = jQuery.expando, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function sortOrder(a, b) {
            if (a === b) hasDuplicate = true;
            return 0;
        }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", // Regular expressions
        // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
        identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", // Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
        "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
        // 1. quoted (capture 3; capture 4 or capture 5)
        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
        ".*" + ")\\)|)", // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
        rwhitespace = new RegExp(whitespace + "+", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
            ID: new RegExp("^#(" + identifier + ")"),
            CLASS: new RegExp("^\\.(" + identifier + ")"),
            TAG: new RegExp("^(" + identifier + "|[*])"),
            ATTR: new RegExp("^" + attributes),
            PSEUDO: new RegExp("^" + pseudos),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
            bool: new RegExp("^(?:" + booleans + ")$", "i"),
            // For use in libraries implementing .is()
            // We use this for POS matching in `select`
            needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, // Easily-parseable/retrievable ID or TAG or CLASS selectors
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, // CSS escapes
        // https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
        runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function funescape(escape, nonHex) {
            var high = "0x" + escape.slice(1) - 0x10000;
            if (nonHex) // Strip the backslash prefix from a non-hex escape sequence
            return nonHex;
            // Replace a hexadecimal escape sequence with the encoded Unicode code point
            // Support: IE <=11+
            // For values outside the Basic Multilingual Plane (BMP), manually construct a
            // surrogate pair
            return high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        }, // Used for iframes; see `setDocument`.
        // Support: IE 9 - 11+, Edge 12 - 18+
        // Removing the function wrapper causes a "Permission Denied"
        // error in IE/Edge.
        unloadHandler = function unloadHandler() {
            setDocument();
        }, inDisabledFieldset = addCombinator(function(elem) {
            return elem.disabled === true && nodeName(elem, "fieldset");
        }, {
            dir: "parentNode",
            next: "legend"
        });
        // Support: IE <=9 only
        // Accessing document.activeElement can throw unexpectedly
        // https://bugs.jquery.com/ticket/13393
        function safeActiveElement() {
            try {
                return document.activeElement;
            } catch (err) {}
        }
        // Optimize for push.apply( _, NodeList )
        try {
            push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
            // Support: Android <=4.0
            // Detect silently failing push.apply
            // eslint-disable-next-line no-unused-expressions
            arr[preferredDoc.childNodes.length].nodeType;
        } catch (e) {
            push = {
                apply: function apply(target, els) {
                    pushNative.apply(target, slice.call(els));
                },
                call: function call(target) {
                    pushNative.apply(target, slice.call(arguments, 1));
                }
            };
        }
        function find(selector, context, results, seed) {
            var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
            nodeType = context ? context.nodeType : 9;
            results = results || [];
            // Return early from calls with invalid selector or context
            if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
            // Try to shortcut find operations (as opposed to filters) in HTML documents
            if (!seed) {
                setDocument(context);
                context = context || document;
                if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                        // ID selector
                        if (m = match[1]) {
                            // Document context
                            if (nodeType === 9) {
                                if (elem = context.getElementById(m)) // Support: IE 9 only
                                // getElementById can match elements by name instead of ID
                                {
                                    if (elem.id === m) {
                                        push.call(results, elem);
                                        return results;
                                    }
                                } else return results;
                            // Element context
                            } else // Support: IE 9 only
                            // getElementById can match elements by name instead of ID
                            if (newContext && (elem = newContext.getElementById(m)) && find.contains(context, elem) && elem.id === m) {
                                push.call(results, elem);
                                return results;
                            }
                        // Type selector
                        } else if (match[2]) {
                            push.apply(results, context.getElementsByTagName(selector));
                            return results;
                        // Class selector
                        } else if ((m = match[3]) && context.getElementsByClassName) {
                            push.apply(results, context.getElementsByClassName(m));
                            return results;
                        }
                    }
                    // Take advantage of querySelectorAll
                    if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                        newSelector = selector;
                        newContext = context;
                        // qSA considers elements outside a scoping root when evaluating child or
                        // descendant combinators, which is not what we want.
                        // In such cases, we work around the behavior by prefixing every selector in the
                        // list with an ID selector referencing the scope context.
                        // The technique has to be used as well when a leading combinator is used
                        // as such selectors are not recognized by querySelectorAll.
                        // Thanks to Andrew Dupont for this technique.
                        if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                            // Expand context for sibling selectors
                            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                            // We can use :scope instead of the ID hack if the browser
                            // supports it & if we're not changing the context.
                            // Support: IE 11+, Edge 17 - 18+
                            // IE/Edge sometimes throw a "Permission denied" error when
                            // strict-comparing two documents; shallow comparisons work.
                            // eslint-disable-next-line eqeqeq
                            if (newContext != context || !support.scope) {
                                // Capture the context ID, setting it first if necessary
                                if (nid = context.getAttribute("id")) nid = jQuery.escapeSelector(nid);
                                else context.setAttribute("id", nid = expando);
                            }
                            // Prefix every selector in the list
                            groups = tokenize(selector);
                            i = groups.length;
                            while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                            newSelector = groups.join(",");
                        }
                        try {
                            push.apply(results, newContext.querySelectorAll(newSelector));
                            return results;
                        } catch (qsaError) {
                            nonnativeSelectorCache(selector, true);
                        } finally{
                            if (nid === expando) context.removeAttribute("id");
                        }
                    }
                }
            }
            // All others
            return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
        }
        /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
            var keys = [];
            function cache(key, value) {
                // Use (key + " ") to avoid collision with native prototype properties
                // (see https://github.com/jquery/sizzle/issues/157)
                if (keys.push(key + " ") > Expr.cacheLength) // Only keep the most recent entries
                delete cache[keys.shift()];
                return cache[key + " "] = value;
            }
            return cache;
        }
        /**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
            fn[expando] = true;
            return fn;
        }
        /**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */ function assert(fn) {
            var el = document.createElement("fieldset");
            try {
                return !!fn(el);
            } catch (e) {
                return false;
            } finally{
                // Remove from its parent by default
                if (el.parentNode) el.parentNode.removeChild(el);
                // release memory in IE
                el = null;
            }
        }
        /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
            return function(elem) {
                return nodeName(elem, "input") && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
            return function(elem) {
                return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
            // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
            return function(elem) {
                // Only certain elements can match :enabled or :disabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                if ("form" in elem) {
                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {
                        // Option elements defer to a parent optgroup if present
                        if ("label" in elem) {
                            if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                            else return elem.disabled === disabled;
                        }
                        // Support: IE 6 - 11+
                        // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                        return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                        elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                    }
                    return elem.disabled === disabled;
                // Try to winnow out elements that can't be disabled before trusting the disabled property.
                // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                // even exist on them, let alone have a boolean value.
                } else if ("label" in elem) return elem.disabled === disabled;
                // Remaining elements are neither :enabled nor :disabled
                return false;
            };
        }
        /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
            return markFunction(function(argument) {
                argument = +argument;
                return markFunction(function(seed, matches) {
                    var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                    // Match elements found at the specified indexes
                    while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
                });
            });
        }
        /**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
            return context && typeof context.getElementsByTagName !== "undefined" && context;
        }
        /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */ function setDocument(node) {
            var subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
            // Return early if doc is invalid or already selected
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (doc == document || doc.nodeType !== 9 || !doc.documentElement) return document;
            // Update global variables
            document = doc;
            documentElement = document.documentElement;
            documentIsHTML = !jQuery.isXMLDoc(document);
            // Support: iOS 7 only, IE 9 - 11+
            // Older browsers didn't support unprefixed `matches`.
            matches = documentElement.matches || documentElement.webkitMatchesSelector || documentElement.msMatchesSelector;
            // Support: IE 9 - 11+, Edge 12 - 18+
            // Accessing iframe documents after unload throws "permission denied" errors
            // (see trac-13936).
            // Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
            // all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
            if (documentElement.msMatchesSelector && // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) // Support: IE 9 - 11+, Edge 12 - 18+
            subWindow.addEventListener("unload", unloadHandler);
            // Support: IE <10
            // Check if getElementById returns elements by name
            // The broken getElementById methods don't pick up programmatically-set names,
            // so use a roundabout getElementsByName test
            support.getById = assert(function(el) {
                documentElement.appendChild(el).id = jQuery.expando;
                return !document.getElementsByName || !document.getElementsByName(jQuery.expando).length;
            });
            // Support: IE 9 only
            // Check to see if it's possible to do matchesSelector
            // on a disconnected node.
            support.disconnectedMatch = assert(function(el) {
                return matches.call(el, "*");
            });
            // Support: IE 9 - 11+, Edge 12 - 18+
            // IE/Edge don't support the :scope pseudo-class.
            support.scope = assert(function() {
                return document.querySelectorAll(":scope");
            });
            // Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
            // Make sure the `:has()` argument is parsed unforgivingly.
            // We include `*` in the test to detect buggy implementations that are
            // _selectively_ forgiving (specifically when the list includes at least
            // one valid selector).
            // Note that we treat complete lack of support for `:has()` as if it were
            // spec-compliant support, which is fine because use of `:has()` in such
            // environments will fail in the qSA path and fall back to jQuery traversal
            // anyway.
            support.cssHas = assert(function() {
                try {
                    document.querySelector(":has(*,:jqfake)");
                    return false;
                } catch (e) {
                    return true;
                }
            });
            // ID filter and find
            if (support.getById) {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        return elem.getAttribute("id") === attrId;
                    };
                };
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var elem = context.getElementById(id);
                        return elem ? [
                            elem
                        ] : [];
                    }
                };
            } else {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        var _$node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                        return _$node && _$node.value === attrId;
                    };
                };
                // Support: IE 6 - 7 only
                // getElementById is not reliable as a find shortcut
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var _$node, i, elems, elem = context.getElementById(id);
                        if (elem) {
                            // Verify the id attribute
                            _$node = elem.getAttributeNode("id");
                            if (_$node && _$node.value === id) return [
                                elem
                            ];
                            // Fall back on getElementsByName
                            elems = context.getElementsByName(id);
                            i = 0;
                            while(elem = elems[i++]){
                                _$node = elem.getAttributeNode("id");
                                if (_$node && _$node.value === id) return [
                                    elem
                                ];
                            }
                        }
                        return [];
                    }
                };
            }
            // Tag
            Expr.find.TAG = function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else return context.querySelectorAll(tag);
            };
            // Class
            Expr.find.CLASS = function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            };
            /* QSA/matchesSelector
	---------------------------------------------------------------------- */ // QSA and matchesSelector support
            rbuggyQSA = [];
            // Build QSA regex
            // Regex strategy adopted from Diego Perini
            assert(function(el) {
                var input;
                documentElement.appendChild(el).innerHTML = "<a id='" + expando + "' href='' disabled='disabled'></a>" + "<select id='" + expando + "-\r\\' disabled='disabled'>" + "<option selected=''></option></select>";
                // Support: iOS <=7 - 8 only
                // Boolean attributes and "value" are not treated correctly in some XML documents
                if (!el.querySelectorAll("[selected]").length) rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                // Support: iOS <=7 - 8 only
                if (!el.querySelectorAll("[id~=" + expando + "-]").length) rbuggyQSA.push("~=");
                // Support: iOS 8 only
                // https://bugs.webkit.org/show_bug.cgi?id=136851
                // In-page `selector#id sibling-combinator selector` fails
                if (!el.querySelectorAll("a#" + expando + "+*").length) rbuggyQSA.push(".#.+[+~]");
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                if (!el.querySelectorAll(":checked").length) rbuggyQSA.push(":checked");
                // Support: Windows 8 Native Apps
                // The type and name attributes are restricted during .innerHTML assignment
                input = document.createElement("input");
                input.setAttribute("type", "hidden");
                el.appendChild(input).setAttribute("name", "D");
                // Support: IE 9 - 11+
                // IE's :disabled selector does not pick up the children of disabled fieldsets
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                documentElement.appendChild(el).disabled = true;
                if (el.querySelectorAll(":disabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                // Support: IE 11+, Edge 15 - 18+
                // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                // Adding a temporary attribute to the document before the selection works
                // around the issue.
                // Interestingly, IE 10 & older don't seem to have the issue.
                input = document.createElement("input");
                input.setAttribute("name", "");
                el.appendChild(input);
                if (!el.querySelectorAll("[name='']").length) rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
            });
            if (!support.cssHas) // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
            // Our regular `try-catch` mechanism fails to detect natively-unsupported
            // pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
            // in browsers that parse the `:has()` argument as a forgiving selector list.
            // https://drafts.csswg.org/selectors/#relational now requires the argument
            // to be parsed unforgivingly, but browsers have not yet fully adjusted.
            rbuggyQSA.push(":has");
            rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
            /* Sorting
	---------------------------------------------------------------------- */ // Document order sorting
            sortOrder = function sortOrder(a, b) {
                // Flag for duplicate removal
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                // Sort on method existence if only one input has compareDocumentPosition
                var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                if (compare) return compare;
                // Calculate position if both inputs belong to the same document
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
                1;
                // Disconnected nodes
                if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
                    // Choose the first element that is related to our preferred document
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (a === document || a.ownerDocument == preferredDoc && find.contains(preferredDoc, a)) return -1;
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (b === document || b.ownerDocument == preferredDoc && find.contains(preferredDoc, b)) return 1;
                    // Maintain original order
                    return sortInput ? indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : 0;
                }
                return compare & 4 ? -1 : 1;
            };
            return document;
        }
        find.matches = function(expr, elements) {
            return find(expr, null, null, elements);
        };
        find.matchesSelector = function(elem, expr) {
            setDocument(elem);
            if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
                var ret = matches.call(elem, expr);
                // IE 9's matchesSelector returns false on disconnected nodes
                if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                // fragment in IE 9
                elem.document && elem.document.nodeType !== 11) return ret;
            } catch (e) {
                nonnativeSelectorCache(expr, true);
            }
            return find(expr, document, null, [
                elem
            ]).length > 0;
        };
        find.contains = function(context, elem) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((context.ownerDocument || context) != document) setDocument(context);
            return jQuery.contains(context, elem);
        };
        find.attr = function(elem, name) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((elem.ownerDocument || elem) != document) setDocument(elem);
            var fn = Expr.attrHandle[name.toLowerCase()], // Don't get fooled by Object.prototype properties (see trac-13807)
            val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
            if (val !== undefined) return val;
            return elem.getAttribute(name);
        };
        find.error = function(msg) {
            throw new Error("Syntax error, unrecognized expression: " + msg);
        };
        /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ jQuery.uniqueSort = function(results) {
            var elem, duplicates = [], j = 0, i = 0;
            // Unless we *know* we can detect duplicates, assume their presence
            //
            // Support: Android <=4.0+
            // Testing for detecting duplicates is unpredictable so instead assume we can't
            // depend on duplicate detection in all browsers without a stable sort.
            hasDuplicate = !support.sortStable;
            sortInput = !support.sortStable && slice.call(results, 0);
            sort.call(results, sortOrder);
            if (hasDuplicate) {
                while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
                while(j--)splice.call(results, duplicates[j], 1);
            }
            // Clear input after sorting to release objects
            // See https://github.com/jquery/sizzle/pull/225
            sortInput = null;
            return results;
        };
        jQuery.fn.uniqueSort = function() {
            return this.pushStack(jQuery.uniqueSort(slice.apply(this)));
        };
        Expr = jQuery.expr = {
            // Can be adjusted by the user
            cacheLength: 50,
            createPseudo: markFunction,
            match: matchExpr,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: true
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: true
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function ATTR(match) {
                    match[1] = match[1].replace(runescape, funescape);
                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                    if (match[2] === "~=") match[3] = " " + match[3] + " ";
                    return match.slice(0, 4);
                },
                CHILD: function CHILD(match) {
                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/ match[1] = match[1].toLowerCase();
                    if (match[1].slice(0, 3) === "nth") {
                        // nth-* requires argument
                        if (!match[3]) find.error(match[0]);
                        // numeric x and y parameters for Expr.filter.CHILD
                        // remember that false/true cast respectively to 0/1
                        match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                        match[5] = +(match[7] + match[8] || match[3] === "odd");
                    // other types prohibit arguments
                    } else if (match[3]) find.error(match[0]);
                    return match;
                },
                PSEUDO: function PSEUDO(match) {
                    var excess, unquoted = !match[6] && match[2];
                    if (matchExpr.CHILD.test(match[0])) return null;
                    // Accept quoted arguments as-is
                    if (match[3]) match[2] = match[4] || match[5] || "";
                    else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                    (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                    (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                        // excess is a negative index
                        match[0] = match[0].slice(0, excess);
                        match[2] = unquoted.slice(0, excess);
                    }
                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                }
            },
            filter: {
                TAG: function TAG(nodeNameSelector) {
                    var expectedNodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                    return nodeNameSelector === "*" ? function() {
                        return true;
                    } : function(elem) {
                        return nodeName(elem, expectedNodeName);
                    };
                },
                CLASS: function CLASS(className) {
                    var pattern = classCache[className + " "];
                    return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                        return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                    }));
                },
                ATTR: function ATTR(name, operator, check) {
                    return function(elem) {
                        var result = find.attr(elem, name);
                        if (result == null) return operator === "!=";
                        if (!operator) return true;
                        result += "";
                        if (operator === "=") return result === check;
                        if (operator === "!=") return result !== check;
                        if (operator === "^=") return check && result.indexOf(check) === 0;
                        if (operator === "*=") return check && result.indexOf(check) > -1;
                        if (operator === "$=") return check && result.slice(-check.length) === check;
                        if (operator === "~=") return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
                        if (operator === "|=") return result === check || result.slice(0, check.length + 1) === check + "-";
                        return false;
                    };
                },
                CHILD: function CHILD(type, what, _argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                    return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                    function(elem) {
                        return !!elem.parentNode;
                    } : function(elem, _context, xml) {
                        var cache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                        if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                                while(dir){
                                    node = elem;
                                    while(node = node[dir]){
                                        if (ofType ? nodeName(node, name) : node.nodeType === 1) return false;
                                    }
                                    // Reverse direction for :only-* (if we haven't yet done so)
                                    start = dir = type === "only" && !start && "nextSibling";
                                }
                                return true;
                            }
                            start = [
                                forward ? parent.firstChild : parent.lastChild
                            ];
                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                                // Seek `elem` from a previously-cached index
                                outerCache = parent[expando] || (parent[expando] = {});
                                cache = outerCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex && cache[2];
                                node = nodeIndex && parent.childNodes[nodeIndex];
                                while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                                (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                                if (node.nodeType === 1 && ++diff && node === elem) {
                                    outerCache[type] = [
                                        dirruns,
                                        nodeIndex,
                                        diff
                                    ];
                                    break;
                                }
                            } else {
                                // Use previously-cached element index if available
                                if (useCache) {
                                    outerCache = elem[expando] || (elem[expando] = {});
                                    cache = outerCache[type] || [];
                                    nodeIndex = cache[0] === dirruns && cache[1];
                                    diff = nodeIndex;
                                }
                                // xml :nth-child(...)
                                // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                if (diff === false) {
                                    // Use the same loop as above to seek `elem` from the start
                                    while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {
                                        // Cache the index of each encountered element
                                        if (useCache) {
                                            outerCache = node[expando] || (node[expando] = {});
                                            outerCache[type] = [
                                                dirruns,
                                                diff
                                            ];
                                        }
                                        if (node === elem) break;
                                    }
                                }
                            }
                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return diff === first || diff % first === 0 && diff / first >= 0;
                        }
                    };
                },
                PSEUDO: function PSEUDO(pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // https://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || find.error("unsupported pseudo: " + pseudo);
                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as jQuery does
                    if (fn[expando]) return fn(argument);
                    // But maintain support for old signatures
                    if (fn.length > 1) {
                        args = [
                            pseudo,
                            pseudo,
                            "",
                            argument
                        ];
                        return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
                            var idx, matched = fn(seed, argument), i = matched.length;
                            while(i--){
                                idx = indexOf.call(seed, matched[i]);
                                seed[idx] = !(matches[idx] = matched[i]);
                            }
                        }) : function(elem) {
                            return fn(elem, 0, args);
                        };
                    }
                    return fn;
                }
            },
            pseudos: {
                // Potentially complex pseudos
                not: markFunction(function(selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [], results = [], matcher = compile(selector.replace(rtrimCSS, "$1"));
                    return matcher[expando] ? markFunction(function(seed, matches, _context, xml) {
                        var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                        // Match elements unmatched by `matcher`
                        while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                    }) : function(elem, _context, xml) {
                        input[0] = elem;
                        matcher(input, null, xml, results);
                        // Don't keep the element
                        // (see https://github.com/jquery/sizzle/issues/299)
                        input[0] = null;
                        return !results.pop();
                    };
                }),
                has: markFunction(function(selector) {
                    return function(elem) {
                        return find(selector, elem).length > 0;
                    };
                }),
                contains: markFunction(function(text) {
                    text = text.replace(runescape, funescape);
                    return function(elem) {
                        return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
                    };
                }),
                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // https://www.w3.org/TR/selectors/#lang-pseudo
                lang: markFunction(function(lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) find.error("unsupported lang: " + lang);
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function(elem) {
                        var elemLang;
                        do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                            elemLang = elemLang.toLowerCase();
                            return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                        }
                        while ((elem = elem.parentNode) && elem.nodeType === 1);
                        return false;
                    };
                }),
                // Miscellaneous
                target: function target(elem) {
                    var hash = window1.location && window1.location.hash;
                    return hash && hash.slice(1) === elem.id;
                },
                root: function root(elem) {
                    return elem === documentElement;
                },
                focus: function focus(elem) {
                    return elem === safeActiveElement() && document.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
                },
                // Boolean properties
                enabled: createDisabledPseudo(false),
                disabled: createDisabledPseudo(true),
                checked: function checked(elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
                },
                selected: function selected(elem) {
                    // Support: IE <=11+
                    // Accessing the selectedIndex property
                    // forces the browser to treat the default option as
                    // selected when in an optgroup.
                    if (elem.parentNode) // eslint-disable-next-line no-unused-expressions
                    elem.parentNode.selectedIndex;
                    return elem.selected === true;
                },
                // Contents
                empty: function empty(elem) {
                    // https://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                        if (elem.nodeType < 6) return false;
                    }
                    return true;
                },
                parent: function parent(elem) {
                    return !Expr.pseudos.empty(elem);
                },
                // Element/input types
                header: function header(elem) {
                    return rheader.test(elem.nodeName);
                },
                input: function input(elem) {
                    return rinputs.test(elem.nodeName);
                },
                button: function button(elem) {
                    return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
                },
                text: function text(elem) {
                    var attr;
                    return nodeName(elem, "input") && elem.type === "text" && // Support: IE <10 only
                    // New HTML5 attribute values (e.g., "search") appear
                    // with elem.type === "text"
                    ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                },
                // Position-in-collection
                first: createPositionalPseudo(function() {
                    return [
                        0
                    ];
                }),
                last: createPositionalPseudo(function(_matchIndexes, length) {
                    return [
                        length - 1
                    ];
                }),
                eq: createPositionalPseudo(function(_matchIndexes, length, argument) {
                    return [
                        argument < 0 ? argument + length : argument
                    ];
                }),
                even: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 0;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                odd: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 1;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                lt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i;
                    if (argument < 0) i = argument + length;
                    else if (argument > length) i = length;
                    else i = argument;
                    for(; --i >= 0;)matchIndexes.push(i);
                    return matchIndexes;
                }),
                gt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for(; ++i < length;)matchIndexes.push(i);
                    return matchIndexes;
                })
            }
        };
        Expr.pseudos.nth = Expr.pseudos.eq;
        // Add button/input type pseudos
        for(i in {
            radio: true,
            checkbox: true,
            file: true,
            password: true,
            image: true
        })Expr.pseudos[i] = createInputPseudo(i);
        for(i in {
            submit: true,
            reset: true
        })Expr.pseudos[i] = createButtonPseudo(i);
        // Easy API for creating new setFilters
        function setFilters() {}
        setFilters.prototype = Expr.filters = Expr.pseudos;
        Expr.setFilters = new setFilters();
        function tokenize(selector, parseOnly) {
            var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
            if (cached) return parseOnly ? 0 : cached.slice(0);
            soFar = selector;
            groups = [];
            preFilters = Expr.preFilter;
            while(soFar){
                // Comma and first run
                if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) // Don't consume trailing commas as valid
                    soFar = soFar.slice(match[0].length) || soFar;
                    groups.push(tokens = []);
                }
                matched = false;
                // Combinators
                if (match = rleadingCombinator.exec(soFar)) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        // Cast descendant combinators to space
                        type: match[0].replace(rtrimCSS, " ")
                    });
                    soFar = soFar.slice(matched.length);
                }
                // Filters
                for(type in Expr.filter)if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        type: type,
                        matches: match
                    });
                    soFar = soFar.slice(matched.length);
                }
                if (!matched) break;
            }
            // Return the length of the invalid excess
            // if we're just parsing
            // Otherwise, throw an error or return tokens
            if (parseOnly) return soFar.length;
            return soFar ? find.error(selector) : // Cache the tokens
            tokenCache(selector, groups).slice(0);
        }
        function toSelector(tokens) {
            var i = 0, len = tokens.length, selector = "";
            for(; i < len; i++)selector += tokens[i].value;
            return selector;
        }
        function addCombinator(matcher, combinator, base) {
            var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
            return combinator.first ? // Check against closest ancestor/preceding element
            function(elem, context, xml) {
                while(elem = elem[dir]){
                    if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
                }
                return false;
            } : // Check against all ancestor/preceding elements
            function(elem, context, xml) {
                var oldCache, outerCache, newCache = [
                    dirruns,
                    doneName
                ];
                // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                if (xml) {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        if (matcher(elem, context, xml)) return true;
                    }
                } else {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        outerCache = elem[expando] || (elem[expando] = {});
                        if (skip && nodeName(elem, skip)) elem = elem[dir] || elem;
                        else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                        return newCache[2] = oldCache[2];
                        else {
                            // Reuse newcache so results back-propagate to previous elements
                            outerCache[key] = newCache;
                            // A match means we're done; a fail means we have to keep checking
                            if (newCache[2] = matcher(elem, context, xml)) return true;
                        }
                    }
                }
                return false;
            };
        }
        function elementMatcher(matchers) {
            return matchers.length > 1 ? function(elem, context, xml) {
                var i = matchers.length;
                while(i--){
                    if (!matchers[i](elem, context, xml)) return false;
                }
                return true;
            } : matchers[0];
        }
        function multipleContexts(selector, contexts, results) {
            var i = 0, len = contexts.length;
            for(; i < len; i++)find(selector, contexts[i], results);
            return results;
        }
        function condense(unmatched, map, filter, context, xml) {
            var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
            for(; i < len; i++){
                if (elem = unmatched[i]) {
                    if (!filter || filter(elem, context, xml)) {
                        newUnmatched.push(elem);
                        if (mapped) map.push(i);
                    }
                }
            }
            return newUnmatched;
        }
        function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
            if (postFilter && !postFilter[expando]) postFilter = setMatcher(postFilter);
            if (postFinder && !postFinder[expando]) postFinder = setMatcher(postFinder, postSelector);
            return markFunction(function(seed, results, context, xml) {
                var temp, i, elem, matcherOut, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
                elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                    context
                ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
                matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;
                if (matcher) {
                    // If we have a postFinder, or filtered seed, or non-seed postFilter
                    // or preexisting results,
                    matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                    [] : // ...otherwise use results directly
                    results;
                    // Find primary matches
                    matcher(matcherIn, matcherOut, context, xml);
                } else matcherOut = matcherIn;
                // Apply postFilter
                if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);
                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                }
                if (seed) {
                    if (postFinder || preFilter) {
                        if (postFinder) {
                            // Get the final matcherOut by condensing this intermediate into postFinder contexts
                            temp = [];
                            i = matcherOut.length;
                            while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                            temp.push(matcherIn[i] = elem);
                            postFinder(null, matcherOut = [], temp, xml);
                        }
                        // Move matched elements from seed to results to keep them synchronized
                        i = matcherOut.length;
                        while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                    }
                } else {
                    matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                    if (postFinder) postFinder(null, results, matcherOut, xml);
                    else push.apply(results, matcherOut);
                }
            });
        }
        function matcherFromTokens(tokens) {
            var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
            matchContext = addCombinator(function(elem) {
                return elem === checkContext;
            }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
                return indexOf.call(checkContext, elem) > -1;
            }, implicitRelative, true), matchers = [
                function(elem, context, xml) {
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                    // Avoid hanging onto element
                    // (see https://github.com/jquery/sizzle/issues/299)
                    checkContext = null;
                    return ret;
                }
            ];
            for(; i < len; i++)if (matcher = Expr.relative[tokens[i].type]) matchers = [
                addCombinator(elementMatcher(matchers), matcher)
            ];
            else {
                matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                // Return special upon seeing a positional matcher
                if (matcher[expando]) {
                    // Find the next relative operator (if any) for proper handling
                    j = ++i;
                    for(; j < len; j++){
                        if (Expr.relative[tokens[j].type]) break;
                    }
                    return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                    tokens.slice(0, i - 1).concat({
                        value: tokens[i - 2].type === " " ? "*" : ""
                    })).replace(rtrimCSS, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
                }
                matchers.push(matcher);
            }
            return elementMatcher(matchers);
        }
        function matcherFromGroupMatchers(elementMatchers, setMatchers) {
            var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function superMatcher(seed, context, xml, results, outermost) {
                var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
                elems = seed || byElement && Expr.find.TAG("*", outermost), // Use integer dirruns iff this is the outermost matcher
                dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
                if (outermost) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                outermostContext = context == document || context || outermost;
                // Add elements passing elementMatchers directly to results
                // Support: iOS <=7 - 9 only
                // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
                // elements by id. (see trac-14142)
                for(; i !== len && (elem = elems[i]) != null; i++){
                    if (byElement && elem) {
                        j = 0;
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (!context && elem.ownerDocument != document) {
                            setDocument(elem);
                            xml = !documentIsHTML;
                        }
                        while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                            push.call(results, elem);
                            break;
                        }
                        if (outermost) dirruns = dirrunsUnique;
                    }
                    // Track unmatched elements for set filters
                    if (bySet) {
                        // They will have gone through all possible matchers
                        if (elem = !matcher && elem) matchedCount--;
                        // Lengthen the array for every element, matched or not
                        if (seed) unmatched.push(elem);
                    }
                }
                // `i` is now the count of elements visited above, and adding it to `matchedCount`
                // makes the latter nonnegative.
                matchedCount += i;
                // Apply set filters to unmatched elements
                // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                // no element matchers and no seed.
                // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                // numerically zero.
                if (bySet && i !== matchedCount) {
                    j = 0;
                    while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                    if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                            while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                        }
                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                    }
                    // Add matches to results
                    push.apply(results, setMatched);
                    // Seedless set matches succeeding multiple successful matchers stipulate sorting
                    if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) jQuery.uniqueSort(results);
                }
                // Override manipulation of globals by nested matchers
                if (outermost) {
                    dirruns = dirrunsUnique;
                    outermostContext = contextBackup;
                }
                return unmatched;
            };
            return bySet ? markFunction(superMatcher) : superMatcher;
        }
        function compile(selector, match /* Internal Use Only */ ) {
            var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
            if (!cached) {
                // Generate a function of recursive functions that can be used to check each element
                if (!match) match = tokenize(selector);
                i = match.length;
                while(i--){
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) setMatchers.push(cached);
                    else elementMatchers.push(cached);
                }
                // Cache the compiled function
                cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                // Save selector and tokenization
                cached.selector = selector;
            }
            return cached;
        }
        /**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ function select(selector, context, results, seed) {
            var i, tokens, token, type, _$find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
            results = results || [];
            // Try to minimize operations if there is only one selector in the list and no seed
            // (the latter of which guarantees us context)
            if (match.length === 1) {
                // Reduce context if the leading compound selector is an ID
                tokens = match[0] = match[0].slice(0);
                if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                    context = (Expr.find.ID(token.matches[0].replace(runescape, funescape), context) || [])[0];
                    if (!context) return results;
                    else if (compiled) context = context.parentNode;
                    selector = selector.slice(tokens.shift().value.length);
                }
                // Fetch a seed set for right-to-left matching
                i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
                while(i--){
                    token = tokens[i];
                    // Abort if we hit a combinator
                    if (Expr.relative[type = token.type]) break;
                    if (_$find = Expr.find[type]) // Search, expanding context for leading sibling combinators
                    {
                        if (seed = _$find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                            // If seed is empty or no tokens remain, we can return early
                            tokens.splice(i, 1);
                            selector = seed.length && toSelector(tokens);
                            if (!selector) {
                                push.apply(results, seed);
                                return results;
                            }
                            break;
                        }
                    }
                }
            }
            // Compile and execute a filtering function if one is not provided
            // Provide `match` to avoid retokenization if we modified the selector above
            (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
            return results;
        }
        // One-time assignments
        // Support: Android <=4.0 - 4.1+
        // Sort stability
        support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
        // Initialize against the default document
        setDocument();
        // Support: Android <=4.0 - 4.1+
        // Detached nodes confoundingly follow *each other*
        support.sortDetached = assert(function(el) {
            // Should return 1, but returns 4 (following)
            return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
        });
        jQuery.find = find;
        // Deprecated
        jQuery.expr[":"] = jQuery.expr.pseudos;
        jQuery.unique = jQuery.uniqueSort;
        // These have always been private, but they used to be documented as part of
        // Sizzle so let's maintain them for now for backwards compatibility purposes.
        find.compile = compile;
        find.select = select;
        find.setDocument = setDocument;
        find.tokenize = tokenize;
        find.escape = jQuery.escapeSelector;
        find.getText = jQuery.text;
        find.isXML = jQuery.isXMLDoc;
        find.selectors = jQuery.expr;
        find.support = jQuery.support;
        find.uniqueSort = jQuery.uniqueSort;
    /* eslint-enable */ })();
    var dir = function dir(elem, _dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[_dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    };
    var siblings = function siblings(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (isFunction(qualifier)) return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function find(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function filter(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function not(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function is(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function init(selector, context, root) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // Method init() accepts an alternate rootjQuery
        // so migrate can support jQuery.sub (gh-2101)
        root = root || rootjQuery;
        // Handle HTML strings
        if (typeof selector === "string") {
            if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) // Assume that strings that start and end with <> are HTML and skip the regex check
            match = [
                null,
                selector,
                null
            ];
            else match = rquickExpr.exec(selector);
            // Match html or make sure no context is specified for #id
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (isFunction(this[match])) this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || root).find(selector);
            else return this.constructor(context).find(selector);
        // HANDLE: $(DOMElement)
        } else if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (isFunction(selector)) return root.ready !== undefined ? root.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        return jQuery.makeArray(selector, this);
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function has(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function closest(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to jQuery#find
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function index(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function add(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function addBack(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function parent(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function parents(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function parentsUntil(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function next(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function prev(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function nextAll(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function prevAll(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function nextUntil(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function prevUntil(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function siblings1(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function children(elem) {
            return siblings(elem.firstChild);
        },
        contents: function contents(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function fire() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function add() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (isFunction(arg)) {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function remove() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function has(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function empty() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function disable() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function disabled() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function lock() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function locked1() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function fireWith(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function fire() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function fired1() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && isFunction(method = value.promise)) method.call(value).done(resolve).fail(reject);
            else if (value && isFunction(method = value.then)) method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply(undefined, [
                value
            ]);
        }
    }
    jQuery.extend({
        Deferred: function Deferred(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function state1() {
                    return state;
                },
                always: function always() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                "catch": function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function pipe() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && isFunction(returned.promise)) returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function then(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function mightThrow() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                ((typeof returned === "undefined" ? "undefined" : (0, _typeOf._)(returned)) === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (isFunction(then)) {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function process1() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.error);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the error, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getErrorHook) process.error = jQuery.Deferred.getErrorHook();
                                else if (jQuery.Deferred.getStackHook) process.error = jQuery.Deferred.getStackHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function promise1(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function when(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
            primary = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function updateFunc(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) return primary.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            return primary.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    // If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
    // captured before the async barrier to get the original error cause
    // which may otherwise be hidden.
    jQuery.Deferred.exceptionHook = function(error, asyncError) {
        // Support: IE 8 - 9 only
        // Console exists when dev tools are open, which can happen at any time
        if (window1.console && window1.console.warn && error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception: " + error.message, error.stack, asyncError);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)["catch"](function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See trac-6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function ready(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    // Support: IE <=9 - 10 only
    // Older IE sometimes signals "interactive" too soon
    if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    var access = function access1(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (!isFunction(value)) raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function fn(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    };
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase; used by the css and data modules
    // Support: IE <=9 - 11, Edge 12 - 15
    // Microsoft forgot to hump their vendor prefix (trac-9572)
    function camelCase(string) {
        return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    }
    var acceptData = function acceptData(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    };
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function cache(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = {};
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see trac-8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function set(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return cache;
        },
        get: function get(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function access(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function remove(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function hasData(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function hasData(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function data(elem, name, _data) {
            return dataUser.access(elem, name, _data);
        },
        removeData: function removeData(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function _data(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function _removeData(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function data(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11 only
                        // The attrs elements can be null (trac-14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if ((typeof key === "undefined" ? "undefined" : (0, _typeOf._)(key)) === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function removeData(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function queue(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function dequeue(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function next() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function _queueHooks(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function queue(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function dequeue(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function clearQueue(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function promise(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function resolve() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    var documentElement = document.documentElement;
    var isAttached = function isAttached(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
    // Check attachment across shadow DOM boundaries when possible (gh-3504)
    // Support: iOS 10.0-10.2 only
    // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
    // leading to errors. We need to check for `getRootNode`.
    if (documentElement.getRootNode) isAttached = function isAttached(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    };
    var isHiddenWithinTree = function isHiddenWithinTree(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
        // Support: Firefox <=43 - 45
        // Disconnected elements can have computed display: none, so first confirm that elem is
        // in the document.
        isAttached(elem) && jQuery.css(elem, "display") === "none";
    };
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function currentValue() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, _$nodeName = elem.nodeName, display = defaultDisplayMap[_$nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(_$nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[_$nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function show() {
            return showHide(this, true);
        },
        hide: function hide() {
            return showHide(this);
        },
        toggle: function toggle(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
        var fragment = document.createDocumentFragment(), div = fragment.appendChild(document.createElement("div")), input = document.createElement("input");
        // Support: Android 4.0 - 4.3 only
        // Check state lost if the name is set (trac-11217)
        // Support: Windows Web Apps (WWA)
        // `name` and `type` must use .setAttribute for WWA (trac-14901)
        input.setAttribute("type", "radio");
        input.setAttribute("checked", "checked");
        input.setAttribute("name", "t");
        div.appendChild(input);
        // Support: Android <=4.1 only
        // Older WebKit doesn't clone checked state correctly in fragments
        support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
        // Support: IE <=11 only
        // Make sure textarea (and checkbox) defaultValue is properly cloned
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
        // Support: IE <=9 only
        // IE <=9 replaces <option> tags with their contents when inserted outside of
        // the select element.
        div.innerHTML = "<option></option>";
        support.option = !!div.lastChild;
    })();
    // We have to close these tags to support XHTML (trac-13200)
    var wrapMap = {
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do. So we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            1,
            "<table>",
            "</table>"
        ],
        col: [
            2,
            "<table><colgroup>",
            "</colgroup></table>"
        ],
        tr: [
            2,
            "<table><tbody>",
            "</tbody></table>"
        ],
        td: [
            3,
            "<table><tbody><tr>",
            "</tr></tbody></table>"
        ],
        _default: [
            0,
            "",
            ""
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    // Support: IE <=9 only
    if (!support.option) wrapMap.optgroup = wrapMap.option = [
        1,
        "<select multiple='multiple'>",
        "</select>"
    ];
    function getAll(context, tag) {
        // Support: IE <=9 - 11 only
        // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") ret = context.getElementsByTagName(tag || "*");
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object") // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || wrapMap._default;
                    tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                    // Descend through wrappers to the right content
                    j = wrap[0];
                    while(j--)tmp = tmp.lastChild;
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (trac-12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if ((typeof types === "undefined" ? "undefined" : (0, _typeOf._)(types)) === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function fn(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        global: {},
        add: function add(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function eventHandle(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
            }
        },
        // Detach an event or set of events from an element
        remove: function remove(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function dispatch(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function handlers(event, _handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = _handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: IE <=9
            // Black-hole SVG <use> instance trees (trac-13180)
            cur.nodeType && // Support: Firefox <=42
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11 only
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (trac-13208)
                // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = _handlers[i];
                        // Don't conflict with Object.prototype properties (trac-13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < _handlers.length) handlerQueue.push({
                elem: cur,
                handlers: _handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function addProp(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: isFunction(hook) ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function set(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function fix(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function setup(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", true);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function trigger(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function _default(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function postDispatch(event) {
                    // Support: Firefox 20+
                    // Firefox doesn't alert if the returnValue field is not set.
                    if (event.result !== undefined && event.originalEvent) event.originalEvent.returnValue = event.result;
                }
            }
        }
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, isSetup) {
        // Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
        if (!isSetup) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function handler(event) {
                var result, saved = dataPriv.get(this, type);
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    if (!saved) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object), so this array
                        // will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        this[type]();
                        result = dataPriv.get(this, type);
                        dataPriv.set(this, type, false);
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            return result;
                        }
                    // If this is an inner synthetic event for an event with a bubbling surrogate
                    // (focus or blur), assume that the surrogate already propagated from triggering
                    // the native event and prevent that from happening again here.
                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                    // less bad than duplication.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order
                // Fire an inner synthetic event with the original arguments
                } else if (saved) {
                    // ...and capture the result
                    dataPriv.set(this, type, jQuery.event.trigger(saved[0], saved.slice(1), this));
                    // Abort handling of the native event by all jQuery handlers while allowing
                    // native handlers on the same element to run. On target, this is achieved
                    // by stopping immediate propagation just on the jQuery event. However,
                    // the native event is re-wrapped by a jQuery one on each level of the
                    // propagation so the only way to stop it for jQuery is to stop it for
                    // everyone via native `stopPropagation()`. This is not a problem for
                    // focus/blur which don't bubble, but it does also stop click on checkboxes
                    // and radios. We accept this limitation.
                    event.stopPropagation();
                    event.isImmediatePropagationStopped = returnTrue;
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: Android <=2.3 only
            src.returnValue === false ? returnTrue : returnFalse;
            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (trac-504, trac-13143)
            this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function preventDefault() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function stopPropagation() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function stopImmediatePropagation() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        char: true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        function focusMappedHandler(nativeEvent) {
            if (document.documentMode) {
                // Support: IE 11+
                // Attach a single focusin/focusout handler on the document while someone wants
                // focus/blur. This is because the former are synchronous in IE while the latter
                // are async. In other browsers, all those handlers are invoked synchronously.
                // `handle` from private data would already wrap the event, but we need
                // to change the `type` here.
                var handle = dataPriv.get(this, "handle"), event = jQuery.event.fix(nativeEvent);
                event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
                event.isSimulated = true;
                // First, handle focusin/focusout
                handle(nativeEvent);
                // ...then, handle focus/blur
                //
                // focus/blur don't bubble while focusin/focusout do; simulate the former by only
                // invoking the handler at the lower level.
                if (event.target === event.currentTarget) // The setup part calls `leverageNative`, which, in turn, calls
                // `jQuery.event.add`, so event handle will already have been set
                // by this point.
                handle(event);
            } else // For non-IE browsers, attach a single capturing handler on the document
            // while someone wants focusin/focusout.
            jQuery.event.simulate(delegateType, nativeEvent.target, jQuery.event.fix(nativeEvent));
        }
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function setup() {
                var attaches;
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, true);
                if (document.documentMode) {
                    // Support: IE 9 - 11+
                    // We use the same native handler for focusin & focus (and focusout & blur)
                    // so we need to coordinate setup & teardown parts between those events.
                    // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                    attaches = dataPriv.get(this, delegateType);
                    if (!attaches) this.addEventListener(delegateType, focusMappedHandler);
                    dataPriv.set(this, delegateType, (attaches || 0) + 1);
                } else // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function trigger() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            teardown: function teardown() {
                var attaches;
                if (document.documentMode) {
                    attaches = dataPriv.get(this, delegateType) - 1;
                    if (!attaches) {
                        this.removeEventListener(delegateType, focusMappedHandler);
                        dataPriv.remove(this, delegateType);
                    } else dataPriv.set(this, delegateType, attaches);
                } else // Return false to indicate standard teardown should be applied
                return false;
            },
            // Suppress native focus or blur if we're currently inside
            // a leveraged native-event stack
            _default: function _default(event) {
                return dataPriv.get(event.target, type);
            },
            delegateType: delegateType
        };
        // Support: Firefox <=44
        // Firefox doesn't have focus(in | out) events
        // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
        //
        // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
        // focus(in | out) events fire after focus & blur events,
        // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
        // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
        //
        // Support: IE 9 - 11+
        // To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
        // attach a single handler for both events in IE.
        jQuery.event.special[delegateType] = {
            setup: function setup() {
                // Handle: regular nodes (via `this.ownerDocument`), window
                // (via `this.document`) & document (via `this`).
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType);
                // Support: IE 9 - 11+
                // We use the same native handler for focusin & focus (and focusout & blur)
                // so we need to coordinate setup & teardown parts between those events.
                // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                if (!attaches) {
                    if (document.documentMode) this.addEventListener(delegateType, focusMappedHandler);
                    else doc.addEventListener(type, focusMappedHandler, true);
                }
                dataPriv.set(dataHolder, delegateType, (attaches || 0) + 1);
            },
            teardown: function teardown() {
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType) - 1;
                if (!attaches) {
                    if (document.documentMode) this.removeEventListener(delegateType, focusMappedHandler);
                    else doc.removeEventListener(type, focusMappedHandler, true);
                    dataPriv.remove(dataHolder, delegateType);
                } else dataPriv.set(dataHolder, delegateType, attaches);
            }
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    //
    // Support: Safari 7 only
    // Safari sends mouseenter too often; see:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
    // for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function handle(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function on1(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function one(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function off(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if ((typeof types === "undefined" ? "undefined" : (0, _typeOf._)(types)) === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11, Edge 12 - 13 only
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i, // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var i, l, type, pdataOld, udataOld, udataCur, events;
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.get(src);
            events = pdataOld.events;
            if (events) {
                dataPriv.remove(dest, "handle events");
                for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
            }
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src);
            udataCur = jQuery.extend({}, udataOld);
            dataUser.set(dest, udataCur);
        }
    }
    // Fix IE bugs, see support tests
    function fixInput(src, dest) {
        var _$nodeName = dest.nodeName.toLowerCase();
        // Fails to persist the checked state of a cloned checkbox or radio button.
        if (_$nodeName === "input" && rcheckableType.test(src.type)) dest.checked = src.checked;
        else if (_$nodeName === "input" || _$nodeName === "textarea") dest.defaultValue = src.defaultValue;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
        // We can't cloneNode fragments that contain checked, in WebKit
        if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) return collection.each(function(index) {
            var self = collection.eq(index);
            if (valueIsFunction) args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (trac-8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) // Support: Android <=4.0 only, PhantomJS 1 only
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Re-enable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce || node.getAttribute("nonce")
                                }, doc);
                            } else // Unwrap a CDATA section containing script contents. This shouldn't be
                            // needed as in XML documents they're already not visible when
                            // inspecting element contents and in HTML documents they have no
                            // meaning but we're preserving that logic for backwards compatibility.
                            // This will be removed completely in 4.0. See gh-4904.
                            DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function htmlPrefilter(html) {
            return html;
        },
        clone: function clone(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew jQuery#find here for performance reasons:
                // https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)fixInput(srcElements[i], destElements[i]);
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function cleanData(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function detach(selector) {
            return remove(this, selector, true);
        },
        remove: function remove1(selector) {
            return remove(this, selector);
        },
        text: function text(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function append() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function prepend() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function before() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function after() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function empty() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function clone(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function html(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function replaceWith() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply(ret, elems.get());
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    var getStyles = function getStyles(elem) {
        // Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) view = window1;
        return view.getComputedStyle(elem);
    };
    var swap = function swap(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    };
    var rboxStyle = new RegExp(cssExpand.join("|"), "i");
    (function() {
        // Executing both pixelPosition & boxSizingReliable tests require only one layout
        // so they're executed at the same time to save the second computation.
        function computeStyleTests() {
            // This is a singleton, we need to execute it only once
            if (!div) return;
            container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
            div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
            documentElement.appendChild(container).appendChild(div);
            var divStyle = window1.getComputedStyle(div);
            pixelPositionVal = divStyle.top !== "1%";
            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
            // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
            // Some styles come back with percentage values, even though they shouldn't
            div.style.right = "60%";
            pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
            // Support: IE 9 - 11 only
            // Detect misreporting of content dimensions for box-sizing:border-box elements
            boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
            // Support: IE 9 only
            // Detect overflow:scroll screwiness (gh-3699)
            // Support: Chrome <=64
            // Don't get tricked when zoom affects offsetWidth (gh-4029)
            div.style.position = "absolute";
            scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
            documentElement.removeChild(container);
            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null;
        }
        function roundPixelMeasures(measure) {
            return Math.round(parseFloat(measure));
        }
        var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
        // Finish early in limited (non-browser) environments
        if (!div.style) return;
        // Support: IE <=9 - 11 only
        // Style of cloned element affects source element cloned (trac-8908)
        div.style.backgroundClip = "content-box";
        div.cloneNode(true).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";
        jQuery.extend(support, {
            boxSizingReliable: function boxSizingReliable() {
                computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelBoxStyles: function pixelBoxStyles() {
                computeStyleTests();
                return pixelBoxStylesVal;
            },
            pixelPosition: function pixelPosition() {
                computeStyleTests();
                return pixelPositionVal;
            },
            reliableMarginLeft: function reliableMarginLeft() {
                computeStyleTests();
                return reliableMarginLeftVal;
            },
            scrollboxSize: function scrollboxSize() {
                computeStyleTests();
                return scrollboxSizeVal;
            },
            // Support: IE 9 - 11+, Edge 15 - 18+
            // IE/Edge misreport `getComputedStyle` of table rows with width/height
            // set in CSS while `offset*` properties report correct values.
            // Behavior in IE 9 is more subtle than in newer versions & it passes
            // some versions of this test; make sure not to make it pass there!
            //
            // Support: Firefox 70+
            // Only Firefox includes border widths
            // in computed dimensions. (gh-4529)
            reliableTrDimensions: function reliableTrDimensions() {
                var table, tr, trChild, trStyle;
                if (reliableTrDimensionsVal == null) {
                    table = document.createElement("table");
                    tr = document.createElement("tr");
                    trChild = document.createElement("div");
                    table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
                    tr.style.cssText = "box-sizing:content-box;border:1px solid";
                    // Support: Chrome 86+
                    // Height set through cssText does not get applied.
                    // Computed height then comes back as 0.
                    tr.style.height = "1px";
                    trChild.style.height = "9px";
                    // Support: Android 8 Chrome 86+
                    // In our bodyBackground.html iframe,
                    // display for all div elements is set to "inline",
                    // which causes a problem only in Android 8 Chrome 86.
                    // Ensuring the div is `display: block`
                    // gets around this issue.
                    trChild.style.display = "block";
                    documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
                    trStyle = window1.getComputedStyle(tr);
                    reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
                    documentElement.removeChild(table);
                }
                return reliableTrDimensionsVal;
            }
        });
    })();
    function curCSS(elem, name, computed) {
        var width, minWidth, maxWidth, ret, isCustomProp = rcustomProp.test(name), // Support: Firefox 51+
        // Retrieving style before computed somehow
        // fixes an issue with getting wrong values
        // on detached elements
        style = elem.style;
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for:
        //   .css('filter') (IE 9 only, trac-12537)
        //   .css('--customProperty) (gh-3144)
        if (computed) {
            // Support: IE <=9 - 11+
            // IE only supports `"float"` in `getPropertyValue`; in computed styles
            // it's only available as `"cssFloat"`. We no longer modify properties
            // sent to `.css()` apart from camelCasing, so we need to check both.
            // Normally, this would create difference in behavior: if
            // `getPropertyValue` returns an empty string, the value returned
            // by `.css()` would be `undefined`. This is usually the case for
            // disconnected elements. However, in IE even disconnected elements
            // with no styles return `"none"` for `getPropertyValue( "float" )`
            ret = computed.getPropertyValue(name) || computed[name];
            if (isCustomProp && ret) // Support: Firefox 105+, Chrome <=105+
            // Spec requires trimming whitespace for custom properties (gh-4926).
            // Firefox only trims leading whitespace. Chrome just collapses
            // both leading & trailing whitespace to a single space.
            //
            // Fall back to `undefined` if empty string returned.
            // This collapses a missing definition with property defined
            // and set to an empty string but there's no standard API
            // allowing us to differentiate them without a performance penalty
            // and returning `undefined` aligns with older jQuery.
            //
            // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
            // as whitespace while CSS does not, but this is not a problem
            // because CSS preprocessing replaces them with U+000A LINE FEED
            // (which *is* CSS whitespace)
            // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
            ret = ret.replace(rtrimCSS, "$1") || undefined;
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;
                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;
                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
            }
        }
        return ret !== undefined ? // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    function addGetHookIf(conditionFn, hookFn) {
        // Define the hook, we'll check on the first run if it's really needed.
        return {
            get: function get() {
                if (conditionFn()) {
                    // Hook not needed (or it's not possible to use it due
                    // to missing dependency), remove it.
                    delete this.get;
                    return;
                }
                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
            }
        };
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document.createElement("div").style, vendorProps = {};
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
    function finalPropName(name) {
        var _final = jQuery.cssProps[name] || vendorProps[name];
        if (_final) return _final;
        if (name in emptyStyle) return name;
        return vendorProps[name] = vendorPropName(name) || name;
    }
    var // Swappable if display is none or starts with table
    // except "table", "table-cell", or "table-caption"
    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/, cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0, marginDelta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            // Count margin delta separately to only add it after scroll gutter adjustment.
            // This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
            if (box === "margin") marginDelta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta + marginDelta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Support: Firefox <=54
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        // Support: IE 9 - 11 only
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Interestingly, in some cases IE 9 doesn't suffer from this issue.
        !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        val === "auto" || // Support: Android <=4.1 - 4.3 only
        // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
        !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function get(elem, computed) {
                    if (computed) {
                        // We should always get a number back from opacity
                        var ret = curCSS(elem, "opacity");
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },
        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
            animationIterationCount: true,
            aspectRatio: true,
            borderImageSlice: true,
            columnCount: true,
            flexGrow: true,
            flexShrink: true,
            fontWeight: true,
            gridArea: true,
            gridColumn: true,
            gridColumnEnd: true,
            gridColumnStart: true,
            gridRow: true,
            gridRowEnd: true,
            gridRowStart: true,
            lineHeight: true,
            opacity: true,
            order: true,
            orphans: true,
            scale: true,
            widows: true,
            zIndex: true,
            zoom: true,
            // SVG-related
            fillOpacity: true,
            floodOpacity: true,
            stopOpacity: true,
            strokeMiterlimit: true,
            strokeOpacity: true
        },
        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {},
        // Get and set the style property on a DOM Node
        style: function style(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value);
                // Convert "+=" or "-=" to relative numbers (trac-7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug trac-9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (trac-7116)
                if (value == null || value !== value) return;
                // If a number was passed in, add the unit (except for certain CSS properties)
                // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                // "px" to a few hardcoded values.
                if (type === "number" && !isCustomProp) value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                // background-* props affect original clone's values
                if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function css(elem, name, extra, styles) {
            var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function get(elem, computed, extra) {
                if (computed) // Certain elements can have dimension info if we invisibly show them
                // but it must have a current display style that would benefit
                return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
                // Table columns in Safari have non-zero offsetWidth & zero
                // getBoundingClientRect().width unless display is changed.
                // Support: IE <=11 only
                // Running getBoundingClientRect on a disconnected node
                // in IE throws an error.
                (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function set(elem, value, extra) {
                var matches, styles = getStyles(elem), // Only read styles.position if the test has a chance to fail
                // to avoid forcing a reflow.
                scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && scrollboxSizeBuggy) subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
        if (computed) return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
            marginLeft: 0
        }, function() {
            return elem.getBoundingClientRect().left;
        })) + "px";
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function expand(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function css(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    // Based off of the plugin by Clint Helfers, with permission.
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    (function() {
        var input = document.createElement("input"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
        input.type = "checkbox";
        // Support: Android <=4.3 only
        // Default value for a checkbox should be "on"
        support.checkOn = input.value !== "";
        // Support: IE <=11 only
        // Must access selectedIndex to make default options select
        support.optSelected = opt.selected;
        // Support: IE <=11 only
        // An input loses its value after becoming a radio
        input = document.createElement("input");
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
    })();
    var boolHook, attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend({
        attr: function attr(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function removeAttr(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function attr(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
            if (value !== undefined) {
                if (value === null) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value + "");
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = jQuery.find.attr(elem, name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {
            type: {
                set: function set(elem, value) {
                    if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                        var val = elem.value;
                        elem.setAttribute("type", value);
                        if (val) elem.value = val;
                        return value;
                    }
                }
            }
        },
        removeAttr: function removeAttr(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Hooks for boolean attributes
    boolHook = {
        set: function set(elem, value, name) {
            if (value === false) // Remove boolean attributes when set to false
            jQuery.removeAttr(elem, name);
            else elem.setAttribute(name, name);
            return name;
        }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name) {
        var getter = attrHandle[name] || jQuery.find.attr;
        attrHandle[name] = function(elem, name, isXML) {
            var ret, handle, lowercaseName = name.toLowerCase();
            if (!isXML) {
                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[lowercaseName];
                attrHandle[lowercaseName] = ret;
                ret = getter(elem, name, isXML) != null ? lowercaseName : null;
                attrHandle[lowercaseName] = handle;
            }
            return ret;
        };
    });
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function prop(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function removeProp(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function prop(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function get(elem) {
                    // Support: IE <=9 - 11 only
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // Use proper attribute retrieval (trac-12072)
                    var tabindex = jQuery.find.attr(elem, "tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11 only
    // Accessing the selectedIndex property
    // forces the browser to respect setting selected
    // on the option
    // The getter ensures a default option is selected
    // when in an optgroup
    // eslint rule "no-unused-expressions" is disabled for this code
    // since it considers such accessions noop
    if (!support.optSelected) jQuery.propHooks.selected = {
        get: function get(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent && parent.parentNode) parent.parentNode.selectedIndex;
            return null;
        },
        set: function set(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent) {
                parent.selectedIndex;
                if (parent.parentNode) parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function addClass(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        if (cur.indexOf(" " + className + " ") < 0) cur += className + " ";
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        removeClass: function removeClass(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                // This expression is here for better compressibility (see addClass)
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Remove *all* instances
                        while(cur.indexOf(" " + className + " ") > -1)cur = cur.replace(" " + className + " ", " ");
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        toggleClass: function toggleClass(value, stateVal) {
            var classNames, className, i, self, type = typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value), isValidValue = type === "string" || Array.isArray(value);
            if (isFunction(value)) return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            if (typeof stateVal === "boolean" && isValidValue) return stateVal ? this.addClass(value) : this.removeClass(value);
            classNames = classesToArray(value);
            return this.each(function() {
                if (isValidValue) {
                    // Toggle individual class names
                    self = jQuery(this);
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Check each className given, space separated list
                        if (self.hasClass(className)) self.removeClass(className);
                        else self.addClass(className);
                    }
                // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                    className = getClass(this);
                    if (className) // Store className if set
                    dataPriv.set(this, "__className__", className);
                    // If the element has a class name or if we're passed `false`,
                    // then remove the whole classname (if there was one, the above saved it).
                    // Otherwise bring back whatever was previously saved (if anything),
                    // falling back to the empty string if nothing was stored.
                    if (this.setAttribute) this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
                }
            });
        },
        hasClass: function hasClass(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    var rreturn = /\r/g;
    jQuery.fn.extend({
        val: function val(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle most common string cases
                    if (typeof ret === "string") return ret.replace(rreturn, "");
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = isFunction(value);
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            option: {
                get: function get(elem) {
                    var val = jQuery.find.attr(elem, "value");
                    return val != null ? val : // Support: IE <=10 - 11 only
                    // option.text throws exceptions (trac-14686, trac-14858)
                    // Strip and collapse whitespace
                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                    stripAndCollapse(jQuery.text(elem));
                }
            },
            select: {
                get: function get(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        // Support: IE <=9 only
                        // IE8-9 doesn't update selected after form reset (trac-2551)
                        if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function set(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        /* eslint-disable no-cond-assign */ if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) optionSet = true;
                    /* eslint-enable no-cond-assign */ }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function set(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
        if (!support.checkOn) jQuery.valHooks[this].get = function(elem) {
            return elem.getAttribute("value") === null ? "on" : elem.value;
        };
    });
    // Return jQuery for attributes-only inclusion
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11 only
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {}
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
        }).join("\n") : data));
        return xml;
    };
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function stopPropagationCallback(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function trigger(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, (typeof event === "undefined" ? "undefined" : (0, _typeOf._)(event)) === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (trac-9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (trac-6170)
                {
                    if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function simulate(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function trigger(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function triggerHandler(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + ((typeof v === "undefined" ? "undefined" : (0, _typeOf._)(v)) === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function add(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function serialize() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function serializeArray() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    jQuery.fn.extend({
        wrapAll: function wrapAll(html) {
            var wrap;
            if (this[0]) {
                if (isFunction(html)) html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function wrapInner(html) {
            if (isFunction(html)) return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function wrap(html) {
            var htmlIsFunction = isFunction(html);
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function unwrap(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    // Support: Safari 8 only
    // In Safari 8 documents created via document.implementation.createHTMLDocument
    // collapse sibling forms: the second one becomes a child of the first one.
    // Because of that, this security measure has to be disabled in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137337
    support.createHTMLDocument = function() {
        var body = document.implementation.createHTMLDocument("").body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
    }();
    // Argument "data" should be string of html
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string") return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var base, parsed, scripts;
        if (!context) {
            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");
                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
            } else context = document;
        }
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    jQuery.offset = {
        setOffset: function setOffset(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (isFunction(options)) // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function offset(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function position() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.parentNode;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function offsetParent() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Support: Safari <=7 - 9.1, Chrome <=37 - 49
    // Add the top/left cssHooks using jQuery.fn.position
    // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
    // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
    // getComputedStyle returns percent when specified for top/left/bottom/right;
    // rather than make the css module depend on the offset module, just check for it here
    jQuery.each([
        "top",
        "left"
    ], function(_i, prop) {
        jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
            if (computed) {
                computed = curCSS(elem, prop);
                // If curCSS returns percentage, fallback to offset
                return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
            }
        });
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.fn.extend({
        bind: function bind(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function unbind(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function delegate(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function undelegate(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function hover(fnOver, fnOut) {
            return this.on("mouseenter", fnOver).on("mouseleave", fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Support: Android <=4.0 only
    // Make sure we trim BOM and NBSP
    // Require that the "whitespace run" starts from a non-whitespace
    // to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
    var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (!isFunction(fn)) return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function proxy() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;
    jQuery.now = Date.now;
    jQuery.isNumeric = function(obj) {
        // As of jQuery 3.0, isNumeric is limited to
        // strings and numbers (primitives or objects)
        // that can be coerced to finite numbers (gh-2662)
        var type = jQuery.type(obj);
        return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        !isNaN(obj - parseFloat(obj));
    };
    jQuery.trim = function(text) {
        return text == null ? "" : (text + "").replace(rtrim, "$1");
    };
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
    // and CommonJS for browser emulators (trac-13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
});

},{"@swc/helpers/_/_type_of":"lkAFj"}],"lkAFj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _type_of;
});
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"2qAMd"}],"2qAMd":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        "default": a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function get() {
                return source[key];
            }
        });
    });
    return dest;
};
exports["export"] = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"1iBFx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "version", function() {
    return 0, _govukFrontendVersionMjs.version;
});
parcelHelpers.export(exports, "Accordion", function() {
    return 0, _accordionMjs.Accordion;
});
parcelHelpers.export(exports, "Button", function() {
    return 0, _buttonMjs.Button;
});
parcelHelpers.export(exports, "CharacterCount", function() {
    return 0, _characterCountMjs.CharacterCount;
});
parcelHelpers.export(exports, "Checkboxes", function() {
    return 0, _checkboxesMjs.Checkboxes;
});
parcelHelpers.export(exports, "ErrorSummary", function() {
    return 0, _errorSummaryMjs.ErrorSummary;
});
parcelHelpers.export(exports, "ExitThisPage", function() {
    return 0, _exitThisPageMjs.ExitThisPage;
});
parcelHelpers.export(exports, "FileUpload", function() {
    return 0, _fileUploadMjs.FileUpload;
});
parcelHelpers.export(exports, "Header", function() {
    return 0, _headerMjs.Header;
});
parcelHelpers.export(exports, "NotificationBanner", function() {
    return 0, _notificationBannerMjs.NotificationBanner;
});
parcelHelpers.export(exports, "PasswordInput", function() {
    return 0, _passwordInputMjs.PasswordInput;
});
parcelHelpers.export(exports, "Radios", function() {
    return 0, _radiosMjs.Radios;
});
parcelHelpers.export(exports, "ServiceNavigation", function() {
    return 0, _serviceNavigationMjs.ServiceNavigation;
});
parcelHelpers.export(exports, "SkipLink", function() {
    return 0, _skipLinkMjs.SkipLink;
});
parcelHelpers.export(exports, "Tabs", function() {
    return 0, _tabsMjs.Tabs;
});
parcelHelpers.export(exports, "createAll", function() {
    return 0, _initMjs.createAll;
});
parcelHelpers.export(exports, "initAll", function() {
    return 0, _initMjs.initAll;
});
parcelHelpers.export(exports, "isSupported", function() {
    return 0, _indexMjs.isSupported;
});
parcelHelpers.export(exports, "Component", function() {
    return 0, _componentMjs.Component;
});
parcelHelpers.export(exports, "ConfigurableComponent", function() {
    return 0, _configurationMjs.ConfigurableComponent;
});
var _govukFrontendVersionMjs = require("./common/govuk-frontend-version.mjs");
var _accordionMjs = require("./components/accordion/accordion.mjs");
var _buttonMjs = require("./components/button/button.mjs");
var _characterCountMjs = require("./components/character-count/character-count.mjs");
var _checkboxesMjs = require("./components/checkboxes/checkboxes.mjs");
var _errorSummaryMjs = require("./components/error-summary/error-summary.mjs");
var _exitThisPageMjs = require("./components/exit-this-page/exit-this-page.mjs");
var _fileUploadMjs = require("./components/file-upload/file-upload.mjs");
var _headerMjs = require("./components/header/header.mjs");
var _notificationBannerMjs = require("./components/notification-banner/notification-banner.mjs");
var _passwordInputMjs = require("./components/password-input/password-input.mjs");
var _radiosMjs = require("./components/radios/radios.mjs");
var _serviceNavigationMjs = require("./components/service-navigation/service-navigation.mjs");
var _skipLinkMjs = require("./components/skip-link/skip-link.mjs");
var _tabsMjs = require("./components/tabs/tabs.mjs");
var _initMjs = require("./init.mjs");
var _indexMjs = require("./common/index.mjs");
var _componentMjs = require("./component.mjs");
var _configurationMjs = require("./common/configuration.mjs");

},{"./common/govuk-frontend-version.mjs":"dAONB","./components/accordion/accordion.mjs":"6HrGR","./components/button/button.mjs":"ic7uQ","./components/character-count/character-count.mjs":"1Bfd0","./components/checkboxes/checkboxes.mjs":"kvvKs","./components/error-summary/error-summary.mjs":"gJljr","./components/exit-this-page/exit-this-page.mjs":"b4dHw","./components/file-upload/file-upload.mjs":"aBOo0","./components/header/header.mjs":"hvSmM","./components/notification-banner/notification-banner.mjs":"8sb1f","./components/password-input/password-input.mjs":"5Yenz","./components/radios/radios.mjs":"gWpiP","./components/service-navigation/service-navigation.mjs":"7jdp8","./components/skip-link/skip-link.mjs":"kDOrc","./components/tabs/tabs.mjs":"3PGhh","./init.mjs":"9fVIs","./common/index.mjs":"hMIZ0","./component.mjs":"VCgbS","./common/configuration.mjs":"iQR6u","@parcel/transformer-js/src/esmodule-helpers.js":"2qAMd"}],"dAONB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "version", function() {
    return version;
});
var version = '5.14.0';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"2qAMd"}],"6HrGR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Accordion", function() {
    return Accordion;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _configurationMjs = require("../../common/configuration.mjs");
var _indexMjs = require("../../errors/index.mjs");
var _i18NMjs = require("../../i18n.mjs");
/**
 * Accordion component
 *
 * This allows a collection of sections to be collapsed by default, showing only
 * their headers. Sections can be expanded or collapsed individually by clicking
 * their headers. A "Show all sections" button is also added to the top of the
 * accordion, which switches to "Hide all sections" when all the sections are
 * expanded.
 *
 * The state of each section is saved to the DOM via the `aria-expanded`
 * attribute, which also provides accessibility.
 *
 * @preserve
 * @augments ConfigurableComponent<AccordionConfig>
 */ var Accordion = /*#__PURE__*/ function(ConfigurableComponent) {
    "use strict";
    (0, _inherits._)(Accordion, ConfigurableComponent);
    function Accordion($root) {
        var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, _classCallCheck._)(this, Accordion);
        var _this;
        _this = (0, _callSuper._)(this, Accordion, [
            $root,
            config
        ]);
        _this.i18n = void 0;
        _this.controlsClass = 'govuk-accordion__controls';
        _this.showAllClass = 'govuk-accordion__show-all';
        _this.showAllTextClass = 'govuk-accordion__show-all-text';
        _this.sectionClass = 'govuk-accordion__section';
        _this.sectionExpandedClass = 'govuk-accordion__section--expanded';
        _this.sectionButtonClass = 'govuk-accordion__section-button';
        _this.sectionHeaderClass = 'govuk-accordion__section-header';
        _this.sectionHeadingClass = 'govuk-accordion__section-heading';
        _this.sectionHeadingDividerClass = 'govuk-accordion__section-heading-divider';
        _this.sectionHeadingTextClass = 'govuk-accordion__section-heading-text';
        _this.sectionHeadingTextFocusClass = 'govuk-accordion__section-heading-text-focus';
        _this.sectionShowHideToggleClass = 'govuk-accordion__section-toggle';
        _this.sectionShowHideToggleFocusClass = 'govuk-accordion__section-toggle-focus';
        _this.sectionShowHideTextClass = 'govuk-accordion__section-toggle-text';
        _this.upChevronIconClass = 'govuk-accordion-nav__chevron';
        _this.downChevronIconClass = 'govuk-accordion-nav__chevron--down';
        _this.sectionSummaryClass = 'govuk-accordion__section-summary';
        _this.sectionSummaryFocusClass = 'govuk-accordion__section-summary-focus';
        _this.sectionContentClass = 'govuk-accordion__section-content';
        _this.$sections = void 0;
        _this.$showAllButton = null;
        _this.$showAllIcon = null;
        _this.$showAllText = null;
        _this.i18n = new (0, _i18NMjs.I18n)(_this.config.i18n);
        var $sections = _this.$root.querySelectorAll(".".concat(_this.sectionClass));
        if (!$sections.length) throw new (0, _indexMjs.ElementError)({
            component: Accordion,
            identifier: 'Sections (`<div class="'.concat(_this.sectionClass, '">`)')
        });
        _this.$sections = $sections;
        _this.initControls();
        _this.initSectionHeaders();
        _this.updateShowAllButton(_this.areAllSectionsOpen());
        return _this;
    }
    (0, _createClass._)(Accordion, [
        {
            key: "initControls",
            value: function initControls() {
                var _this = this;
                this.$showAllButton = document.createElement('button');
                this.$showAllButton.setAttribute('type', 'button');
                this.$showAllButton.setAttribute('class', this.showAllClass);
                this.$showAllButton.setAttribute('aria-expanded', 'false');
                this.$showAllIcon = document.createElement('span');
                this.$showAllIcon.classList.add(this.upChevronIconClass);
                this.$showAllButton.appendChild(this.$showAllIcon);
                var $accordionControls = document.createElement('div');
                $accordionControls.setAttribute('class', this.controlsClass);
                $accordionControls.appendChild(this.$showAllButton);
                this.$root.insertBefore($accordionControls, this.$root.firstChild);
                this.$showAllText = document.createElement('span');
                this.$showAllText.classList.add(this.showAllTextClass);
                this.$showAllButton.appendChild(this.$showAllText);
                this.$showAllButton.addEventListener('click', function() {
                    return _this.onShowOrHideAllToggle();
                });
                if ('onbeforematch' in document) document.addEventListener('beforematch', function(event) {
                    return _this.onBeforeMatch(event);
                });
            }
        },
        {
            key: "initSectionHeaders",
            value: function initSectionHeaders() {
                var _this = this;
                this.$sections.forEach(function($section, i) {
                    var $header = $section.querySelector(".".concat(_this.sectionHeaderClass));
                    if (!$header) throw new (0, _indexMjs.ElementError)({
                        component: Accordion,
                        identifier: 'Section headers (`<div class="'.concat(_this.sectionHeaderClass, '">`)')
                    });
                    _this.constructHeaderMarkup($header, i);
                    _this.setExpanded(_this.isExpanded($section), $section);
                    $header.addEventListener('click', function() {
                        return _this.onSectionToggle($section);
                    });
                    _this.setInitialState($section);
                });
            }
        },
        {
            key: "constructHeaderMarkup",
            value: function constructHeaderMarkup($header, index) {
                var $span = $header.querySelector(".".concat(this.sectionButtonClass));
                var $heading = $header.querySelector(".".concat(this.sectionHeadingClass));
                var $summary = $header.querySelector(".".concat(this.sectionSummaryClass));
                if (!$heading) throw new (0, _indexMjs.ElementError)({
                    component: Accordion,
                    identifier: "Section heading (`.".concat(this.sectionHeadingClass, "`)")
                });
                if (!$span) throw new (0, _indexMjs.ElementError)({
                    component: Accordion,
                    identifier: 'Section button placeholder (`<span class="'.concat(this.sectionButtonClass, '">`)')
                });
                var $button = document.createElement('button');
                $button.setAttribute('type', 'button');
                $button.setAttribute('aria-controls', "".concat(this.$root.id, "-content-").concat(index + 1));
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Array.from($span.attributes)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var attr = _step.value;
                        if (attr.name !== 'id') $button.setAttribute(attr.name, attr.value);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var $headingText = document.createElement('span');
                $headingText.classList.add(this.sectionHeadingTextClass);
                $headingText.id = $span.id;
                var $headingTextFocus = document.createElement('span');
                $headingTextFocus.classList.add(this.sectionHeadingTextFocusClass);
                $headingText.appendChild($headingTextFocus);
                Array.from($span.childNodes).forEach(function($child) {
                    return $headingTextFocus.appendChild($child);
                });
                var $showHideToggle = document.createElement('span');
                $showHideToggle.classList.add(this.sectionShowHideToggleClass);
                $showHideToggle.setAttribute('data-nosnippet', '');
                var $showHideToggleFocus = document.createElement('span');
                $showHideToggleFocus.classList.add(this.sectionShowHideToggleFocusClass);
                $showHideToggle.appendChild($showHideToggleFocus);
                var $showHideText = document.createElement('span');
                var $showHideIcon = document.createElement('span');
                $showHideIcon.classList.add(this.upChevronIconClass);
                $showHideToggleFocus.appendChild($showHideIcon);
                $showHideText.classList.add(this.sectionShowHideTextClass);
                $showHideToggleFocus.appendChild($showHideText);
                $button.appendChild($headingText);
                $button.appendChild(this.getButtonPunctuationEl());
                if ($summary) {
                    var $summarySpan = document.createElement('span');
                    var $summarySpanFocus = document.createElement('span');
                    $summarySpanFocus.classList.add(this.sectionSummaryFocusClass);
                    $summarySpan.appendChild($summarySpanFocus);
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = Array.from($summary.attributes)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var attr1 = _step1.value;
                            $summarySpan.setAttribute(attr1.name, attr1.value);
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                _iterator1["return"]();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                    Array.from($summary.childNodes).forEach(function($child) {
                        return $summarySpanFocus.appendChild($child);
                    });
                    $summary.remove();
                    $button.appendChild($summarySpan);
                    $button.appendChild(this.getButtonPunctuationEl());
                }
                $button.appendChild($showHideToggle);
                $heading.removeChild($span);
                $heading.appendChild($button);
            }
        },
        {
            key: "onBeforeMatch",
            value: function onBeforeMatch(event) {
                var $fragment = event.target;
                if (!($fragment instanceof Element)) return;
                var $section = $fragment.closest(".".concat(this.sectionClass));
                if ($section) this.setExpanded(true, $section);
            }
        },
        {
            key: "onSectionToggle",
            value: function onSectionToggle($section) {
                var nowExpanded = !this.isExpanded($section);
                this.setExpanded(nowExpanded, $section);
                this.storeState($section, nowExpanded);
            }
        },
        {
            key: "onShowOrHideAllToggle",
            value: function onShowOrHideAllToggle() {
                var _this = this;
                var nowExpanded = !this.areAllSectionsOpen();
                this.$sections.forEach(function($section) {
                    _this.setExpanded(nowExpanded, $section);
                    _this.storeState($section, nowExpanded);
                });
                this.updateShowAllButton(nowExpanded);
            }
        },
        {
            key: "setExpanded",
            value: function setExpanded(expanded, $section) {
                var $showHideIcon = $section.querySelector(".".concat(this.upChevronIconClass));
                var $showHideText = $section.querySelector(".".concat(this.sectionShowHideTextClass));
                var $button = $section.querySelector(".".concat(this.sectionButtonClass));
                var $content = $section.querySelector(".".concat(this.sectionContentClass));
                if (!$content) throw new (0, _indexMjs.ElementError)({
                    component: Accordion,
                    identifier: 'Section content (`<div class="'.concat(this.sectionContentClass, '">`)')
                });
                if (!$showHideIcon || !$showHideText || !$button) return;
                var newButtonText = expanded ? this.i18n.t('hideSection') : this.i18n.t('showSection');
                $showHideText.textContent = newButtonText;
                $button.setAttribute('aria-expanded', "".concat(expanded));
                var ariaLabelParts = [];
                var $headingText = $section.querySelector(".".concat(this.sectionHeadingTextClass));
                if ($headingText) ariaLabelParts.push($headingText.textContent.trim());
                var $summary = $section.querySelector(".".concat(this.sectionSummaryClass));
                if ($summary) ariaLabelParts.push($summary.textContent.trim());
                var ariaLabelMessage = expanded ? this.i18n.t('hideSectionAriaLabel') : this.i18n.t('showSectionAriaLabel');
                ariaLabelParts.push(ariaLabelMessage);
                $button.setAttribute('aria-label', ariaLabelParts.join(' , '));
                if (expanded) {
                    $content.removeAttribute('hidden');
                    $section.classList.add(this.sectionExpandedClass);
                    $showHideIcon.classList.remove(this.downChevronIconClass);
                } else {
                    $content.setAttribute('hidden', 'until-found');
                    $section.classList.remove(this.sectionExpandedClass);
                    $showHideIcon.classList.add(this.downChevronIconClass);
                }
                this.updateShowAllButton(this.areAllSectionsOpen());
            }
        },
        {
            key: "isExpanded",
            value: function isExpanded($section) {
                return $section.classList.contains(this.sectionExpandedClass);
            }
        },
        {
            key: "areAllSectionsOpen",
            value: function areAllSectionsOpen() {
                var _this = this;
                return Array.from(this.$sections).every(function($section) {
                    return _this.isExpanded($section);
                });
            }
        },
        {
            key: "updateShowAllButton",
            value: function updateShowAllButton(expanded) {
                if (!this.$showAllButton || !this.$showAllText || !this.$showAllIcon) return;
                this.$showAllButton.setAttribute('aria-expanded', expanded.toString());
                this.$showAllText.textContent = expanded ? this.i18n.t('hideAllSections') : this.i18n.t('showAllSections');
                this.$showAllIcon.classList.toggle(this.downChevronIconClass, !expanded);
            }
        },
        {
            /**
   * Get the identifier for a section
   *
   * We need a unique way of identifying each content in the Accordion.
   * Since an `#id` should be unique and an `id` is required for `aria-`
   * attributes `id` can be safely used.
   *
   * @param {Element} $section - Section element
   * @returns {string | undefined | null} Identifier for section
   */ key: "getIdentifier",
            value: function getIdentifier($section) {
                var $button = $section.querySelector(".".concat(this.sectionButtonClass));
                return $button == null ? void 0 : $button.getAttribute('aria-controls');
            }
        },
        {
            key: "storeState",
            value: function storeState($section, isExpanded) {
                if (!this.config.rememberExpanded) return;
                var id = this.getIdentifier($section);
                if (id) try {
                    window.sessionStorage.setItem(id, isExpanded.toString());
                } catch (_unused) {}
            }
        },
        {
            key: "setInitialState",
            value: function setInitialState($section) {
                if (!this.config.rememberExpanded) return;
                var id = this.getIdentifier($section);
                if (id) try {
                    var state = window.sessionStorage.getItem(id);
                    if (state !== null) this.setExpanded(state === 'true', $section);
                } catch (_unused2) {}
            }
        },
        {
            key: "getButtonPunctuationEl",
            value: function getButtonPunctuationEl() {
                var $punctuationEl = document.createElement('span');
                $punctuationEl.classList.add('govuk-visually-hidden', this.sectionHeadingDividerClass);
                $punctuationEl.textContent = ', ';
                return $punctuationEl;
            }
        }
    ]);
    return Accordion;
}((0, _configurationMjs.ConfigurableComponent));
/**
 * Accordion config
 *
 * @see {@link Accordion.defaults}
 * @typedef {object} AccordionConfig
 * @property {AccordionTranslations} [i18n=Accordion.defaults.i18n] - Accordion translations
 * @property {boolean} [rememberExpanded] - Whether the expanded and collapsed
 *   state of each section is remembered and restored when navigating.
 */ /**
 * Accordion translations
 *
 * @see {@link Accordion.defaults.i18n}
 * @typedef {object} AccordionTranslations
 *
 * Messages used by the component for the labels of its buttons. This includes
 * the visible text shown on screen, and text to help assistive technology users
 * for the buttons toggling each section.
 * @property {string} [hideAllSections] - The text content for the 'Hide all
 *   sections' button, used when at least one section is expanded.
 * @property {string} [hideSection] - The text content for the 'Hide'
 *   button, used when a section is expanded.
 * @property {string} [hideSectionAriaLabel] - The text content appended to the
 *   'Hide' button's accessible name when a section is expanded.
 * @property {string} [showAllSections] - The text content for the 'Show all
 *   sections' button, used when all sections are collapsed.
 * @property {string} [showSection] - The text content for the 'Show'
 *   button, used when a section is collapsed.
 * @property {string} [showSectionAriaLabel] - The text content appended to the
 *   'Show' button's accessible name when a section is expanded.
 */ /**
 * @import { Schema } from '../../common/configuration.mjs'
 */ Accordion.moduleName = 'govuk-accordion';
Accordion.defaults = Object.freeze({
    i18n: {
        hideAllSections: 'Hide all sections',
        hideSection: 'Hide',
        hideSectionAriaLabel: 'Hide this section',
        showAllSections: 'Show all sections',
        showSection: 'Show',
        showSectionAriaLabel: 'Show this section'
    },
    rememberExpanded: true
});
Accordion.schema = Object.freeze({
    properties: {
        i18n: {
            type: 'object'
        },
        rememberExpanded: {
            type: 'boolean'
        }
    }
});

},{"@swc/helpers/_/_call_super":"jbaHU","@swc/helpers/_/_class_call_check":"gDZPt","@swc/helpers/_/_create_class":"7MByf","@swc/helpers/_/_inherits":"lXwSH","../../common/configuration.mjs":"iQR6u","../../errors/index.mjs":"fYWJ8","../../i18n.mjs":"y8yul","@parcel/transformer-js/src/esmodule-helpers.js":"2qAMd"}],"jbaHU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _call_super;
});
var _getPrototypeOfJs = require("./_get_prototype_of.js");
var _isNativeReflectConstructJs = require("./_is_native_reflect_construct.js");
var _possibleConstructorReturnJs = require("./_possible_constructor_return.js");
function _call_super(_this, derived, args) {
    // Super
    derived = (0, _getPrototypeOfJs._)(derived);
    return (0, _possibleConstructorReturnJs._)(_this, (0, _isNativeReflectConstructJs._)() ? Reflect.construct(derived, args || [], (0, _getPrototypeOfJs._)(_this).constructor) : derived.apply(_this, args));
}

},{"./_get_prototype_of.js":"YIEPg","./_is_native_reflect_construct.js":"iibYu","./_possible_constructor_return.js":"labyA","@parcel/transformer-js/src/esmodule-helpers.js":"2qAMd"}],"YIEPg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _get_prototype_of;
});
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"2qAMd"}],"iibYu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _is_native_reflect_construct;
});
function _is_native_reflect_construct() {
    // Since Reflect.construct can't be properly polyfilled, some
    // implementations (e.g. core-js@2) don't set the correct internal slots.
    // Those polyfills don't allow us to subclass built-ins, so we need to
    // use our fallback implementation.
    try {
        // If the internal slots aren't set, this throws an error similar to
        //   TypeError: this is not a Boolean object.
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"2qAMd"}],"labyA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _possible_constructor_return;
});
var _assertThisInitializedJs = require("./_assert_this_initialized.js");
var _typeOfJs = require("./_type_of.js");
function _possible_constructor_return(self, call) {
    if (call && ((0, _typeOfJs._)(call) === "object" || typeof call === "function")) return call;
    return (0, _assertThisInitializedJs._)(self);
}

},{"./_assert_this_initialized.js":"jObIj","./_type_of.js":"lkAFj","@parcel/transformer-js/src/esmodule-helpers.js":"2qAMd"}],"jObIj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _assert_this_initialized;
});
function _assert_this_initialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"2qAMd"}],"gDZPt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _class_call_check;
});
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"2qAMd"}],"7MByf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _create_class;
});
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"2qAMd"}],"lXwSH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _inherits;
});
var _setPrototypeOfJs = require("./_set_prototype_of.js");
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, _setPrototypeOfJs._)(subClass, superClass);
}

},{"./_set_prototype_of.js":"bVhRy","@parcel/transformer-js/src/esmodule-helpers.js":"2qAMd"}],"bVhRy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _set_prototype_of;
});
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"2qAMd"}],"iQR6u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Schema for component config
 *
 * @template {Partial<Record<keyof ConfigurationType, unknown>>} ConfigurationType
 * @typedef {object} Schema
 * @property {Record<keyof ConfigurationType, SchemaProperty | undefined>} properties - Schema properties
 * @property {SchemaCondition<ConfigurationType>[]} [anyOf] - List of schema conditions
 */ /**
 * Schema property for component config
 *
 * @typedef {object} SchemaProperty
 * @property {'string' | 'boolean' | 'number' | 'object'} type - Property type
 */ /**
 * Schema condition for component config
 *
 * @template {Partial<Record<keyof ConfigurationType, unknown>>} ConfigurationType
 * @typedef {object} SchemaCondition
 * @property {(keyof ConfigurationType)[]} required - List of required config fields
 * @property {string} errorMessage - Error message when required config fields not provided
 */ /**
 * @template {Partial<Record<keyof ConfigurationType, unknown>>} [ConfigurationType=ObjectNested]
 * @typedef ChildClass
 * @property {string} moduleName - The module name that'll be looked for in the DOM when initialising the component
 * @property {Schema<ConfigurationType>} [schema] - The schema of the component configuration
 * @property {ConfigurationType} [defaults] - The default values of the configuration of the component
 */ /**
 * @template {Partial<Record<keyof ConfigurationType, unknown>>} [ConfigurationType=ObjectNested]
 * @typedef {typeof Component & ChildClass<ConfigurationType>} ChildClassConstructor<ConfigurationType>
 */ /**
 * @import { CompatibleClass, Config, CreateAllOptions, OnErrorCallback } from '../init.mjs'
 */ parcelHelpers.export(exports, "ConfigurableComponent", function() {
    return ConfigurableComponent;
});
parcelHelpers.export(exports, "configOverride", function() {
    return configOverride;
});
parcelHelpers.export(exports, "extractConfigByNamespace", function() {
    return extractConfigByNamespace;
});
parcelHelpers.export(exports, "mergeConfigs", function() {
    return mergeConfigs;
});
parcelHelpers.export(exports, "normaliseDataset", function() {
    return normaliseDataset;
});
parcelHelpers.export(exports, "normaliseOptions", function() {
    return normaliseOptions;
});
parcelHelpers.export(exports, "normaliseString", function() {
    return normaliseString;
});
parcelHelpers.export(exports, "validateConfig", function() {
    return validateConfig;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _componentMjs = require("../component.mjs");
var _indexMjs = require("../errors/index.mjs");
var _indexMjs1 = require("./index.mjs");
var configOverride = Symbol["for"]('configOverride');
var ConfigurableComponent = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, _inherits._)(ConfigurableComponent, Component);
    function ConfigurableComponent($root, config) {
        (0, _classCallCheck._)(this, ConfigurableComponent);
        var _this;
        _this = (0, _callSuper._)(this, ConfigurableComponent, [
            $root
        ]);
        _this._config = void 0;
        var childConstructor = _this.constructor;
        if (!(0, _indexMjs1.isObject)(childConstructor.defaults)) throw new (0, _indexMjs.ConfigError)((0, _indexMjs1.formatErrorMessage)(childConstructor, 'Config passed as parameter into constructor but no defaults defined'));
        var datasetConfig = normaliseDataset(childConstructor, _this._$root.dataset);
        _this._config = mergeConfigs(childConstructor.defaults, config != null ? config : {}, _this[configOverride](datasetConfig), datasetConfig);
        return _this;
    }
    (0, _createClass._)(ConfigurableComponent, [
        {
            key: configOverride,
            value: function value(param) {
                return {};
            }
        },
        {
            key: "config",
            get: /**
   * Returns the root element of the component
   *
   * @protected
   * @returns {ConfigurationType} - the root element of component
   */ function get() {
                return this._config;
            }
        }
    ]);
    return ConfigurableComponent;
}((0, _componentMjs.Component));
function normaliseString(value, property) {
    var trimmedValue = value ? value.trim() : '';
    var output;
    var outputType = property == null ? void 0 : property.type;
    if (!outputType) {
        if ([
            'true',
            'false'
        ].includes(trimmedValue)) outputType = 'boolean';
        if (trimmedValue.length > 0 && isFinite(Number(trimmedValue))) outputType = 'number';
    }
    switch(outputType){
        case 'boolean':
            output = trimmedValue === 'true';
            break;
        case 'number':
            output = Number(trimmedValue);
            break;
        default:
            output = value;
    }
    return output;
}
function normaliseDataset(Component, dataset) {
    if (!(0, _indexMjs1.isObject)(Component.schema)) throw new (0, _indexMjs.ConfigError)((0, _indexMjs1.formatErrorMessage)(Component, 'Config passed as parameter into constructor but no schema defined'));
    var out = {};
    var entries = Object.entries(Component.schema.properties);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var entry = _step.value;
            var _entry = (0, _slicedToArray._)(entry, 2), namespace = _entry[0], property = _entry[1];
            var field = namespace.toString();
            if (field in dataset) out[field] = normaliseString(dataset[field], property);
            if ((property == null ? void 0 : property.type) === 'object') out[field] = extractConfigByNamespace(Component.schema, dataset, namespace);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return out;
}
function normaliseOptions(scopeOrOptions) {
    var $scope = document;
    var onError;
    if ((0, _indexMjs1.isObject)(scopeOrOptions)) {
        var options = scopeOrOptions;
        if ((0, _indexMjs1.isScope)(options.scope) || options.scope === null) $scope = options.scope;
        if (typeof options.onError === 'function') onError = options.onError;
    }
    if ((0, _indexMjs1.isScope)(scopeOrOptions)) $scope = scopeOrOptions;
    else if (scopeOrOptions === null) $scope = null;
    else if (typeof scopeOrOptions === 'function') onError = scopeOrOptions;
    return {
        scope: $scope,
        onError: onError
    };
}
function mergeConfigs() {
    for(var _len = arguments.length, configObjects = new Array(_len), _key = 0; _key < _len; _key++){
        configObjects[_key] = arguments[_key];
    }
    var formattedConfigObject = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator = configObjects[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
            var configObject = _step.value;
            try {
                for(var _iterator1 = Object.keys(configObject)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                    var key = _step1.value;
                    var option = formattedConfigObject[key];
                    var override = configObject[key];
                    if ((0, _indexMjs1.isObject)(option) && (0, _indexMjs1.isObject)(override)) formattedConfigObject[key] = mergeConfigs(option, override);
                    else formattedConfigObject[key] = override;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator1["return"] != null) {
                        _iterator1["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return formattedConfigObject;
}
function validateConfig(schema, config) {
    var validationErrors = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(schema)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, _slicedToArray._)(_step.value, 2), name = _step_value[0], conditions = _step_value[1];
            var errors = [];
            if (Array.isArray(conditions)) {
                var _validationErrors;
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = conditions[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var _step_value1 = _step1.value, required = _step_value1.required, errorMessage = _step_value1.errorMessage;
                        if (!required.every(function(key) {
                            return !!config[key];
                        })) errors.push(errorMessage);
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                            _iterator1["return"]();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                if (name === 'anyOf' && !(conditions.length - errors.length >= 1)) (_validationErrors = validationErrors).push.apply(_validationErrors, (0, _toConsumableArray._)(errors));
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return validationErrors;
}
function extractConfigByNamespace(schema, dataset, namespace) {
    var property = schema.properties[namespace];
    if ((property == null ? void 0 : property.type) !== 'object') return;
    var newObject = (0, _defineProperty._)({}, namespace, {});
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(dataset)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, _slicedToArray._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            var current = newObject;
            var keyParts = key.split('.');
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = keyParts.entries()[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var _step_value1 = (0, _slicedToArray._)(_step1.value, 2), index = _step_value1[0], name = _step_value1[1];
                    if ((0, _indexMjs1.isObject)(current)) {
                        if (index < keyParts.length - 1) {
                            if (!(0, _indexMjs1.isObject)(current[name])) current[name] = {};
                            current = current[name];
                        } else if (key !== namespace) current[name] = normaliseString(value);
                    }
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                        _iterator1["return"]();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return newObject[namespace];
}

},{"@swc/helpers/_/_call_super":"jbaHU","@swc/helpers/_/_class_call_check":"gDZPt","@swc/helpers/_/_create_class":"7MByf","@swc/helpers/_/_define_property":"6AiRP","@swc/helpers/_/_inherits":"lXwSH","@swc/helpers/_/_sliced_to_array":"jFaLC","@swc/helpers/_/_to_consumable_array":"6XR2l","../component.mjs":"VCgbS","../errors/index.mjs":"fYWJ8","./index.mjs":"hMIZ0","@parcel/transformer-js/src/esmodule-helpers.js":"2qAMd"}],"6AiRP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _define_property;
});
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"2qAMd"}],"jFaLC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _sliced_to_array;
});
var _arrayWithHolesJs = require("./_array_with_holes.js");
var _iterableToArrayLimitJs = require("./_iterable_to_array_limit.js");
var _nonIterableRestJs = require("./_non_iterable_rest.js");
var _unsupportedIterableToArrayJs = require("./_unsupported_iterable_to_array.js");
function _sliced_to_array(arr, i) {
    return (0, _arrayWithHolesJs._)(arr) || (0, _iterableToArrayLimitJs._)(arr, i) || (0, _unsupportedIterableToArrayJs._)(arr, i) || (0, _nonIterableRestJs._)();
}

},{"./_array_with_holes.js":"68cny","./_iterable_to_array_limit.js":"LCVMh","./_non_iterable_rest.js":"fQSaT","./_unsupported_iterable_to_array.js":"aEnwK","@parcel/transformer-js/src/esmodule-helpers.js":"2qAMd"}],"68cny":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _array_with_holes;
});
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"2qAMd"}],"LCVMh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _iterable_to_array_limit;
});
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"2qAMd"}],"fQSaT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _non_iterable_rest;
});
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"2qAMd"}],"aEnwK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _unsupported_iterable_to_array;
});
var _arrayLikeToArrayJs = require("./_array_like_to_array.js");
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, _arrayLikeToArrayJs._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, _arrayLikeToArrayJs._)(o, minLen);
}

},{"./_array_like_to_array.js":"UQ8GJ","@parcel/transformer-js/src/esmodule-helpers.js":"2qAMd"}],"UQ8GJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _array_like_to_array;
});
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"2qAMd"}],"6XR2l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _to_consumable_array;
});
var _arrayWithoutHolesJs = require("./_array_without_holes.js");
var _iterableToArrayJs = require("./_iterable_to_array.js");
var _nonIterableSpreadJs = require("./_non_iterable_spread.js");
var _unsupportedIterableToArrayJs = require("./_unsupported_iterable_to_array.js");
function _to_consumable_array(arr) {
    return (0, _arrayWithoutHolesJs._)(arr) || (0, _iterableToArrayJs._)(arr) || (0, _unsupportedIterableToArrayJs._)(arr) || (0, _nonIterableSpreadJs._)();
}

},{"./_array_without_holes.js":"ljsn5","./_iterable_to_array.js":"jS6Gl","./_non_iterable_spread.js":"cTYlQ","./_unsupported_iterable_to_array.js":"aEnwK","@parcel/transformer-js/src/esmodule-helpers.js":"2qAMd"}],"ljsn5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _array_without_holes;
});
var _arrayLikeToArrayJs = require("./_array_like_to_array.js");
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return (0, _arrayLikeToArrayJs._)(arr);
}

},{"./_array_like_to_array.js":"UQ8GJ","@parcel/transformer-js/src/esmodule-helpers.js":"2qAMd"}],"jS6Gl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _iterable_to_array;
});
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"2qAMd"}],"cTYlQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _non_iterable_spread;
});
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"2qAMd"}],"VCgbS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Component", function() {
    return Component;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _indexMjs = require("./common/index.mjs");
var _indexMjs1 = require("./errors/index.mjs");
var Component = /*#__PURE__*/ function() {
    "use strict";
    function Component($root) {
        (0, _classCallCheck._)(this, Component);
        this._$root = void 0;
        var childConstructor = this.constructor;
        if (typeof childConstructor.moduleName !== 'string') throw new (0, _indexMjs1.InitError)("`moduleName` not defined in component");
        if (!($root instanceof childConstructor.elementType)) throw new (0, _indexMjs1.ElementError)({
            element: $root,
            component: childConstructor,
            identifier: 'Root element (`$root`)',
            expectedType: childConstructor.elementType.name
        });
        else this._$root = $root;
        childConstructor.checkSupport();
        this.checkInitialised();
        var moduleName = childConstructor.moduleName;
        this.$root.setAttribute("data-".concat(moduleName, "-init"), '');
    }
    (0, _createClass._)(Component, [
        {
            key: "$root",
            get: /**
   * Returns the root element of the component
   *
   * @protected
   * @returns {RootElementType} - the root element of component
   */ function get() {
                return this._$root;
            }
        },
        {
            key: "checkInitialised",
            value: function checkInitialised() {
                var constructor = this.constructor;
                var moduleName = constructor.moduleName;
                if (moduleName && (0, _indexMjs.isInitialised)(this.$root, moduleName)) throw new (0, _indexMjs1.InitError)(constructor);
            }
        }
    ], [
        {
            key: "checkSupport",
            value: function checkSupport() {
                if (!(0, _indexMjs.isSupported)()) throw new (0, _indexMjs1.SupportError)();
            }
        }
    ]);
    return Component;
}();
/**
 * @typedef ChildClass
 * @property {string} moduleName - The module name that'll be looked for in the DOM when initialising the component
 */ /**
 * @typedef {typeof Component & ChildClass} ChildClassConstructor
 */ Component.elementType = HTMLElement;

},{"@swc/helpers/_/_class_call_check":"gDZPt","@swc/helpers/_/_create_class":"7MByf","./common/index.mjs":"hMIZ0","./errors/index.mjs":"fYWJ8","@parcel/transformer-js/src/esmodule-helpers.js":"2qAMd"}],"hMIZ0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @typedef ComponentWithModuleName
 * @property {string} moduleName - Name of the component
 */ parcelHelpers.export(exports, "formatErrorMessage", function() {
    return formatErrorMessage;
});
parcelHelpers.export(exports, "getBreakpoint", function() {
    return getBreakpoint;
});
parcelHelpers.export(exports, "isInitialised", function() {
    return isInitialised;
});
parcelHelpers.export(exports, "isObject", function() {
    return isObject;
});
parcelHelpers.export(exports, "isScope", function() {
    return isScope;
});
parcelHelpers.export(exports, "isSupported", function() {
    return isSupported;
});
parcelHelpers.export(exports, "setFocus", function() {
    return setFocus;
});
var _typeOf = require("@swc/helpers/_/_type_of");
function getBreakpoint(name) {
    var property = "--govuk-breakpoint-".concat(name);
    var value = window.getComputedStyle(document.documentElement).getPropertyValue(property);
    return {
        property: property,
        value: value || undefined
    };
}
function setFocus($element) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _options$onBeforeFocu;
    var isFocusable = $element.getAttribute('tabindex');
    if (!isFocusable) $element.setAttribute('tabindex', '-1');
    function onFocus() {
        $element.addEventListener('blur', onBlur, {
            once: true
        });
    }
    function onBlur() {
        var _options$onBlur;
        (_options$onBlur = options.onBlur) == null || _options$onBlur.call($element);
        if (!isFocusable) $element.removeAttribute('tabindex');
    }
    $element.addEventListener('focus', onFocus, {
        once: true
    });
    (_options$onBeforeFocu = options.onBeforeFocus) == null || _options$onBeforeFocu.call($element);
    $element.focus();
}
function isInitialised($root, moduleName) {
    return $root instanceof HTMLElement && $root.hasAttribute("data-".concat(moduleName, "-init"));
}
/**
 * Checks if GOV.UK Frontend is supported on this page
 *
 * Some browsers will load and run our JavaScript but GOV.UK Frontend
 * won't be supported.
 *
 * @param {HTMLElement | null} [$scope] - (internal) `<body>` HTML element checked for browser support
 * @returns {boolean} Whether GOV.UK Frontend is supported on this page
 */ function isSupported() {
    var $scope = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document.body;
    if (!$scope) return false;
    return $scope.classList.contains('govuk-frontend-supported');
}
function isArray(option) {
    return Array.isArray(option);
}
function isObject(option) {
    return !!option && (typeof option === "undefined" ? "undefined" : (0, _typeOf._)(option)) === 'object' && !isArray(option);
}
function isScope($scope) {
    return !!$scope && ($scope instanceof Element || $scope instanceof Document);
}
function formatErrorMessage(Component, message) {
    return "".concat(Component.moduleName, ": ").concat(message);
}

},{"@swc/helpers/_/_type_of":"lkAFj","@parcel/transformer-js/src/esmodule-helpers.js":"2qAMd"}],"fYWJ8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @import { ComponentWithModuleName } from '../common/index.mjs'
 */ parcelHelpers.export(exports, "ConfigError", function() {
    return ConfigError;
});
parcelHelpers.export(exports, "ElementError", function() {
    return ElementError;
});
parcelHelpers.export(exports, "GOVUKFrontendError", function() {
    return GOVUKFrontendError;
});
parcelHelpers.export(exports, "InitError", function() {
    return InitError;
});
parcelHelpers.export(exports, "SupportError", function() {
    return SupportError;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _inherits = require("@swc/helpers/_/_inherits");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _wrapNativeSuper = require("@swc/helpers/_/_wrap_native_super");
var _indexMjs = require("../common/index.mjs");
var GOVUKFrontendError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, _inherits._)(GOVUKFrontendError, Error1);
    function GOVUKFrontendError() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, _classCallCheck._)(this, GOVUKFrontendError);
        var _this;
        _this = (0, _callSuper._)(this, GOVUKFrontendError, (0, _toConsumableArray._)(args));
        _this.name = 'GOVUKFrontendError';
        return _this;
    }
    return GOVUKFrontendError;
}((0, _wrapNativeSuper._)(Error));
var SupportError = /*#__PURE__*/ function(GOVUKFrontendError) {
    "use strict";
    (0, _inherits._)(SupportError, GOVUKFrontendError);
    function SupportError() {
        var $scope = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document.body;
        (0, _classCallCheck._)(this, SupportError);
        var _this;
        var supportMessage = 'noModule' in HTMLScriptElement.prototype ? 'GOV.UK Frontend initialised without `<body class="govuk-frontend-supported">` from template `<script>` snippet' : 'GOV.UK Frontend is not supported in this browser';
        _this = (0, _callSuper._)(this, SupportError, [
            $scope ? supportMessage : 'GOV.UK Frontend initialised without `<script type="module">`'
        ]);
        _this.name = 'SupportError';
        return _this;
    }
    return SupportError;
}(GOVUKFrontendError);
var ConfigError = /*#__PURE__*/ function(GOVUKFrontendError) {
    "use strict";
    (0, _inherits._)(ConfigError, GOVUKFrontendError);
    function ConfigError() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, _classCallCheck._)(this, ConfigError);
        var _this;
        _this = (0, _callSuper._)(this, ConfigError, (0, _toConsumableArray._)(args));
        _this.name = 'ConfigError';
        return _this;
    }
    return ConfigError;
}(GOVUKFrontendError);
var ElementError = /*#__PURE__*/ function(GOVUKFrontendError) {
    "use strict";
    (0, _inherits._)(ElementError, GOVUKFrontendError);
    function ElementError(messageOrOptions) {
        (0, _classCallCheck._)(this, ElementError);
        var _this;
        var message = typeof messageOrOptions === 'string' ? messageOrOptions : '';
        if ((0, _indexMjs.isObject)(messageOrOptions)) {
            var component = messageOrOptions.component, identifier = messageOrOptions.identifier, element = messageOrOptions.element, expectedType = messageOrOptions.expectedType;
            message = identifier;
            message += element ? " is not of type ".concat(expectedType != null ? expectedType : 'HTMLElement') : ' not found';
            if (component) message = (0, _indexMjs.formatErrorMessage)(component, message);
        }
        _this = (0, _callSuper._)(this, ElementError, [
            message
        ]);
        _this.name = 'ElementError';
        return _this;
    }
    return ElementError;
}(GOVUKFrontendError);
var InitError = /*#__PURE__*/ function(GOVUKFrontendError) {
    "use strict";
    (0, _inherits._)(InitError, GOVUKFrontendError);
    function InitError(componentOrMessage) {
        (0, _classCallCheck._)(this, InitError);
        var _this;
        var message = typeof componentOrMessage === 'string' ? componentOrMessage : (0, _indexMjs.formatErrorMessage)(componentOrMessage, "Root element (`$root`) already initialised");
        _this = (0, _callSuper._)(this, InitError, [
            message
        ]);
        _this.name = 'InitError';
        return _this;
    }
    return InitError;
}(GOVUKFrontendError);

},{"@swc/helpers/_/_call_super":"jbaHU","@swc/helpers/_/_class_call_check":"gDZPt","@swc/helpers/_/_inherits":"lXwSH","@swc/helpers/_/_to_consumable_array":"6XR2l","@swc/helpers/_/_wrap_native_super":"k47ZR","../common/index.mjs":"hMIZ0","@parcel/transformer-js/src/esmodule-helpers.js":"2qAMd"}],"k47ZR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _wrap_native_super;
});
var _constructJs = require("./_construct.js");
var _getPrototypeOfJs = require("./_get_prototype_of.js");
var _isNativeFunctionJs = require("./_is_native_function.js");
var _setPrototypeOfJs = require("./_set_prototype_of.js");
function _wrap_native_super(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrap_native_super = function(Class) {
        if (Class === null || !(0, _isNativeFunctionJs._)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, _constructJs._)(Class, arguments, (0, _getPrototypeOfJs._)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, _setPrototypeOfJs._)(Wrapper, Class);
    };
    return _wrap_native_super(Class);
}

},{"./_construct.js":"bVBU1","./_get_prototype_of.js":"YIEPg","./_is_native_function.js":"esjTo","./_set_prototype_of.js":"bVhRy","@parcel/transformer-js/src/esmodule-helpers.js":"2qAMd"}],"bVBU1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _construct;
});
var _isNativeReflectConstructJs = require("./_is_native_reflect_construct.js");
var _setPrototypeOfJs = require("./_set_prototype_of.js");
function _construct(Parent, args, Class) {
    if ((0, _isNativeReflectConstructJs._)()) _construct = Reflect.construct;
    else _construct = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, _setPrototypeOfJs._)(instance, Class.prototype);
        return instance;
    };
    return _construct.apply(null, arguments);
}

},{"./_is_native_reflect_construct.js":"iibYu","./_set_prototype_of.js":"bVhRy","@parcel/transformer-js/src/esmodule-helpers.js":"2qAMd"}],"esjTo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _is_native_function;
});
function _is_native_function(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"2qAMd"}],"y8yul":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "I18n", function() {
    return I18n;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _indexMjs = require("./common/index.mjs");
var I18n = /*#__PURE__*/ function() {
    "use strict";
    function I18n() {
        var translations = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, _classCallCheck._)(this, I18n);
        var _config$locale;
        this.translations = void 0;
        this.locale = void 0;
        this.translations = translations;
        this.locale = (_config$locale = config.locale) != null ? _config$locale : document.documentElement.lang || 'en';
    }
    (0, _createClass._)(I18n, [
        {
            key: "t",
            value: function t(lookupKey, options) {
                if (!lookupKey) throw new Error('i18n: lookup key missing');
                var translation = this.translations[lookupKey];
                if (typeof (options == null ? void 0 : options.count) === 'number' && (0, _indexMjs.isObject)(translation)) {
                    var translationPluralForm = translation[this.getPluralSuffix(lookupKey, options.count)];
                    if (translationPluralForm) translation = translationPluralForm;
                }
                if (typeof translation === 'string') {
                    if (translation.match(/%{(.\S+)}/)) {
                        if (!options) throw new Error('i18n: cannot replace placeholders in string if no option data provided');
                        return this.replacePlaceholders(translation, options);
                    }
                    return translation;
                }
                return lookupKey;
            }
        },
        {
            key: "replacePlaceholders",
            value: function replacePlaceholders(translationString, options) {
                var formatter = Intl.NumberFormat.supportedLocalesOf(this.locale).length ? new Intl.NumberFormat(this.locale) : undefined;
                return translationString.replace(/%{(.\S+)}/g, function(placeholderWithBraces, placeholderKey) {
                    if (Object.prototype.hasOwnProperty.call(options, placeholderKey)) {
                        var placeholderValue = options[placeholderKey];
                        if (placeholderValue === false || typeof placeholderValue !== 'number' && typeof placeholderValue !== 'string') return '';
                        if (typeof placeholderValue === 'number') return formatter ? formatter.format(placeholderValue) : "".concat(placeholderValue);
                        return placeholderValue;
                    }
                    throw new Error("i18n: no data found to replace ".concat(placeholderWithBraces, " placeholder in string"));
                });
            }
        },
        {
            key: "hasIntlPluralRulesSupport",
            value: function hasIntlPluralRulesSupport() {
                return Boolean('PluralRules' in window.Intl && Intl.PluralRules.supportedLocalesOf(this.locale).length);
            }
        },
        {
            key: "getPluralSuffix",
            value: function getPluralSuffix(lookupKey, count) {
                count = Number(count);
                if (!isFinite(count)) return 'other';
                var translation = this.translations[lookupKey];
                var preferredForm = this.hasIntlPluralRulesSupport() ? new Intl.PluralRules(this.locale).select(count) : 'other';
                if ((0, _indexMjs.isObject)(translation)) {
                    if (preferredForm in translation) return preferredForm;
                    else if ('other' in translation) {
                        console.warn('i18n: Missing plural form ".'.concat(preferredForm, '" for "').concat(this.locale, '" locale. Falling back to ".other".'));
                        return 'other';
                    }
                }
                throw new Error('i18n: Plural form ".other" is required for "'.concat(this.locale, '" locale'));
            }
        }
    ]);
    return I18n;
}();

},{"@swc/helpers/_/_class_call_check":"gDZPt","@swc/helpers/_/_create_class":"7MByf","./common/index.mjs":"hMIZ0","@parcel/transformer-js/src/esmodule-helpers.js":"2qAMd"}],"ic7uQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Button", function() {
    return Button;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _configurationMjs = require("../../common/configuration.mjs");
var DEBOUNCE_TIMEOUT_IN_SECONDS = 1;
/**
 * JavaScript enhancements for the Button component
 *
 * @preserve
 * @augments ConfigurableComponent<ButtonConfig>
 */ var Button = /*#__PURE__*/ function(ConfigurableComponent) {
    "use strict";
    (0, _inherits._)(Button, ConfigurableComponent);
    function Button($root) {
        var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, _classCallCheck._)(this, Button);
        var _this;
        _this = (0, _callSuper._)(this, Button, [
            $root,
            config
        ]);
        _this.debounceFormSubmitTimer = null;
        _this.$root.addEventListener('keydown', function(event) {
            return _this.handleKeyDown(event);
        });
        _this.$root.addEventListener('click', function(event) {
            return _this.debounce(event);
        });
        return _this;
    }
    (0, _createClass._)(Button, [
        {
            key: "handleKeyDown",
            value: function handleKeyDown(event) {
                var $target = event.target;
                if (event.key !== ' ') return;
                if ($target instanceof HTMLElement && $target.getAttribute('role') === 'button') {
                    event.preventDefault();
                    $target.click();
                }
            }
        },
        {
            key: "debounce",
            value: function debounce(event) {
                var _this = this;
                if (!this.config.preventDoubleClick) return;
                if (this.debounceFormSubmitTimer) {
                    event.preventDefault();
                    return false;
                }
                this.debounceFormSubmitTimer = window.setTimeout(function() {
                    _this.debounceFormSubmitTimer = null;
                }, DEBOUNCE_TIMEOUT_IN_SECONDS * 1000);
            }
        }
    ]);
    return Button;
}((0, _configurationMjs.ConfigurableComponent));
/**
 * Button config
 *
 * @typedef {object} ButtonConfig
 * @property {boolean} [preventDoubleClick=false] - Prevent accidental double
 *   clicks on submit buttons from submitting forms multiple times.
 */ /**
 * @import { Schema } from '../../common/configuration.mjs'
 */ Button.moduleName = 'govuk-button';
Button.defaults = Object.freeze({
    preventDoubleClick: false
});
Button.schema = Object.freeze({
    properties: {
        preventDoubleClick: {
            type: 'boolean'
        }
    }
});

},{"@swc/helpers/_/_call_super":"jbaHU","@swc/helpers/_/_class_call_check":"gDZPt","@swc/helpers/_/_create_class":"7MByf","@swc/helpers/_/_inherits":"lXwSH","../../common/configuration.mjs":"iQR6u","@parcel/transformer-js/src/esmodule-helpers.js":"2qAMd"}],"1Bfd0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CharacterCount", function() {
    return CharacterCount;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _closestAttributeValueMjs = require("../../common/closest-attribute-value.mjs");
var _configurationMjs = require("../../common/configuration.mjs");
var _indexMjs = require("../../common/index.mjs");
var _indexMjs1 = require("../../errors/index.mjs");
var _i18NMjs = require("../../i18n.mjs");
/**
 * Character count component
 *
 * Tracks the number of characters or words in the `.govuk-js-character-count`
 * `<textarea>` inside the element. Displays a message with the remaining number
 * of characters/words available, or the number of characters/words in excess.
 *
 * You can configure the message to only appear after a certain percentage
 * of the available characters/words has been entered.
 *
 * @preserve
 * @augments ConfigurableComponent<CharacterCountConfig>
 */ var CharacterCount = /*#__PURE__*/ function(ConfigurableComponent) {
    "use strict";
    (0, _inherits._)(CharacterCount, ConfigurableComponent);
    function CharacterCount($root) {
        var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, _classCallCheck._)(this, CharacterCount);
        var _this;
        var _ref, _this$config$maxwords;
        _this = (0, _callSuper._)(this, CharacterCount, [
            $root,
            config
        ]);
        _this.$textarea = void 0;
        _this.$visibleCountMessage = void 0;
        _this.$screenReaderCountMessage = void 0;
        _this.lastInputTimestamp = null;
        _this.lastInputValue = '';
        _this.valueChecker = null;
        _this.i18n = void 0;
        _this.maxLength = void 0;
        var $textarea = _this.$root.querySelector('.govuk-js-character-count');
        if (!($textarea instanceof HTMLTextAreaElement || $textarea instanceof HTMLInputElement)) throw new (0, _indexMjs1.ElementError)({
            component: CharacterCount,
            element: $textarea,
            expectedType: 'HTMLTextareaElement or HTMLInputElement',
            identifier: 'Form field (`.govuk-js-character-count`)'
        });
        var errors = (0, _configurationMjs.validateConfig)(CharacterCount.schema, _this.config);
        if (errors[0]) throw new (0, _indexMjs1.ConfigError)((0, _indexMjs.formatErrorMessage)(CharacterCount, errors[0]));
        _this.i18n = new (0, _i18NMjs.I18n)(_this.config.i18n, {
            locale: (0, _closestAttributeValueMjs.closestAttributeValue)(_this.$root, 'lang')
        });
        _this.maxLength = (_ref = (_this$config$maxwords = _this.config.maxwords) != null ? _this$config$maxwords : _this.config.maxlength) != null ? _ref : Infinity;
        _this.$textarea = $textarea;
        var textareaDescriptionId = "".concat(_this.$textarea.id, "-info");
        var $textareaDescription = document.getElementById(textareaDescriptionId);
        if (!$textareaDescription) throw new (0, _indexMjs1.ElementError)({
            component: CharacterCount,
            element: $textareaDescription,
            identifier: 'Count message (`id="'.concat(textareaDescriptionId, '"`)')
        });
        _this.$errorMessage = _this.$root.querySelector('.govuk-error-message');
        if ($textareaDescription.textContent.match(/^\s*$/)) $textareaDescription.textContent = _this.i18n.t('textareaDescription', {
            count: _this.maxLength
        });
        _this.$textarea.insertAdjacentElement('afterend', $textareaDescription);
        var $screenReaderCountMessage = document.createElement('div');
        $screenReaderCountMessage.className = 'govuk-character-count__sr-status govuk-visually-hidden';
        $screenReaderCountMessage.setAttribute('aria-live', 'polite');
        _this.$screenReaderCountMessage = $screenReaderCountMessage;
        $textareaDescription.insertAdjacentElement('afterend', $screenReaderCountMessage);
        var $visibleCountMessage = document.createElement('div');
        $visibleCountMessage.className = $textareaDescription.className;
        $visibleCountMessage.classList.add('govuk-character-count__status');
        $visibleCountMessage.setAttribute('aria-hidden', 'true');
        _this.$visibleCountMessage = $visibleCountMessage;
        $textareaDescription.insertAdjacentElement('afterend', $visibleCountMessage);
        $textareaDescription.classList.add('govuk-visually-hidden');
        _this.$textarea.removeAttribute('maxlength');
        _this.bindChangeEvents();
        window.addEventListener('pageshow', function() {
            return _this.updateCountMessage();
        });
        _this.updateCountMessage();
        return _this;
    }
    (0, _createClass._)(CharacterCount, [
        {
            key: (0, _configurationMjs.configOverride),
            value: function value(datasetConfig) {
                var configOverrides = {};
                if ('maxwords' in datasetConfig || 'maxlength' in datasetConfig) configOverrides = {
                    maxlength: undefined,
                    maxwords: undefined
                };
                return configOverrides;
            }
        },
        {
            key: "bindChangeEvents",
            value: function bindChangeEvents() {
                var _this = this;
                this.$textarea.addEventListener('keyup', function() {
                    return _this.handleKeyUp();
                });
                this.$textarea.addEventListener('focus', function() {
                    return _this.handleFocus();
                });
                this.$textarea.addEventListener('blur', function() {
                    return _this.handleBlur();
                });
            }
        },
        {
            key: "handleKeyUp",
            value: function handleKeyUp() {
                this.updateVisibleCountMessage();
                this.lastInputTimestamp = Date.now();
            }
        },
        {
            key: "handleFocus",
            value: function handleFocus() {
                var _this = this;
                this.valueChecker = window.setInterval(function() {
                    if (!_this.lastInputTimestamp || Date.now() - 500 >= _this.lastInputTimestamp) _this.updateIfValueChanged();
                }, 1000);
            }
        },
        {
            key: "handleBlur",
            value: function handleBlur() {
                if (this.valueChecker) window.clearInterval(this.valueChecker);
            }
        },
        {
            key: "updateIfValueChanged",
            value: function updateIfValueChanged() {
                if (this.$textarea.value !== this.lastInputValue) {
                    this.lastInputValue = this.$textarea.value;
                    this.updateCountMessage();
                }
            }
        },
        {
            key: "updateCountMessage",
            value: function updateCountMessage() {
                this.updateVisibleCountMessage();
                this.updateScreenReaderCountMessage();
            }
        },
        {
            key: "updateVisibleCountMessage",
            value: function updateVisibleCountMessage() {
                var remainingNumber = this.maxLength - this.count(this.$textarea.value);
                var isError = remainingNumber < 0;
                this.$visibleCountMessage.classList.toggle('govuk-character-count__message--disabled', !this.isOverThreshold());
                if (!this.$errorMessage) this.$textarea.classList.toggle('govuk-textarea--error', isError);
                this.$visibleCountMessage.classList.toggle('govuk-error-message', isError);
                this.$visibleCountMessage.classList.toggle('govuk-hint', !isError);
                this.$visibleCountMessage.textContent = this.getCountMessage();
            }
        },
        {
            key: "updateScreenReaderCountMessage",
            value: function updateScreenReaderCountMessage() {
                if (this.isOverThreshold()) this.$screenReaderCountMessage.removeAttribute('aria-hidden');
                else this.$screenReaderCountMessage.setAttribute('aria-hidden', 'true');
                this.$screenReaderCountMessage.textContent = this.getCountMessage();
            }
        },
        {
            key: "count",
            value: function count(text) {
                if (this.config.maxwords) {
                    var _text$match;
                    var tokens = (_text$match = text.match(/\S+/g)) != null ? _text$match : [];
                    return tokens.length;
                }
                return text.length;
            }
        },
        {
            key: "getCountMessage",
            value: function getCountMessage() {
                var remainingNumber = this.maxLength - this.count(this.$textarea.value);
                var countType = this.config.maxwords ? 'words' : 'characters';
                return this.formatCountMessage(remainingNumber, countType);
            }
        },
        {
            key: "formatCountMessage",
            value: function formatCountMessage(remainingNumber, countType) {
                if (remainingNumber === 0) return this.i18n.t("".concat(countType, "AtLimit"));
                var translationKeySuffix = remainingNumber < 0 ? 'OverLimit' : 'UnderLimit';
                return this.i18n.t("".concat(countType).concat(translationKeySuffix), {
                    count: Math.abs(remainingNumber)
                });
            }
        },
        {
            key: "isOverThreshold",
            value: function isOverThreshold() {
                if (!this.config.threshold) return true;
                var currentLength = this.count(this.$textarea.value);
                var maxLength = this.maxLength;
                var thresholdValue = maxLength * this.config.threshold / 100;
                return thresholdValue <= currentLength;
            }
        }
    ]);
    return CharacterCount;
}((0, _configurationMjs.ConfigurableComponent));
/**
 * Character count config
 *
 * @see {@link CharacterCount.defaults}
 * @typedef {object} CharacterCountConfig
 * @property {number} [maxlength] - The maximum number of characters.
 *   If maxwords is provided, the maxlength option will be ignored.
 * @property {number} [maxwords] - The maximum number of words. If maxwords is
 *   provided, the maxlength option will be ignored.
 * @property {number} [threshold=0] - The percentage value of the limit at
 *   which point the count message is displayed. If this attribute is set, the
 *   count message will be hidden by default.
 * @property {CharacterCountTranslations} [i18n=CharacterCount.defaults.i18n] - Character count translations
 */ /**
 * Character count translations
 *
 * @see {@link CharacterCount.defaults.i18n}
 * @typedef {object} CharacterCountTranslations
 *
 * Messages shown to users as they type. It provides feedback on how many words
 * or characters they have remaining or if they are over the limit. This also
 * includes a message used as an accessible description for the textarea.
 * @property {TranslationPluralForms} [charactersUnderLimit] - Message displayed
 *   when the number of characters is under the configured maximum, `maxlength`.
 *   This message is displayed visually and through assistive technologies. The
 *   component will replace the `%{count}` placeholder with the number of
 *   remaining characters. This is a [pluralised list of
 *   messages](https://frontend.design-system.service.gov.uk/localise-govuk-frontend).
 * @property {string} [charactersAtLimit] - Message displayed when the number of
 *   characters reaches the configured maximum, `maxlength`. This message is
 *   displayed visually and through assistive technologies.
 * @property {TranslationPluralForms} [charactersOverLimit] - Message displayed
 *   when the number of characters is over the configured maximum, `maxlength`.
 *   This message is displayed visually and through assistive technologies. The
 *   component will replace the `%{count}` placeholder with the number of
 *   remaining characters. This is a [pluralised list of
 *   messages](https://frontend.design-system.service.gov.uk/localise-govuk-frontend).
 * @property {TranslationPluralForms} [wordsUnderLimit] - Message displayed when
 *   the number of words is under the configured maximum, `maxlength`. This
 *   message is displayed visually and through assistive technologies. The
 *   component will replace the `%{count}` placeholder with the number of
 *   remaining words. This is a [pluralised list of
 *   messages](https://frontend.design-system.service.gov.uk/localise-govuk-frontend).
 * @property {string} [wordsAtLimit] - Message displayed when the number of
 *   words reaches the configured maximum, `maxlength`. This message is
 *   displayed visually and through assistive technologies.
 * @property {TranslationPluralForms} [wordsOverLimit] - Message displayed when
 *   the number of words is over the configured maximum, `maxlength`. This
 *   message is displayed visually and through assistive technologies. The
 *   component will replace the `%{count}` placeholder with the number of
 *   remaining words. This is a [pluralised list of
 *   messages](https://frontend.design-system.service.gov.uk/localise-govuk-frontend).
 * @property {TranslationPluralForms} [textareaDescription] - Message made
 *   available to assistive technologies, if none is already present in the
 *   HTML, to describe that the component accepts only a limited amount of
 *   content. It is visible on the page when JavaScript is unavailable. The
 *   component will replace the `%{count}` placeholder with the value of the
 *   `maxlength` or `maxwords` parameter.
 */ /**
 * @import { Schema } from '../../common/configuration.mjs'
 * @import { TranslationPluralForms } from '../../i18n.mjs'
 */ CharacterCount.moduleName = 'govuk-character-count';
CharacterCount.defaults = Object.freeze({
    threshold: 0,
    i18n: {
        charactersUnderLimit: {
            one: 'You have %{count} character remaining',
            other: 'You have %{count} characters remaining'
        },
        charactersAtLimit: 'You have 0 characters remaining',
        charactersOverLimit: {
            one: 'You have %{count} character too many',
            other: 'You have %{count} characters too many'
        },
        wordsUnderLimit: {
            one: 'You have %{count} word remaining',
            other: 'You have %{count} words remaining'
        },
        wordsAtLimit: 'You have 0 words remaining',
        wordsOverLimit: {
            one: 'You have %{count} word too many',
            other: 'You have %{count} words too many'
        },
        textareaDescription: {
            other: ''
        }
    }
});
CharacterCount.schema = Object.freeze({
    properties: {
        i18n: {
            type: 'object'
        },
        maxwords: {
            type: 'number'
        },
        maxlength: {
            type: 'number'
        },
        threshold: {
            type: 'number'
        }
    },
    anyOf: [
        {
            required: [
                'maxwords'
            ],
            errorMessage: 'Either "maxlength" or "maxwords" must be provided'
        },
        {
            required: [
                'maxlength'
            ],
            errorMessage: 'Either "maxlength" or "maxwords" must be provided'
        }
    ]
});

},{"@swc/helpers/_/_call_super":"jbaHU","@swc/helpers/_/_class_call_check":"gDZPt","@swc/helpers/_/_create_class":"7MByf","@swc/helpers/_/_inherits":"lXwSH","../../common/closest-attribute-value.mjs":"5pLlZ","../../common/configuration.mjs":"iQR6u","../../common/index.mjs":"hMIZ0","../../errors/index.mjs":"fYWJ8","../../i18n.mjs":"y8yul","@parcel/transformer-js/src/esmodule-helpers.js":"2qAMd"}],"5pLlZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "closestAttributeValue", function() {
    return closestAttributeValue;
});
function closestAttributeValue($element, attributeName) {
    var $closestElementWithAttribute = $element.closest("[".concat(attributeName, "]"));
    return $closestElementWithAttribute ? $closestElementWithAttribute.getAttribute(attributeName) : null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"2qAMd"}],"kvvKs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Checkboxes", function() {
    return Checkboxes;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _componentMjs = require("../../component.mjs");
var _indexMjs = require("../../errors/index.mjs");
/**
 * Checkboxes component
 *
 * @preserve
 */ var Checkboxes = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, _inherits._)(Checkboxes, Component);
    function Checkboxes($root) {
        (0, _classCallCheck._)(this, Checkboxes);
        var _this;
        _this = (0, _callSuper._)(this, Checkboxes, [
            $root
        ]);
        _this.$inputs = void 0;
        var $inputs = _this.$root.querySelectorAll('input[type="checkbox"]');
        if (!$inputs.length) throw new (0, _indexMjs.ElementError)({
            component: Checkboxes,
            identifier: 'Form inputs (`<input type="checkbox">`)'
        });
        _this.$inputs = $inputs;
        _this.$inputs.forEach(function($input) {
            var targetId = $input.getAttribute('data-aria-controls');
            if (!targetId) return;
            if (!document.getElementById(targetId)) throw new (0, _indexMjs.ElementError)({
                component: Checkboxes,
                identifier: 'Conditional reveal (`id="'.concat(targetId, '"`)')
            });
            $input.setAttribute('aria-controls', targetId);
            $input.removeAttribute('data-aria-controls');
        });
        window.addEventListener('pageshow', function() {
            return _this.syncAllConditionalReveals();
        });
        _this.syncAllConditionalReveals();
        _this.$root.addEventListener('click', function(event) {
            return _this.handleClick(event);
        });
        return _this;
    }
    (0, _createClass._)(Checkboxes, [
        {
            key: "syncAllConditionalReveals",
            value: function syncAllConditionalReveals() {
                var _this = this;
                this.$inputs.forEach(function($input) {
                    return _this.syncConditionalRevealWithInputState($input);
                });
            }
        },
        {
            key: "syncConditionalRevealWithInputState",
            value: function syncConditionalRevealWithInputState($input) {
                var targetId = $input.getAttribute('aria-controls');
                if (!targetId) return;
                var $target = document.getElementById(targetId);
                if ($target != null && $target.classList.contains('govuk-checkboxes__conditional')) {
                    var inputIsChecked = $input.checked;
                    $input.setAttribute('aria-expanded', inputIsChecked.toString());
                    $target.classList.toggle('govuk-checkboxes__conditional--hidden', !inputIsChecked);
                }
            }
        },
        {
            key: "unCheckAllInputsExcept",
            value: function unCheckAllInputsExcept($input) {
                var _this = this;
                var allInputsWithSameName = document.querySelectorAll('input[type="checkbox"][name="'.concat($input.name, '"]'));
                allInputsWithSameName.forEach(function($inputWithSameName) {
                    var hasSameFormOwner = $input.form === $inputWithSameName.form;
                    if (hasSameFormOwner && $inputWithSameName !== $input) {
                        $inputWithSameName.checked = false;
                        _this.syncConditionalRevealWithInputState($inputWithSameName);
                    }
                });
            }
        },
        {
            key: "unCheckExclusiveInputs",
            value: function unCheckExclusiveInputs($input) {
                var _this = this;
                var allInputsWithSameNameAndExclusiveBehaviour = document.querySelectorAll('input[data-behaviour="exclusive"][type="checkbox"][name="'.concat($input.name, '"]'));
                allInputsWithSameNameAndExclusiveBehaviour.forEach(function($exclusiveInput) {
                    var hasSameFormOwner = $input.form === $exclusiveInput.form;
                    if (hasSameFormOwner) {
                        $exclusiveInput.checked = false;
                        _this.syncConditionalRevealWithInputState($exclusiveInput);
                    }
                });
            }
        },
        {
            key: "handleClick",
            value: function handleClick(event) {
                var $clickedInput = event.target;
                if (!($clickedInput instanceof HTMLInputElement) || $clickedInput.type !== 'checkbox') return;
                var hasAriaControls = $clickedInput.getAttribute('aria-controls');
                if (hasAriaControls) this.syncConditionalRevealWithInputState($clickedInput);
                if (!$clickedInput.checked) return;
                var hasBehaviourExclusive = $clickedInput.getAttribute('data-behaviour') === 'exclusive';
                if (hasBehaviourExclusive) this.unCheckAllInputsExcept($clickedInput);
                else this.unCheckExclusiveInputs($clickedInput);
            }
        }
    ]);
    return Checkboxes;
}((0, _componentMjs.Component));
Checkboxes.moduleName = 'govuk-checkboxes';

},{"@swc/helpers/_/_call_super":"jbaHU","@swc/helpers/_/_class_call_check":"gDZPt","@swc/helpers/_/_create_class":"7MByf","@swc/helpers/_/_inherits":"lXwSH","../../component.mjs":"VCgbS","../../errors/index.mjs":"fYWJ8","@parcel/transformer-js/src/esmodule-helpers.js":"2qAMd"}],"gJljr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ErrorSummary", function() {
    return ErrorSummary;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _configurationMjs = require("../../common/configuration.mjs");
var _indexMjs = require("../../common/index.mjs");
/**
 * Error summary component
 *
 * Takes focus on initialisation for accessible announcement, unless disabled in
 * configuration.
 *
 * @preserve
 * @augments ConfigurableComponent<ErrorSummaryConfig>
 */ var ErrorSummary = /*#__PURE__*/ function(ConfigurableComponent) {
    "use strict";
    (0, _inherits._)(ErrorSummary, ConfigurableComponent);
    function ErrorSummary($root) {
        var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, _classCallCheck._)(this, ErrorSummary);
        var _this;
        _this = (0, _callSuper._)(this, ErrorSummary, [
            $root,
            config
        ]);
        if (!_this.config.disableAutoFocus) (0, _indexMjs.setFocus)(_this.$root);
        _this.$root.addEventListener('click', function(event) {
            return _this.handleClick(event);
        });
        return _this;
    }
    (0, _createClass._)(ErrorSummary, [
        {
            key: "handleClick",
            value: function handleClick(event) {
                var $target = event.target;
                if ($target && this.focusTarget($target)) event.preventDefault();
            }
        },
        {
            key: "focusTarget",
            value: function focusTarget($target) {
                if (!($target instanceof HTMLAnchorElement)) return false;
                var inputId = $target.hash.replace('#', '');
                if (!inputId) return false;
                var $input = document.getElementById(inputId);
                if (!$input) return false;
                var $legendOrLabel = this.getAssociatedLegendOrLabel($input);
                if (!$legendOrLabel) return false;
                $legendOrLabel.scrollIntoView();
                $input.focus({
                    preventScroll: true
                });
                return true;
            }
        },
        {
            key: "getAssociatedLegendOrLabel",
            value: function getAssociatedLegendOrLabel($input) {
                var _document$querySelect;
                var $fieldset = $input.closest('fieldset');
                if ($fieldset) {
                    var $legends = $fieldset.getElementsByTagName('legend');
                    if ($legends.length) {
                        var $candidateLegend = $legends[0];
                        if ($input instanceof HTMLInputElement && ($input.type === 'checkbox' || $input.type === 'radio')) return $candidateLegend;
                        var legendTop = $candidateLegend.getBoundingClientRect().top;
                        var inputRect = $input.getBoundingClientRect();
                        if (inputRect.height && window.innerHeight) {
                            var inputBottom = inputRect.top + inputRect.height;
                            if (inputBottom - legendTop < window.innerHeight / 2) return $candidateLegend;
                        }
                    }
                }
                return (_document$querySelect = document.querySelector("label[for='".concat($input.getAttribute('id'), "']"))) != null ? _document$querySelect : $input.closest('label');
            }
        }
    ]);
    return ErrorSummary;
}((0, _configurationMjs.ConfigurableComponent));
/**
 * Error summary config
 *
 * @typedef {object} ErrorSummaryConfig
 * @property {boolean} [disableAutoFocus=false] - If set to `true` the error
 *   summary will not be focussed when the page loads.
 */ /**
 * @import { Schema } from '../../common/configuration.mjs'
 */ ErrorSummary.moduleName = 'govuk-error-summary';
ErrorSummary.defaults = Object.freeze({
    disableAutoFocus: false
});
ErrorSummary.schema = Object.freeze({
    properties: {
        disableAutoFocus: {
            type: 'boolean'
        }
    }
});

},{"@swc/helpers/_/_call_super":"jbaHU","@swc/helpers/_/_class_call_check":"gDZPt","@swc/helpers/_/_create_class":"7MByf","@swc/helpers/_/_inherits":"lXwSH","../../common/configuration.mjs":"iQR6u","../../common/index.mjs":"hMIZ0","@parcel/transformer-js/src/esmodule-helpers.js":"2qAMd"}],"b4dHw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ExitThisPage", function() {
    return ExitThisPage;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _configurationMjs = require("../../common/configuration.mjs");
var _indexMjs = require("../../errors/index.mjs");
var _i18NMjs = require("../../i18n.mjs");
/**
 * Exit this page component
 *
 * @preserve
 * @augments ConfigurableComponent<ExitThisPageConfig>
 */ var ExitThisPage = /*#__PURE__*/ function(ConfigurableComponent) {
    "use strict";
    (0, _inherits._)(ExitThisPage, ConfigurableComponent);
    function ExitThisPage($root) {
        var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, _classCallCheck._)(this, ExitThisPage);
        var _this;
        _this = (0, _callSuper._)(this, ExitThisPage, [
            $root,
            config
        ]);
        _this.i18n = void 0;
        _this.$button = void 0;
        _this.$skiplinkButton = null;
        _this.$updateSpan = null;
        _this.$indicatorContainer = null;
        _this.$overlay = null;
        _this.keypressCounter = 0;
        _this.lastKeyWasModified = false;
        _this.timeoutTime = 5000;
        _this.keypressTimeoutId = null;
        _this.timeoutMessageId = null;
        var $button = _this.$root.querySelector('.govuk-exit-this-page__button');
        if (!($button instanceof HTMLAnchorElement)) throw new (0, _indexMjs.ElementError)({
            component: ExitThisPage,
            element: $button,
            expectedType: 'HTMLAnchorElement',
            identifier: 'Button (`.govuk-exit-this-page__button`)'
        });
        _this.i18n = new (0, _i18NMjs.I18n)(_this.config.i18n);
        _this.$button = $button;
        var $skiplinkButton = document.querySelector('.govuk-js-exit-this-page-skiplink');
        if ($skiplinkButton instanceof HTMLAnchorElement) _this.$skiplinkButton = $skiplinkButton;
        _this.buildIndicator();
        _this.initUpdateSpan();
        _this.initButtonClickHandler();
        if (!('govukFrontendExitThisPageKeypress' in document.body.dataset)) {
            document.addEventListener('keyup', _this.handleKeypress.bind(_this), true);
            document.body.dataset.govukFrontendExitThisPageKeypress = 'true';
        }
        window.addEventListener('pageshow', _this.resetPage.bind(_this));
        return _this;
    }
    (0, _createClass._)(ExitThisPage, [
        {
            key: "initUpdateSpan",
            value: function initUpdateSpan() {
                this.$updateSpan = document.createElement('span');
                this.$updateSpan.setAttribute('role', 'status');
                this.$updateSpan.className = 'govuk-visually-hidden';
                this.$root.appendChild(this.$updateSpan);
            }
        },
        {
            key: "initButtonClickHandler",
            value: function initButtonClickHandler() {
                this.$button.addEventListener('click', this.handleClick.bind(this));
                if (this.$skiplinkButton) this.$skiplinkButton.addEventListener('click', this.handleClick.bind(this));
            }
        },
        {
            key: "buildIndicator",
            value: function buildIndicator() {
                this.$indicatorContainer = document.createElement('div');
                this.$indicatorContainer.className = 'govuk-exit-this-page__indicator';
                this.$indicatorContainer.setAttribute('aria-hidden', 'true');
                for(var i = 0; i < 3; i++){
                    var $indicator = document.createElement('div');
                    $indicator.className = 'govuk-exit-this-page__indicator-light';
                    this.$indicatorContainer.appendChild($indicator);
                }
                this.$button.appendChild(this.$indicatorContainer);
            }
        },
        {
            key: "updateIndicator",
            value: function updateIndicator() {
                var _this = this;
                if (!this.$indicatorContainer) return;
                this.$indicatorContainer.classList.toggle('govuk-exit-this-page__indicator--visible', this.keypressCounter > 0);
                var $indicators = this.$indicatorContainer.querySelectorAll('.govuk-exit-this-page__indicator-light');
                $indicators.forEach(function($indicator, index) {
                    $indicator.classList.toggle('govuk-exit-this-page__indicator-light--on', index < _this.keypressCounter);
                });
            }
        },
        {
            key: "exitPage",
            value: function exitPage() {
                if (!this.$updateSpan) return;
                this.$updateSpan.textContent = '';
                document.body.classList.add('govuk-exit-this-page-hide-content');
                this.$overlay = document.createElement('div');
                this.$overlay.className = 'govuk-exit-this-page-overlay';
                this.$overlay.setAttribute('role', 'alert');
                document.body.appendChild(this.$overlay);
                this.$overlay.textContent = this.i18n.t('activated');
                window.location.href = this.$button.href;
            }
        },
        {
            key: "handleClick",
            value: function handleClick(event) {
                event.preventDefault();
                this.exitPage();
            }
        },
        {
            key: "handleKeypress",
            value: function handleKeypress(event) {
                if (!this.$updateSpan) return;
                if (event.key === 'Shift' && !this.lastKeyWasModified) {
                    this.keypressCounter += 1;
                    this.updateIndicator();
                    if (this.timeoutMessageId) {
                        window.clearTimeout(this.timeoutMessageId);
                        this.timeoutMessageId = null;
                    }
                    if (this.keypressCounter >= 3) {
                        this.keypressCounter = 0;
                        if (this.keypressTimeoutId) {
                            window.clearTimeout(this.keypressTimeoutId);
                            this.keypressTimeoutId = null;
                        }
                        this.exitPage();
                    } else if (this.keypressCounter === 1) this.$updateSpan.textContent = this.i18n.t('pressTwoMoreTimes');
                    else this.$updateSpan.textContent = this.i18n.t('pressOneMoreTime');
                    this.setKeypressTimer();
                } else if (this.keypressTimeoutId) this.resetKeypressTimer();
                this.lastKeyWasModified = event.shiftKey;
            }
        },
        {
            key: "setKeypressTimer",
            value: function setKeypressTimer() {
                if (this.keypressTimeoutId) window.clearTimeout(this.keypressTimeoutId);
                this.keypressTimeoutId = window.setTimeout(this.resetKeypressTimer.bind(this), this.timeoutTime);
            }
        },
        {
            key: "resetKeypressTimer",
            value: function resetKeypressTimer() {
                if (!this.$updateSpan) return;
                if (this.keypressTimeoutId) {
                    window.clearTimeout(this.keypressTimeoutId);
                    this.keypressTimeoutId = null;
                }
                var $updateSpan = this.$updateSpan;
                this.keypressCounter = 0;
                $updateSpan.textContent = this.i18n.t('timedOut');
                this.timeoutMessageId = window.setTimeout(function() {
                    $updateSpan.textContent = '';
                }, this.timeoutTime);
                this.updateIndicator();
            }
        },
        {
            key: "resetPage",
            value: function resetPage() {
                document.body.classList.remove('govuk-exit-this-page-hide-content');
                if (this.$overlay) {
                    this.$overlay.remove();
                    this.$overlay = null;
                }
                if (this.$updateSpan) {
                    this.$updateSpan.setAttribute('role', 'status');
                    this.$updateSpan.textContent = '';
                }
                this.updateIndicator();
                if (this.keypressTimeoutId) window.clearTimeout(this.keypressTimeoutId);
                if (this.timeoutMessageId) window.clearTimeout(this.timeoutMessageId);
            }
        }
    ]);
    return ExitThisPage;
}((0, _configurationMjs.ConfigurableComponent));
/**
 * Exit this Page config
 *
 * @see {@link ExitThisPage.defaults}
 * @typedef {object} ExitThisPageConfig
 * @property {ExitThisPageTranslations} [i18n=ExitThisPage.defaults.i18n] - Exit this page translations
 */ /**
 * Exit this Page translations
 *
 * @see {@link ExitThisPage.defaults.i18n}
 * @typedef {object} ExitThisPageTranslations
 *
 * Messages used by the component programatically inserted text, including
 * overlay text and screen reader announcements.
 * @property {string} [activated] - Screen reader announcement for when EtP
 *   keypress functionality has been successfully activated.
 * @property {string} [timedOut] - Screen reader announcement for when the EtP
 *   keypress functionality has timed out.
 * @property {string} [pressTwoMoreTimes] - Screen reader announcement informing
 *   the user they must press the activation key two more times.
 * @property {string} [pressOneMoreTime] - Screen reader announcement informing
 *   the user they must press the activation key one more time.
 */ /**
 * @import { Schema } from '../../common/configuration.mjs'
 */ ExitThisPage.moduleName = 'govuk-exit-this-page';
ExitThisPage.defaults = Object.freeze({
    i18n: {
        activated: 'Loading.',
        timedOut: 'Exit this page expired.',
        pressTwoMoreTimes: 'Shift, press 2 more times to exit.',
        pressOneMoreTime: 'Shift, press 1 more time to exit.'
    }
});
ExitThisPage.schema = Object.freeze({
    properties: {
        i18n: {
            type: 'object'
        }
    }
});

},{"@swc/helpers/_/_call_super":"jbaHU","@swc/helpers/_/_class_call_check":"gDZPt","@swc/helpers/_/_create_class":"7MByf","@swc/helpers/_/_inherits":"lXwSH","../../common/configuration.mjs":"iQR6u","../../errors/index.mjs":"fYWJ8","../../i18n.mjs":"y8yul","@parcel/transformer-js/src/esmodule-helpers.js":"2qAMd"}],"aBOo0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @typedef {HTMLInputElement & {files: FileList}} HTMLFileInputElement
 */ /**
 * File upload config
 *
 * @see {@link FileUpload.defaults}
 * @typedef {object} FileUploadConfig
 * @property {FileUploadTranslations} [i18n=FileUpload.defaults.i18n] - File upload translations
 */ /**
 * File upload translations
 *
 * @see {@link FileUpload.defaults.i18n}
 * @typedef {object} FileUploadTranslations
 *
 * Messages used by the component
 * @property {string} [chooseFile] - The text of the button that opens the file picker
 * @property {string} [dropInstruction] - The text informing users they can drop files
 * @property {TranslationPluralForms} [multipleFilesChosen] - The text displayed when multiple files
 *   have been chosen by the user
 * @property {string} [noFileChosen] - The text to displayed when no file has been chosen by the user
 * @property {string} [enteredDropZone] - The text announced by assistive technology
 *   when user drags files and enters the drop zone
 * @property {string} [leftDropZone] - The text announced by assistive technology
 *   when user drags files and leaves the drop zone without dropping
 */ /**
 * @import { Schema } from '../../common/configuration.mjs'
 * @import { TranslationPluralForms } from '../../i18n.mjs'
 */ parcelHelpers.export(exports, "FileUpload", function() {
    return FileUpload;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _closestAttributeValueMjs = require("../../common/closest-attribute-value.mjs");
var _configurationMjs = require("../../common/configuration.mjs");
var _indexMjs = require("../../common/index.mjs");
var _indexMjs1 = require("../../errors/index.mjs");
var _i18NMjs = require("../../i18n.mjs");
/**
 * File upload component
 *
 * @preserve
 * @augments ConfigurableComponent<FileUploadConfig>
 */ var FileUpload = /*#__PURE__*/ function(ConfigurableComponent) {
    "use strict";
    (0, _inherits._)(FileUpload, ConfigurableComponent);
    function FileUpload($root) {
        var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, _classCallCheck._)(this, FileUpload);
        var _this;
        _this = (0, _callSuper._)(this, FileUpload, [
            $root,
            config
        ]);
        _this.$input = void 0;
        _this.$button = void 0;
        _this.$status = void 0;
        _this.i18n = void 0;
        _this.id = void 0;
        _this.$announcements = void 0;
        _this.enteredAnotherElement = void 0;
        var $input = _this.$root.querySelector('input');
        if ($input === null) throw new (0, _indexMjs1.ElementError)({
            component: FileUpload,
            identifier: 'File inputs (`<input type="file">`)'
        });
        if ($input.type !== 'file') throw new (0, _indexMjs1.ElementError)((0, _indexMjs.formatErrorMessage)(FileUpload, 'File input (`<input type="file">`) attribute (`type`) is not `file`'));
        _this.$input = $input;
        if (!_this.$input.id) throw new (0, _indexMjs1.ElementError)({
            component: FileUpload,
            identifier: 'File input (`<input type="file">`) attribute (`id`)'
        });
        _this.id = _this.$input.id;
        _this.i18n = new (0, _i18NMjs.I18n)(_this.config.i18n, {
            locale: (0, _closestAttributeValueMjs.closestAttributeValue)(_this.$root, 'lang')
        });
        var $label = _this.findLabel();
        if (!$label.id) $label.id = "".concat(_this.id, "-label");
        _this.$input.id = "".concat(_this.id, "-input");
        _this.$input.setAttribute('hidden', 'true');
        var $button = document.createElement('button');
        $button.classList.add('govuk-file-upload-button');
        $button.type = 'button';
        $button.id = _this.id;
        $button.classList.add('govuk-file-upload-button--empty');
        var ariaDescribedBy = _this.$input.getAttribute('aria-describedby');
        if (ariaDescribedBy) $button.setAttribute('aria-describedby', ariaDescribedBy);
        var $status = document.createElement('span');
        $status.className = 'govuk-body govuk-file-upload-button__status';
        $status.setAttribute('aria-live', 'polite');
        $status.innerText = _this.i18n.t('noFileChosen');
        $button.appendChild($status);
        var commaSpan = document.createElement('span');
        commaSpan.className = 'govuk-visually-hidden';
        commaSpan.innerText = ', ';
        commaSpan.id = "".concat(_this.id, "-comma");
        $button.appendChild(commaSpan);
        var containerSpan = document.createElement('span');
        containerSpan.className = 'govuk-file-upload-button__pseudo-button-container';
        var buttonSpan = document.createElement('span');
        buttonSpan.className = 'govuk-button govuk-button--secondary govuk-file-upload-button__pseudo-button';
        buttonSpan.innerText = _this.i18n.t('chooseFilesButton');
        containerSpan.appendChild(buttonSpan);
        containerSpan.insertAdjacentText('beforeend', ' ');
        var instructionSpan = document.createElement('span');
        instructionSpan.className = 'govuk-body govuk-file-upload-button__instruction';
        instructionSpan.innerText = _this.i18n.t('dropInstruction');
        containerSpan.appendChild(instructionSpan);
        $button.appendChild(containerSpan);
        $button.setAttribute('aria-labelledby', "".concat($label.id, " ").concat(commaSpan.id, " ").concat($button.id));
        $button.addEventListener('click', _this.onClick.bind(_this));
        $button.addEventListener('dragover', function(event) {
            event.preventDefault();
        });
        _this.$root.insertAdjacentElement('afterbegin', $button);
        _this.$input.setAttribute('tabindex', '-1');
        _this.$input.setAttribute('aria-hidden', 'true');
        _this.$button = $button;
        _this.$status = $status;
        _this.$input.addEventListener('change', _this.onChange.bind(_this));
        _this.updateDisabledState();
        _this.observeDisabledState();
        _this.$announcements = document.createElement('span');
        _this.$announcements.classList.add('govuk-file-upload-announcements');
        _this.$announcements.classList.add('govuk-visually-hidden');
        _this.$announcements.setAttribute('aria-live', 'assertive');
        _this.$root.insertAdjacentElement('afterend', _this.$announcements);
        _this.$button.addEventListener('drop', _this.onDrop.bind(_this));
        document.addEventListener('dragenter', _this.updateDropzoneVisibility.bind(_this));
        document.addEventListener('dragenter', function() {
            _this.enteredAnotherElement = true;
        });
        document.addEventListener('dragleave', function() {
            if (!_this.enteredAnotherElement && !_this.$button.disabled) {
                _this.hideDraggingState();
                _this.$announcements.innerText = _this.i18n.t('leftDropZone');
            }
            _this.enteredAnotherElement = false;
        });
        return _this;
    }
    (0, _createClass._)(FileUpload, [
        {
            key: "updateDropzoneVisibility",
            value: function updateDropzoneVisibility(event) {
                if (this.$button.disabled) return;
                if (event.target instanceof Node) {
                    if (this.$root.contains(event.target)) {
                        if (event.dataTransfer && this.canDrop(event.dataTransfer)) {
                            if (!this.$button.classList.contains('govuk-file-upload-button--dragging')) {
                                this.showDraggingState();
                                this.$announcements.innerText = this.i18n.t('enteredDropZone');
                            }
                        }
                    } else if (this.$button.classList.contains('govuk-file-upload-button--dragging')) {
                        this.hideDraggingState();
                        this.$announcements.innerText = this.i18n.t('leftDropZone');
                    }
                }
            }
        },
        {
            key: "showDraggingState",
            value: function showDraggingState() {
                this.$button.classList.add('govuk-file-upload-button--dragging');
            }
        },
        {
            key: "hideDraggingState",
            value: function hideDraggingState() {
                this.$button.classList.remove('govuk-file-upload-button--dragging');
            }
        },
        {
            key: "onDrop",
            value: function onDrop(event) {
                event.preventDefault();
                if (event.dataTransfer && this.canFillInput(event.dataTransfer)) {
                    this.$input.files = event.dataTransfer.files;
                    this.$input.dispatchEvent(new CustomEvent('change'));
                    this.hideDraggingState();
                }
            }
        },
        {
            key: "canFillInput",
            value: function canFillInput(dataTransfer) {
                return this.matchesInputCapacity(dataTransfer.files.length);
            }
        },
        {
            key: "canDrop",
            value: function canDrop(dataTransfer) {
                if (dataTransfer.items.length) return this.matchesInputCapacity(countFileItems(dataTransfer.items));
                if (dataTransfer.types.length) return dataTransfer.types.includes('Files');
                return true;
            }
        },
        {
            key: "matchesInputCapacity",
            value: function matchesInputCapacity(numberOfFiles) {
                if (this.$input.multiple) return numberOfFiles > 0;
                return numberOfFiles === 1;
            }
        },
        {
            key: "onChange",
            value: function onChange() {
                var fileCount = this.$input.files.length;
                if (fileCount === 0) {
                    this.$status.innerText = this.i18n.t('noFileChosen');
                    this.$button.classList.add('govuk-file-upload-button--empty');
                } else {
                    if (fileCount === 1) this.$status.innerText = this.$input.files[0].name;
                    else this.$status.innerText = this.i18n.t('multipleFilesChosen', {
                        count: fileCount
                    });
                    this.$button.classList.remove('govuk-file-upload-button--empty');
                }
            }
        },
        {
            key: "findLabel",
            value: function findLabel() {
                var $label = document.querySelector('label[for="'.concat(this.$input.id, '"]'));
                if (!$label) throw new (0, _indexMjs1.ElementError)({
                    component: FileUpload,
                    identifier: "Field label (`<label for=".concat(this.$input.id, ">`)")
                });
                return $label;
            }
        },
        {
            key: "onClick",
            value: function onClick() {
                this.$input.click();
            }
        },
        {
            key: "observeDisabledState",
            value: function observeDisabledState() {
                var _this = this;
                var observer = new MutationObserver(function(mutationList) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = mutationList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var mutation = _step.value;
                            if (mutation.type === 'attributes' && mutation.attributeName === 'disabled') _this.updateDisabledState();
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                });
                observer.observe(this.$input, {
                    attributes: true
                });
            }
        },
        {
            key: "updateDisabledState",
            value: function updateDisabledState() {
                this.$button.disabled = this.$input.disabled;
                this.$root.classList.toggle('govuk-drop-zone--disabled', this.$button.disabled);
            }
        }
    ]);
    return FileUpload;
}((0, _configurationMjs.ConfigurableComponent));
/**
 * Counts the number of `DataTransferItem` whose kind is `file`
 *
 * @param {DataTransferItemList} list - The list
 * @returns {number} - The number of items whose kind is `file` in the list
 */ FileUpload.moduleName = 'govuk-file-upload';
FileUpload.defaults = Object.freeze({
    i18n: {
        chooseFilesButton: 'Choose file',
        dropInstruction: 'or drop file',
        noFileChosen: 'No file chosen',
        multipleFilesChosen: {
            one: '%{count} file chosen',
            other: '%{count} files chosen'
        },
        enteredDropZone: 'Entered drop zone',
        leftDropZone: 'Left drop zone'
    }
});
FileUpload.schema = Object.freeze({
    properties: {
        i18n: {
            type: 'object'
        }
    }
});
function countFileItems(list) {
    var result = 0;
    for(var i = 0; i < list.length; i++)if (list[i].kind === 'file') result++;
    return result;
}

},{"@swc/helpers/_/_call_super":"jbaHU","@swc/helpers/_/_class_call_check":"gDZPt","@swc/helpers/_/_create_class":"7MByf","@swc/helpers/_/_inherits":"lXwSH","../../common/closest-attribute-value.mjs":"5pLlZ","../../common/configuration.mjs":"iQR6u","../../common/index.mjs":"hMIZ0","../../errors/index.mjs":"fYWJ8","../../i18n.mjs":"y8yul","@parcel/transformer-js/src/esmodule-helpers.js":"2qAMd"}],"hvSmM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Header", function() {
    return Header;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _possibleConstructorReturn = require("@swc/helpers/_/_possible_constructor_return");
var _indexMjs = require("../../common/index.mjs");
var _componentMjs = require("../../component.mjs");
var _indexMjs1 = require("../../errors/index.mjs");
/**
 * Header component
 *
 * @preserve
 */ var Header = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, _inherits._)(Header, Component);
    function Header($root) {
        (0, _classCallCheck._)(this, Header);
        var _this;
        _this = (0, _callSuper._)(this, Header, [
            $root
        ]);
        _this.$menuButton = void 0;
        _this.$menu = void 0;
        _this.menuIsOpen = false;
        _this.mql = null;
        var $menuButton = _this.$root.querySelector('.govuk-js-header-toggle');
        if (!$menuButton) return (0, _possibleConstructorReturn._)(_this, _this);
        _this.$root.classList.add('govuk-header--with-js-navigation');
        var menuId = $menuButton.getAttribute('aria-controls');
        if (!menuId) throw new (0, _indexMjs1.ElementError)({
            component: Header,
            identifier: 'Navigation button (`<button class="govuk-js-header-toggle">`) attribute (`aria-controls`)'
        });
        var $menu = document.getElementById(menuId);
        if (!$menu) throw new (0, _indexMjs1.ElementError)({
            component: Header,
            element: $menu,
            identifier: 'Navigation (`<ul id="'.concat(menuId, '">`)')
        });
        _this.$menu = $menu;
        _this.$menuButton = $menuButton;
        _this.setupResponsiveChecks();
        _this.$menuButton.addEventListener('click', function() {
            return _this.handleMenuButtonClick();
        });
        return _this;
    }
    (0, _createClass._)(Header, [
        {
            key: "setupResponsiveChecks",
            value: function setupResponsiveChecks() {
                var _this = this;
                var breakpoint = (0, _indexMjs.getBreakpoint)('desktop');
                if (!breakpoint.value) throw new (0, _indexMjs1.ElementError)({
                    component: Header,
                    identifier: "CSS custom property (`".concat(breakpoint.property, "`) on pseudo-class `:root`")
                });
                this.mql = window.matchMedia("(min-width: ".concat(breakpoint.value, ")"));
                if ('addEventListener' in this.mql) this.mql.addEventListener('change', function() {
                    return _this.checkMode();
                });
                else this.mql.addListener(function() {
                    return _this.checkMode();
                });
                this.checkMode();
            }
        },
        {
            key: "checkMode",
            value: function checkMode() {
                if (!this.mql || !this.$menu || !this.$menuButton) return;
                if (this.mql.matches) {
                    this.$menu.removeAttribute('hidden');
                    this.$menuButton.setAttribute('hidden', '');
                } else {
                    this.$menuButton.removeAttribute('hidden');
                    this.$menuButton.setAttribute('aria-expanded', this.menuIsOpen.toString());
                    if (this.menuIsOpen) this.$menu.removeAttribute('hidden');
                    else this.$menu.setAttribute('hidden', '');
                }
            }
        },
        {
            key: "handleMenuButtonClick",
            value: function handleMenuButtonClick() {
                this.menuIsOpen = !this.menuIsOpen;
                this.checkMode();
            }
        }
    ]);
    return Header;
}((0, _componentMjs.Component));
Header.moduleName = 'govuk-header';

},{"@swc/helpers/_/_call_super":"jbaHU","@swc/helpers/_/_class_call_check":"gDZPt","@swc/helpers/_/_create_class":"7MByf","@swc/helpers/_/_inherits":"lXwSH","@swc/helpers/_/_possible_constructor_return":"labyA","../../common/index.mjs":"hMIZ0","../../component.mjs":"VCgbS","../../errors/index.mjs":"fYWJ8","@parcel/transformer-js/src/esmodule-helpers.js":"2qAMd"}],"8sb1f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NotificationBanner", function() {
    return NotificationBanner;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _inherits = require("@swc/helpers/_/_inherits");
var _configurationMjs = require("../../common/configuration.mjs");
var _indexMjs = require("../../common/index.mjs");
/**
 * Notification Banner component
 *
 * @preserve
 * @augments ConfigurableComponent<NotificationBannerConfig>
 */ var NotificationBanner = /*#__PURE__*/ function(ConfigurableComponent) {
    "use strict";
    (0, _inherits._)(NotificationBanner, ConfigurableComponent);
    function NotificationBanner($root) {
        var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, _classCallCheck._)(this, NotificationBanner);
        var _this;
        _this = (0, _callSuper._)(this, NotificationBanner, [
            $root,
            config
        ]);
        if (_this.$root.getAttribute('role') === 'alert' && !_this.config.disableAutoFocus) (0, _indexMjs.setFocus)(_this.$root);
        return _this;
    }
    return NotificationBanner;
}((0, _configurationMjs.ConfigurableComponent));
/**
 * Notification banner config
 *
 * @typedef {object} NotificationBannerConfig
 * @property {boolean} [disableAutoFocus=false] - If set to `true` the
 *   notification banner will not be focussed when the page loads. This only
 *   applies if the component has a `role` of `alert` – in other cases the
 *   component will not be focused on page load, regardless of this option.
 */ /**
 * @import { Schema } from '../../common/configuration.mjs'
 */ NotificationBanner.moduleName = 'govuk-notification-banner';
NotificationBanner.defaults = Object.freeze({
    disableAutoFocus: false
});
NotificationBanner.schema = Object.freeze({
    properties: {
        disableAutoFocus: {
            type: 'boolean'
        }
    }
});

},{"@swc/helpers/_/_call_super":"jbaHU","@swc/helpers/_/_class_call_check":"gDZPt","@swc/helpers/_/_inherits":"lXwSH","../../common/configuration.mjs":"iQR6u","../../common/index.mjs":"hMIZ0","@parcel/transformer-js/src/esmodule-helpers.js":"2qAMd"}],"5Yenz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PasswordInput", function() {
    return PasswordInput;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _closestAttributeValueMjs = require("../../common/closest-attribute-value.mjs");
var _configurationMjs = require("../../common/configuration.mjs");
var _indexMjs = require("../../errors/index.mjs");
var _i18NMjs = require("../../i18n.mjs");
/**
 * Password input component
 *
 * @preserve
 * @augments ConfigurableComponent<PasswordInputConfig>
 */ var PasswordInput = /*#__PURE__*/ function(ConfigurableComponent) {
    "use strict";
    (0, _inherits._)(PasswordInput, ConfigurableComponent);
    function PasswordInput($root) {
        var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, _classCallCheck._)(this, PasswordInput);
        var _this;
        _this = (0, _callSuper._)(this, PasswordInput, [
            $root,
            config
        ]);
        _this.i18n = void 0;
        _this.$input = void 0;
        _this.$showHideButton = void 0;
        _this.$screenReaderStatusMessage = void 0;
        var $input = _this.$root.querySelector('.govuk-js-password-input-input');
        if (!($input instanceof HTMLInputElement)) throw new (0, _indexMjs.ElementError)({
            component: PasswordInput,
            element: $input,
            expectedType: 'HTMLInputElement',
            identifier: 'Form field (`.govuk-js-password-input-input`)'
        });
        if ($input.type !== 'password') throw new (0, _indexMjs.ElementError)('Password input: Form field (`.govuk-js-password-input-input`) must be of type `password`.');
        var $showHideButton = _this.$root.querySelector('.govuk-js-password-input-toggle');
        if (!($showHideButton instanceof HTMLButtonElement)) throw new (0, _indexMjs.ElementError)({
            component: PasswordInput,
            element: $showHideButton,
            expectedType: 'HTMLButtonElement',
            identifier: 'Button (`.govuk-js-password-input-toggle`)'
        });
        if ($showHideButton.type !== 'button') throw new (0, _indexMjs.ElementError)('Password input: Button (`.govuk-js-password-input-toggle`) must be of type `button`.');
        _this.$input = $input;
        _this.$showHideButton = $showHideButton;
        _this.i18n = new (0, _i18NMjs.I18n)(_this.config.i18n, {
            locale: (0, _closestAttributeValueMjs.closestAttributeValue)(_this.$root, 'lang')
        });
        _this.$showHideButton.removeAttribute('hidden');
        var $screenReaderStatusMessage = document.createElement('div');
        $screenReaderStatusMessage.className = 'govuk-password-input__sr-status govuk-visually-hidden';
        $screenReaderStatusMessage.setAttribute('aria-live', 'polite');
        _this.$screenReaderStatusMessage = $screenReaderStatusMessage;
        _this.$input.insertAdjacentElement('afterend', $screenReaderStatusMessage);
        _this.$showHideButton.addEventListener('click', _this.toggle.bind(_this));
        if (_this.$input.form) _this.$input.form.addEventListener('submit', function() {
            return _this.hide();
        });
        window.addEventListener('pageshow', function(event) {
            if (event.persisted && _this.$input.type !== 'password') _this.hide();
        });
        _this.hide();
        return _this;
    }
    (0, _createClass._)(PasswordInput, [
        {
            key: "toggle",
            value: function toggle(event) {
                event.preventDefault();
                if (this.$input.type === 'password') {
                    this.show();
                    return;
                }
                this.hide();
            }
        },
        {
            key: "show",
            value: function show() {
                this.setType('text');
            }
        },
        {
            key: "hide",
            value: function hide() {
                this.setType('password');
            }
        },
        {
            key: "setType",
            value: function setType(type) {
                if (type === this.$input.type) return;
                this.$input.setAttribute('type', type);
                var isHidden = type === 'password';
                var prefixButton = isHidden ? 'show' : 'hide';
                var prefixStatus = isHidden ? 'passwordHidden' : 'passwordShown';
                this.$showHideButton.innerText = this.i18n.t("".concat(prefixButton, "Password"));
                this.$showHideButton.setAttribute('aria-label', this.i18n.t("".concat(prefixButton, "PasswordAriaLabel")));
                this.$screenReaderStatusMessage.innerText = this.i18n.t("".concat(prefixStatus, "Announcement"));
            }
        }
    ]);
    return PasswordInput;
}((0, _configurationMjs.ConfigurableComponent));
/**
 * Password input config
 *
 * @typedef {object} PasswordInputConfig
 * @property {PasswordInputTranslations} [i18n=PasswordInput.defaults.i18n] - Password input translations
 */ /**
 * Password input translations
 *
 * @see {@link PasswordInput.defaults.i18n}
 * @typedef {object} PasswordInputTranslations
 *
 * Messages displayed to the user indicating the state of the show/hide toggle.
 * @property {string} [showPassword] - Visible text of the button when the
 *   password is currently hidden. Plain text only.
 * @property {string} [hidePassword] - Visible text of the button when the
 *   password is currently visible. Plain text only.
 * @property {string} [showPasswordAriaLabel] - aria-label of the button when
 *   the password is currently hidden. Plain text only.
 * @property {string} [hidePasswordAriaLabel] - aria-label of the button when
 *   the password is currently visible. Plain text only.
 * @property {string} [passwordShownAnnouncement] - Screen reader
 *   announcement to make when the password has just become visible.
 *   Plain text only.
 * @property {string} [passwordHiddenAnnouncement] - Screen reader
 *   announcement to make when the password has just been hidden.
 *   Plain text only.
 */ /**
 * @import { Schema } from '../../common/configuration.mjs'
 */ PasswordInput.moduleName = 'govuk-password-input';
PasswordInput.defaults = Object.freeze({
    i18n: {
        showPassword: 'Show',
        hidePassword: 'Hide',
        showPasswordAriaLabel: 'Show password',
        hidePasswordAriaLabel: 'Hide password',
        passwordShownAnnouncement: 'Your password is visible',
        passwordHiddenAnnouncement: 'Your password is hidden'
    }
});
PasswordInput.schema = Object.freeze({
    properties: {
        i18n: {
            type: 'object'
        }
    }
});

},{"@swc/helpers/_/_call_super":"jbaHU","@swc/helpers/_/_class_call_check":"gDZPt","@swc/helpers/_/_create_class":"7MByf","@swc/helpers/_/_inherits":"lXwSH","../../common/closest-attribute-value.mjs":"5pLlZ","../../common/configuration.mjs":"iQR6u","../../errors/index.mjs":"fYWJ8","../../i18n.mjs":"y8yul","@parcel/transformer-js/src/esmodule-helpers.js":"2qAMd"}],"gWpiP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Radios", function() {
    return Radios;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _componentMjs = require("../../component.mjs");
var _indexMjs = require("../../errors/index.mjs");
/**
 * Radios component
 *
 * @preserve
 */ var Radios = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, _inherits._)(Radios, Component);
    function Radios($root) {
        (0, _classCallCheck._)(this, Radios);
        var _this;
        _this = (0, _callSuper._)(this, Radios, [
            $root
        ]);
        _this.$inputs = void 0;
        var $inputs = _this.$root.querySelectorAll('input[type="radio"]');
        if (!$inputs.length) throw new (0, _indexMjs.ElementError)({
            component: Radios,
            identifier: 'Form inputs (`<input type="radio">`)'
        });
        _this.$inputs = $inputs;
        _this.$inputs.forEach(function($input) {
            var targetId = $input.getAttribute('data-aria-controls');
            if (!targetId) return;
            if (!document.getElementById(targetId)) throw new (0, _indexMjs.ElementError)({
                component: Radios,
                identifier: 'Conditional reveal (`id="'.concat(targetId, '"`)')
            });
            $input.setAttribute('aria-controls', targetId);
            $input.removeAttribute('data-aria-controls');
        });
        window.addEventListener('pageshow', function() {
            return _this.syncAllConditionalReveals();
        });
        _this.syncAllConditionalReveals();
        _this.$root.addEventListener('click', function(event) {
            return _this.handleClick(event);
        });
        return _this;
    }
    (0, _createClass._)(Radios, [
        {
            key: "syncAllConditionalReveals",
            value: function syncAllConditionalReveals() {
                var _this = this;
                this.$inputs.forEach(function($input) {
                    return _this.syncConditionalRevealWithInputState($input);
                });
            }
        },
        {
            key: "syncConditionalRevealWithInputState",
            value: function syncConditionalRevealWithInputState($input) {
                var targetId = $input.getAttribute('aria-controls');
                if (!targetId) return;
                var $target = document.getElementById(targetId);
                if ($target != null && $target.classList.contains('govuk-radios__conditional')) {
                    var inputIsChecked = $input.checked;
                    $input.setAttribute('aria-expanded', inputIsChecked.toString());
                    $target.classList.toggle('govuk-radios__conditional--hidden', !inputIsChecked);
                }
            }
        },
        {
            key: "handleClick",
            value: function handleClick(event) {
                var _this = this;
                var $clickedInput = event.target;
                if (!($clickedInput instanceof HTMLInputElement) || $clickedInput.type !== 'radio') return;
                var $allInputs = document.querySelectorAll('input[type="radio"][aria-controls]');
                var $clickedInputForm = $clickedInput.form;
                var $clickedInputName = $clickedInput.name;
                $allInputs.forEach(function($input) {
                    var hasSameFormOwner = $input.form === $clickedInputForm;
                    var hasSameName = $input.name === $clickedInputName;
                    if (hasSameName && hasSameFormOwner) _this.syncConditionalRevealWithInputState($input);
                });
            }
        }
    ]);
    return Radios;
}((0, _componentMjs.Component));
Radios.moduleName = 'govuk-radios';

},{"@swc/helpers/_/_call_super":"jbaHU","@swc/helpers/_/_class_call_check":"gDZPt","@swc/helpers/_/_create_class":"7MByf","@swc/helpers/_/_inherits":"lXwSH","../../component.mjs":"VCgbS","../../errors/index.mjs":"fYWJ8","@parcel/transformer-js/src/esmodule-helpers.js":"2qAMd"}],"7jdp8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ServiceNavigation", function() {
    return ServiceNavigation;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _possibleConstructorReturn = require("@swc/helpers/_/_possible_constructor_return");
var _indexMjs = require("../../common/index.mjs");
var _componentMjs = require("../../component.mjs");
var _indexMjs1 = require("../../errors/index.mjs");
/**
 * Service Navigation component
 *
 * @preserve
 */ var ServiceNavigation = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, _inherits._)(ServiceNavigation, Component);
    function ServiceNavigation($root) {
        (0, _classCallCheck._)(this, ServiceNavigation);
        var _this;
        _this = (0, _callSuper._)(this, ServiceNavigation, [
            $root
        ]);
        _this.$menuButton = void 0;
        _this.$menu = void 0;
        _this.menuIsOpen = false;
        _this.mql = null;
        var $menuButton = _this.$root.querySelector('.govuk-js-service-navigation-toggle');
        if (!$menuButton) return (0, _possibleConstructorReturn._)(_this, _this);
        var menuId = $menuButton.getAttribute('aria-controls');
        if (!menuId) throw new (0, _indexMjs1.ElementError)({
            component: ServiceNavigation,
            identifier: 'Navigation button (`<button class="govuk-js-service-navigation-toggle">`) attribute (`aria-controls`)'
        });
        var $menu = document.getElementById(menuId);
        if (!$menu) throw new (0, _indexMjs1.ElementError)({
            component: ServiceNavigation,
            element: $menu,
            identifier: 'Navigation (`<ul id="'.concat(menuId, '">`)')
        });
        _this.$menu = $menu;
        _this.$menuButton = $menuButton;
        _this.setupResponsiveChecks();
        _this.$menuButton.addEventListener('click', function() {
            return _this.handleMenuButtonClick();
        });
        return _this;
    }
    (0, _createClass._)(ServiceNavigation, [
        {
            key: "setupResponsiveChecks",
            value: function setupResponsiveChecks() {
                var _this = this;
                var breakpoint = (0, _indexMjs.getBreakpoint)('tablet');
                if (!breakpoint.value) throw new (0, _indexMjs1.ElementError)({
                    component: ServiceNavigation,
                    identifier: "CSS custom property (`".concat(breakpoint.property, "`) on pseudo-class `:root`")
                });
                this.mql = window.matchMedia("(min-width: ".concat(breakpoint.value, ")"));
                if ('addEventListener' in this.mql) this.mql.addEventListener('change', function() {
                    return _this.checkMode();
                });
                else this.mql.addListener(function() {
                    return _this.checkMode();
                });
                this.checkMode();
            }
        },
        {
            key: "checkMode",
            value: function checkMode() {
                if (!this.mql || !this.$menu || !this.$menuButton) return;
                if (this.mql.matches) {
                    this.$menu.removeAttribute('hidden');
                    setAttributes(this.$menuButton, attributesForHidingButton);
                } else {
                    removeAttributes(this.$menuButton, Object.keys(attributesForHidingButton));
                    this.$menuButton.setAttribute('aria-expanded', this.menuIsOpen.toString());
                    if (this.menuIsOpen) this.$menu.removeAttribute('hidden');
                    else this.$menu.setAttribute('hidden', '');
                }
            }
        },
        {
            key: "handleMenuButtonClick",
            value: function handleMenuButtonClick() {
                this.menuIsOpen = !this.menuIsOpen;
                this.checkMode();
            }
        }
    ]);
    return ServiceNavigation;
}((0, _componentMjs.Component));
ServiceNavigation.moduleName = 'govuk-service-navigation';
var attributesForHidingButton = {
    hidden: '',
    'aria-hidden': 'true'
};
/**
 * Sets a group of attributes on the given element
 *
 * @param {Element} $element - The element to set the attribute on
 * @param {{[attributeName: string]: string}} attributes - The attributes to set
 */ function setAttributes($element, attributes) {
    for(var attributeName in attributes)$element.setAttribute(attributeName, attributes[attributeName]);
}
/**
 * Removes a list of attributes from the given element
 *
 * @param {Element} $element - The element to remove the attributes from
 * @param {string[]} attributeNames - The names of the attributes to remove
 */ function removeAttributes($element, attributeNames) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = attributeNames[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var attributeName = _step.value;
            $element.removeAttribute(attributeName);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}

},{"@swc/helpers/_/_call_super":"jbaHU","@swc/helpers/_/_class_call_check":"gDZPt","@swc/helpers/_/_create_class":"7MByf","@swc/helpers/_/_inherits":"lXwSH","@swc/helpers/_/_possible_constructor_return":"labyA","../../common/index.mjs":"hMIZ0","../../component.mjs":"VCgbS","../../errors/index.mjs":"fYWJ8","@parcel/transformer-js/src/esmodule-helpers.js":"2qAMd"}],"kDOrc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SkipLink", function() {
    return SkipLink;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _inherits = require("@swc/helpers/_/_inherits");
var _possibleConstructorReturn = require("@swc/helpers/_/_possible_constructor_return");
var _indexMjs = require("../../common/index.mjs");
var _componentMjs = require("../../component.mjs");
var _indexMjs1 = require("../../errors/index.mjs");
/**
 * Skip link component
 *
 * @preserve
 * @augments Component<HTMLAnchorElement>
 */ var SkipLink = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, _inherits._)(SkipLink, Component);
    function SkipLink($root) {
        (0, _classCallCheck._)(this, SkipLink);
        var _this;
        var _this$$root$getAttrib;
        _this = (0, _callSuper._)(this, SkipLink, [
            $root
        ]);
        var hash = _this.$root.hash;
        var href = (_this$$root$getAttrib = _this.$root.getAttribute('href')) != null ? _this$$root$getAttrib : '';
        if (_this.$root.origin !== window.location.origin || _this.$root.pathname !== window.location.pathname) return (0, _possibleConstructorReturn._)(_this);
        var linkedElementId = hash.replace('#', '');
        if (!linkedElementId) throw new (0, _indexMjs1.ElementError)('Skip link: Target link (`href="'.concat(href, '"`) has no hash fragment'));
        var $linkedElement = document.getElementById(linkedElementId);
        if (!$linkedElement) throw new (0, _indexMjs1.ElementError)({
            component: SkipLink,
            element: $linkedElement,
            identifier: 'Target content (`id="'.concat(linkedElementId, '"`)')
        });
        _this.$root.addEventListener('click', function() {
            return (0, _indexMjs.setFocus)($linkedElement, {
                onBeforeFocus: function() {
                    $linkedElement.classList.add('govuk-skip-link-focused-element');
                },
                onBlur: function() {
                    $linkedElement.classList.remove('govuk-skip-link-focused-element');
                }
            });
        });
        return _this;
    }
    return SkipLink;
}((0, _componentMjs.Component));
SkipLink.elementType = HTMLAnchorElement;
SkipLink.moduleName = 'govuk-skip-link';

},{"@swc/helpers/_/_call_super":"jbaHU","@swc/helpers/_/_class_call_check":"gDZPt","@swc/helpers/_/_inherits":"lXwSH","@swc/helpers/_/_possible_constructor_return":"labyA","../../common/index.mjs":"hMIZ0","../../component.mjs":"VCgbS","../../errors/index.mjs":"fYWJ8","@parcel/transformer-js/src/esmodule-helpers.js":"2qAMd"}],"3PGhh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Tabs", function() {
    return Tabs;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _indexMjs = require("../../common/index.mjs");
var _componentMjs = require("../../component.mjs");
var _indexMjs1 = require("../../errors/index.mjs");
/**
 * Tabs component
 *
 * @preserve
 */ var Tabs = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, _inherits._)(Tabs, Component);
    function Tabs($root) {
        (0, _classCallCheck._)(this, Tabs);
        var _this;
        _this = (0, _callSuper._)(this, Tabs, [
            $root
        ]);
        _this.$tabs = void 0;
        _this.$tabList = void 0;
        _this.$tabListItems = void 0;
        _this.jsHiddenClass = 'govuk-tabs__panel--hidden';
        _this.changingHash = false;
        _this.boundTabClick = void 0;
        _this.boundTabKeydown = void 0;
        _this.boundOnHashChange = void 0;
        _this.mql = null;
        var $tabs = _this.$root.querySelectorAll('a.govuk-tabs__tab');
        if (!$tabs.length) throw new (0, _indexMjs1.ElementError)({
            component: Tabs,
            identifier: 'Links (`<a class="govuk-tabs__tab">`)'
        });
        _this.$tabs = $tabs;
        _this.boundTabClick = _this.onTabClick.bind(_this);
        _this.boundTabKeydown = _this.onTabKeydown.bind(_this);
        _this.boundOnHashChange = _this.onHashChange.bind(_this);
        var $tabList = _this.$root.querySelector('.govuk-tabs__list');
        var $tabListItems = _this.$root.querySelectorAll('li.govuk-tabs__list-item');
        if (!$tabList) throw new (0, _indexMjs1.ElementError)({
            component: Tabs,
            identifier: 'List (`<ul class="govuk-tabs__list">`)'
        });
        if (!$tabListItems.length) throw new (0, _indexMjs1.ElementError)({
            component: Tabs,
            identifier: 'List items (`<li class="govuk-tabs__list-item">`)'
        });
        _this.$tabList = $tabList;
        _this.$tabListItems = $tabListItems;
        _this.setupResponsiveChecks();
        return _this;
    }
    (0, _createClass._)(Tabs, [
        {
            key: "setupResponsiveChecks",
            value: function setupResponsiveChecks() {
                var _this = this;
                var breakpoint = (0, _indexMjs.getBreakpoint)('tablet');
                if (!breakpoint.value) throw new (0, _indexMjs1.ElementError)({
                    component: Tabs,
                    identifier: "CSS custom property (`".concat(breakpoint.property, "`) on pseudo-class `:root`")
                });
                this.mql = window.matchMedia("(min-width: ".concat(breakpoint.value, ")"));
                if ('addEventListener' in this.mql) this.mql.addEventListener('change', function() {
                    return _this.checkMode();
                });
                else this.mql.addListener(function() {
                    return _this.checkMode();
                });
                this.checkMode();
            }
        },
        {
            key: "checkMode",
            value: function checkMode() {
                var _this$mql;
                if ((_this$mql = this.mql) != null && _this$mql.matches) this.setup();
                else this.teardown();
            }
        },
        {
            key: "setup",
            value: function setup() {
                var _this = this;
                var _this$getTab;
                this.$tabList.setAttribute('role', 'tablist');
                this.$tabListItems.forEach(function($item) {
                    $item.setAttribute('role', 'presentation');
                });
                this.$tabs.forEach(function($tab) {
                    _this.setAttributes($tab);
                    $tab.addEventListener('click', _this.boundTabClick, true);
                    $tab.addEventListener('keydown', _this.boundTabKeydown, true);
                    _this.hideTab($tab);
                });
                var $activeTab = (_this$getTab = this.getTab(window.location.hash)) != null ? _this$getTab : this.$tabs[0];
                this.showTab($activeTab);
                window.addEventListener('hashchange', this.boundOnHashChange, true);
            }
        },
        {
            key: "teardown",
            value: function teardown() {
                var _this = this;
                this.$tabList.removeAttribute('role');
                this.$tabListItems.forEach(function($item) {
                    $item.removeAttribute('role');
                });
                this.$tabs.forEach(function($tab) {
                    $tab.removeEventListener('click', _this.boundTabClick, true);
                    $tab.removeEventListener('keydown', _this.boundTabKeydown, true);
                    _this.unsetAttributes($tab);
                });
                window.removeEventListener('hashchange', this.boundOnHashChange, true);
            }
        },
        {
            key: "onHashChange",
            value: function onHashChange() {
                var hash = window.location.hash;
                var $tabWithHash = this.getTab(hash);
                if (!$tabWithHash) return;
                if (this.changingHash) {
                    this.changingHash = false;
                    return;
                }
                var $previousTab = this.getCurrentTab();
                if (!$previousTab) return;
                this.hideTab($previousTab);
                this.showTab($tabWithHash);
                $tabWithHash.focus();
            }
        },
        {
            key: "hideTab",
            value: function hideTab($tab) {
                this.unhighlightTab($tab);
                this.hidePanel($tab);
            }
        },
        {
            key: "showTab",
            value: function showTab($tab) {
                this.highlightTab($tab);
                this.showPanel($tab);
            }
        },
        {
            key: "getTab",
            value: function getTab(hash) {
                return this.$root.querySelector('a.govuk-tabs__tab[href="'.concat(hash, '"]'));
            }
        },
        {
            key: "setAttributes",
            value: function setAttributes($tab) {
                var panelId = $tab.hash.replace('#', '');
                if (!panelId) return;
                $tab.setAttribute('id', "tab_".concat(panelId));
                $tab.setAttribute('role', 'tab');
                $tab.setAttribute('aria-controls', panelId);
                $tab.setAttribute('aria-selected', 'false');
                $tab.setAttribute('tabindex', '-1');
                var $panel = this.getPanel($tab);
                if (!$panel) return;
                $panel.setAttribute('role', 'tabpanel');
                $panel.setAttribute('aria-labelledby', $tab.id);
                $panel.classList.add(this.jsHiddenClass);
            }
        },
        {
            key: "unsetAttributes",
            value: function unsetAttributes($tab) {
                $tab.removeAttribute('id');
                $tab.removeAttribute('role');
                $tab.removeAttribute('aria-controls');
                $tab.removeAttribute('aria-selected');
                $tab.removeAttribute('tabindex');
                var $panel = this.getPanel($tab);
                if (!$panel) return;
                $panel.removeAttribute('role');
                $panel.removeAttribute('aria-labelledby');
                $panel.classList.remove(this.jsHiddenClass);
            }
        },
        {
            key: "onTabClick",
            value: function onTabClick(event) {
                var $currentTab = this.getCurrentTab();
                var $nextTab = event.currentTarget;
                if (!$currentTab || !($nextTab instanceof HTMLAnchorElement)) return;
                event.preventDefault();
                this.hideTab($currentTab);
                this.showTab($nextTab);
                this.createHistoryEntry($nextTab);
            }
        },
        {
            key: "createHistoryEntry",
            value: function createHistoryEntry($tab) {
                var $panel = this.getPanel($tab);
                if (!$panel) return;
                var panelId = $panel.id;
                $panel.id = '';
                this.changingHash = true;
                window.location.hash = panelId;
                $panel.id = panelId;
            }
        },
        {
            key: "onTabKeydown",
            value: function onTabKeydown(event) {
                switch(event.key){
                    case 'ArrowLeft':
                    case 'Left':
                        this.activatePreviousTab();
                        event.preventDefault();
                        break;
                    case 'ArrowRight':
                    case 'Right':
                        this.activateNextTab();
                        event.preventDefault();
                        break;
                }
            }
        },
        {
            key: "activateNextTab",
            value: function activateNextTab() {
                var $currentTab = this.getCurrentTab();
                if (!($currentTab != null && $currentTab.parentElement)) return;
                var $nextTabListItem = $currentTab.parentElement.nextElementSibling;
                if (!$nextTabListItem) return;
                var $nextTab = $nextTabListItem.querySelector('a.govuk-tabs__tab');
                if (!$nextTab) return;
                this.hideTab($currentTab);
                this.showTab($nextTab);
                $nextTab.focus();
                this.createHistoryEntry($nextTab);
            }
        },
        {
            key: "activatePreviousTab",
            value: function activatePreviousTab() {
                var $currentTab = this.getCurrentTab();
                if (!($currentTab != null && $currentTab.parentElement)) return;
                var $previousTabListItem = $currentTab.parentElement.previousElementSibling;
                if (!$previousTabListItem) return;
                var $previousTab = $previousTabListItem.querySelector('a.govuk-tabs__tab');
                if (!$previousTab) return;
                this.hideTab($currentTab);
                this.showTab($previousTab);
                $previousTab.focus();
                this.createHistoryEntry($previousTab);
            }
        },
        {
            key: "getPanel",
            value: function getPanel($tab) {
                var panelId = $tab.hash.replace('#', '');
                if (!panelId) return null;
                return this.$root.querySelector("#".concat(panelId));
            }
        },
        {
            key: "showPanel",
            value: function showPanel($tab) {
                var $panel = this.getPanel($tab);
                if (!$panel) return;
                $panel.classList.remove(this.jsHiddenClass);
            }
        },
        {
            key: "hidePanel",
            value: function hidePanel($tab) {
                var $panel = this.getPanel($tab);
                if (!$panel) return;
                $panel.classList.add(this.jsHiddenClass);
            }
        },
        {
            key: "unhighlightTab",
            value: function unhighlightTab($tab) {
                if (!$tab.parentElement) return;
                $tab.setAttribute('aria-selected', 'false');
                $tab.parentElement.classList.remove('govuk-tabs__list-item--selected');
                $tab.setAttribute('tabindex', '-1');
            }
        },
        {
            key: "highlightTab",
            value: function highlightTab($tab) {
                if (!$tab.parentElement) return;
                $tab.setAttribute('aria-selected', 'true');
                $tab.parentElement.classList.add('govuk-tabs__list-item--selected');
                $tab.setAttribute('tabindex', '0');
            }
        },
        {
            key: "getCurrentTab",
            value: function getCurrentTab() {
                return this.$root.querySelector('.govuk-tabs__list-item--selected a.govuk-tabs__tab');
            }
        }
    ]);
    return Tabs;
}((0, _componentMjs.Component));
Tabs.moduleName = 'govuk-tabs';

},{"@swc/helpers/_/_call_super":"jbaHU","@swc/helpers/_/_class_call_check":"gDZPt","@swc/helpers/_/_create_class":"7MByf","@swc/helpers/_/_inherits":"lXwSH","../../common/index.mjs":"hMIZ0","../../component.mjs":"VCgbS","../../errors/index.mjs":"fYWJ8","@parcel/transformer-js/src/esmodule-helpers.js":"2qAMd"}],"9fVIs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @typedef {{new (...args: any[]): any, moduleName: string}} CompatibleClass
 */ /**
 * Config for all components via `initAll()`
 *
 * @typedef {object} Config
 * @property {Element | Document | null} [scope] - Scope of the document to search within
 * @property {OnErrorCallback<CompatibleClass>} [onError] - Initialisation error callback
 * @property {AccordionConfig} [accordion] - Accordion config
 * @property {ButtonConfig} [button] - Button config
 * @property {CharacterCountConfig} [characterCount] - Character Count config
 * @property {ErrorSummaryConfig} [errorSummary] - Error Summary config
 * @property {ExitThisPageConfig} [exitThisPage] - Exit This Page config
 * @property {FileUploadConfig} [fileUpload] - File Upload config
 * @property {NotificationBannerConfig} [notificationBanner] - Notification Banner config
 * @property {PasswordInputConfig} [passwordInput] - Password input config
 */ /**
 * Config for individual components
 *
 * @import { AccordionConfig } from './components/accordion/accordion.mjs'
 * @import { ButtonConfig } from './components/button/button.mjs'
 * @import { CharacterCountConfig } from './components/character-count/character-count.mjs'
 * @import { ErrorSummaryConfig } from './components/error-summary/error-summary.mjs'
 * @import { ExitThisPageConfig } from './components/exit-this-page/exit-this-page.mjs'
 * @import { NotificationBannerConfig } from './components/notification-banner/notification-banner.mjs'
 * @import { PasswordInputConfig } from './components/password-input/password-input.mjs'
 * @import { FileUploadConfig } from './components/file-upload/file-upload.mjs'
 */ /**
 * Component config keys, e.g. `accordion` and `characterCount`
 *
 * @typedef {keyof Omit<Config, 'scope' | 'onError'>} ConfigKey
 */ /**
 * @template {CompatibleClass} ComponentClass
 * @typedef {ConstructorParameters<ComponentClass>[1]} ComponentConfig
 */ /**
 * @template {CompatibleClass} ComponentClass
 * @typedef {object} ErrorContext
 * @property {Element} [element] - Element used for component module initialisation
 * @property {ComponentClass} [component] - Class of component
 * @property {Config | ComponentConfig<ComponentClass>} [config] - Config supplied to components
 */ /**
 * @template {CompatibleClass} ComponentClass
 * @callback OnErrorCallback
 * @param {unknown} error - Thrown error
 * @param {ErrorContext<ComponentClass>} context - Object containing the element, component class and configuration
 */ /**
 * @template {CompatibleClass} ComponentClass
 * @typedef {object} CreateAllOptions
 * @property {Element | Document | null} [scope] - scope of the document to search within
 * @property {OnErrorCallback<ComponentClass>} [onError] - callback function if error throw by component on init
 */ parcelHelpers.export(exports, "createAll", function() {
    return createAll;
});
parcelHelpers.export(exports, "initAll", function() {
    return initAll;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _configurationMjs = require("./common/configuration.mjs");
var _indexMjs = require("./common/index.mjs");
var _accordionMjs = require("./components/accordion/accordion.mjs");
var _buttonMjs = require("./components/button/button.mjs");
var _characterCountMjs = require("./components/character-count/character-count.mjs");
var _checkboxesMjs = require("./components/checkboxes/checkboxes.mjs");
var _errorSummaryMjs = require("./components/error-summary/error-summary.mjs");
var _exitThisPageMjs = require("./components/exit-this-page/exit-this-page.mjs");
var _fileUploadMjs = require("./components/file-upload/file-upload.mjs");
var _headerMjs = require("./components/header/header.mjs");
var _notificationBannerMjs = require("./components/notification-banner/notification-banner.mjs");
var _passwordInputMjs = require("./components/password-input/password-input.mjs");
var _radiosMjs = require("./components/radios/radios.mjs");
var _serviceNavigationMjs = require("./components/service-navigation/service-navigation.mjs");
var _skipLinkMjs = require("./components/skip-link/skip-link.mjs");
var _tabsMjs = require("./components/tabs/tabs.mjs");
var _indexMjs1 = require("./errors/index.mjs");
/**
 * Initialise all components
 *
 * Use the `data-module` attributes to find, instantiate and init all of the
 * components provided as part of GOV.UK Frontend.
 *
 * @param {Config | Element | Document | null} [scopeOrConfig] - Scope of the document to search within or config for all components (with optional scope)
 */ function initAll() {
    var scopeOrConfig = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var config = (0, _indexMjs.isObject)(scopeOrConfig) ? scopeOrConfig : {};
    var options = (0, _configurationMjs.normaliseOptions)(scopeOrConfig);
    try {
        if (!(0, _indexMjs.isSupported)()) throw new (0, _indexMjs1.SupportError)();
        if (options.scope === null) throw new (0, _indexMjs1.ElementError)({
            element: options.scope,
            identifier: 'GOV.UK Frontend scope element (`$scope`)'
        });
    } catch (error) {
        if (options.onError) options.onError(error, {
            config: config
        });
        else console.log(error);
        return;
    }
    var components = [
        [
            (0, _accordionMjs.Accordion),
            config.accordion
        ],
        [
            (0, _buttonMjs.Button),
            config.button
        ],
        [
            (0, _characterCountMjs.CharacterCount),
            config.characterCount
        ],
        [
            (0, _checkboxesMjs.Checkboxes)
        ],
        [
            (0, _errorSummaryMjs.ErrorSummary),
            config.errorSummary
        ],
        [
            (0, _exitThisPageMjs.ExitThisPage),
            config.exitThisPage
        ],
        [
            (0, _fileUploadMjs.FileUpload),
            config.fileUpload
        ],
        [
            (0, _headerMjs.Header)
        ],
        [
            (0, _notificationBannerMjs.NotificationBanner),
            config.notificationBanner
        ],
        [
            (0, _passwordInputMjs.PasswordInput),
            config.passwordInput
        ],
        [
            (0, _radiosMjs.Radios)
        ],
        [
            (0, _serviceNavigationMjs.ServiceNavigation)
        ],
        [
            (0, _skipLinkMjs.SkipLink)
        ],
        [
            (0, _tabsMjs.Tabs)
        ]
    ];
    components.forEach(function(param) {
        var _param = (0, _slicedToArray._)(param, 2), Component = _param[0], componentConfig = _param[1];
        createAll(Component, componentConfig, options);
    });
}
/**
 * Create all instances of a specific component on the page
 *
 * Uses the `data-module` attribute to find all elements matching the specified
 * component on the page, creating instances of the component object for each
 * of them.
 *
 * Any component errors will be caught and logged to the console.
 *
 * @template {CompatibleClass} ComponentClass
 * @param {ComponentClass} Component - class of the component to create
 * @param {ComponentConfig<ComponentClass>} [config] - Config supplied to component
 * @param {OnErrorCallback<ComponentClass> | Element | Document | null | CreateAllOptions<ComponentClass>} [scopeOrOptions] - options for createAll including scope of the document to search within and callback function if error throw by component on init
 * @returns {Array<InstanceType<ComponentClass>>} - array of instantiated components
 */ function createAll(Component, config, scopeOrOptions) {
    var $elements;
    var options = (0, _configurationMjs.normaliseOptions)(scopeOrOptions);
    try {
        var _options$scope;
        if (!(0, _indexMjs.isSupported)()) throw new (0, _indexMjs1.SupportError)();
        if (options.scope === null) throw new (0, _indexMjs1.ElementError)({
            element: options.scope,
            component: Component,
            identifier: 'Scope element (`$scope`)'
        });
        $elements = (_options$scope = options.scope) == null ? void 0 : _options$scope.querySelectorAll('[data-module="'.concat(Component.moduleName, '"]'));
    } catch (error) {
        if (options.onError) options.onError(error, {
            component: Component,
            config: config
        });
        else console.log(error);
        return [];
    }
    return Array.from($elements != null ? $elements : []).map(function($element) {
        try {
            return typeof config !== 'undefined' ? new Component($element, config) : new Component($element);
        } catch (error) {
            if (options.onError) options.onError(error, {
                element: $element,
                component: Component,
                config: config
            });
            else console.log(error);
            return null;
        }
    }).filter(Boolean);
}

},{"@swc/helpers/_/_sliced_to_array":"jFaLC","./common/configuration.mjs":"iQR6u","./common/index.mjs":"hMIZ0","./components/accordion/accordion.mjs":"6HrGR","./components/button/button.mjs":"ic7uQ","./components/character-count/character-count.mjs":"1Bfd0","./components/checkboxes/checkboxes.mjs":"kvvKs","./components/error-summary/error-summary.mjs":"gJljr","./components/exit-this-page/exit-this-page.mjs":"b4dHw","./components/file-upload/file-upload.mjs":"aBOo0","./components/header/header.mjs":"hvSmM","./components/notification-banner/notification-banner.mjs":"8sb1f","./components/password-input/password-input.mjs":"5Yenz","./components/radios/radios.mjs":"gWpiP","./components/service-navigation/service-navigation.mjs":"7jdp8","./components/skip-link/skip-link.mjs":"kDOrc","./components/tabs/tabs.mjs":"3PGhh","./errors/index.mjs":"fYWJ8","@parcel/transformer-js/src/esmodule-helpers.js":"2qAMd"}],"a9jtk":[function(require,module,exports,__globalThis) {
exports.getCookie = getCookie;
exports.hideCookieBanner = hideCookieBanner;
// Setup the cookie banner UI
exports.cookieBanner = function() {
    if (window.IER_HIDE_COOKIE_BANNER) // Hide the banner on the cookies page, as it duplicates the page pattern.
    // This pattern is used on https://www.gov.uk/help/cookies
    return;
    if (getCookie("cookie_preferences_set") === undefined) // Cookie banner hidden for non-js users - see 'Option 3'
    // at https://design-system.service.gov.uk/components/cookie-banner/
    showCookieBanner();
    var acceptAllCookiesButton = $('[name="accept-all-cookies"]');
    var rejectAllCookiesButton = $('[name="reject-all-cookies"]');
    [
        acceptAllCookiesButton,
        rejectAllCookiesButton
    ].forEach(function(button) {
        button.click(function() {
            var allow = button.attr("name") === "accept-all-cookies";
            updateAnalyticsCookies(allow);
            setCookie('cookie_preferences_set', 'true', 365);
            hideCookiesQuestion();
            showConfirmationMessage(allow);
        });
    });
    var hideConfirmationMessageButton = $('[name="hide-cookies-confirmation"]');
    hideConfirmationMessageButton.click(function() {
        hideConfirmationMessage();
        hideCookieBanner();
    });
};
exports.cookiesPage = function(cookiesUpdatedRedirectPath) {
    setFormDefaults();
    var cookiesForm = $('#cookies-form');
    cookiesForm.submit(function(event) {
        event.preventDefault();
        var allowAnalyticsCookies = $('[name=analytics-cookies]:checked').val() === 'on';
        updateAnalyticsCookies(allowAnalyticsCookies);
        setCookie('cookie_preferences_set', 'true', 365);
        hideCookieBanner();
        window.location.href = cookiesUpdatedRedirectPath;
    });
    cookiesForm.removeClass('hide');
    $('#no-js-cookie-explanation').addClass('hide');
};
function updateAnalyticsCookies(allow) {
    setCookie('allow_analytics_cookies', allow, 365);
    if (!allow) {
        deleteCookie('_ga');
        deleteCookie('_gat');
        deleteCookie('_gid');
    } else // defined in layout.njk
    if (window.setupGATracking) window.setupGATracking();
    else console.error("Missing global function setupGATracking from layout.njk");
}
function setFormDefaults() {
    var analyticsCookie = getCookie('allow_analytics_cookies');
    if (analyticsCookie === 'true') $('#allow-analytics-cookies').prop("checked", true);
    else $('#disallow-analytics-cookies').prop("checked", true);
}
// Cookie helper code adapted from https://stackoverflow.com/a/24103596
function setCookie(name, value, days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 86400000);
    document.cookie = name + '=' + value + '; expires=' + date.toUTCString() + '; path=/';
}
function deleteCookie(name) {
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/';
}
function getCookie(name) {
    var nameEQ = name + "=";
    var cookies = document.cookie.split(';');
    return getFirstDefined(cookies.map(getValueIfCorrectCookie(nameEQ)));
}
function showCookieBanner() {
    var cookieBanner = document.querySelector(".govuk-cookie-banner");
    cookieBanner.removeAttribute("hidden");
}
function hideCookieBanner() {
    var cookieBanner = document.querySelector(".govuk-cookie-banner");
    cookieBanner.setAttribute("hidden", "");
}
function hideCookiesQuestion() {
    var cookieBanner = document.querySelector(".reject-or-accept-cookies");
    cookieBanner.setAttribute("hidden", "");
}
function showConfirmationMessage(allow) {
    var confirmationMessageClass = allow ? ".accept-cookies-confirmation-message" : ".reject-cookies-confirmation-message";
    var confirmationMessage = document.querySelector(confirmationMessageClass);
    // See GDS guidance under 'Option 3' at https://design-system.service.gov.uk/components/cookie-banner/
    confirmationMessage.removeAttribute("hidden");
    confirmationMessage.tabIndex = -1;
    confirmationMessage.role = "alert";
    confirmationMessage.focus();
}
function hideConfirmationMessage() {
    var rejectedConfirmationMessage = document.querySelector(".reject-cookies-confirmation-message");
    var acceptedConfirmationMessage = document.querySelector(".accept-cookies-confirmation-message");
    [
        rejectedConfirmationMessage,
        acceptedConfirmationMessage
    ].forEach(function(message) {
        message.setAttribute("hidden", "");
    });
}
function or(x, y) {
    return x || y;
}
function getValueIfCorrectCookie(nameEQ) {
    return function(cookie) {
        var index = cookie.indexOf(nameEQ);
        if (index !== -1) return cookie.substring(nameEQ.length + index, cookie.length);
    };
}
function getFirstDefined(arr) {
    return arr.reduce(or);
}

},{}],"6XZMm":[function(require,module,exports,__globalThis) {
exports.gaEventValidationError = function(errors) {
    var endpoint = window.location.pathname;
    Object.keys(errors).map(function(error) {
        ga && ga('send', {
            hitType: 'event',
            eventCategory: 'Validation error',
            eventAction: "".concat(endpoint, " - ").concat(error),
            eventLabel: errors[error].text || errors[error].html
        });
        window.dataLayer && dataLayer.push({
            event: 'validation_error',
            event_data: {
                event_name: 'validation_error',
                error_category: error,
                error_text: errors[error].text,
                error_html: errors[error].html
            }
        });
    });
};
exports.gaEventBackLink = function() {
    $('.govuk-back-link').click(function() {
        ga && ga('send', {
            hitType: 'event',
            eventCategory: 'Back link clicked',
            eventAction: 'Back link clicked'
        });
        window.dataLayer && dataLayer.push({
            event: 'event_data',
            event_data: {
                event_name: 'back_link_clicked'
            }
        });
    });
};
exports.gaEventExitPage = function(exit) {
    ga && ga('send', {
        hitType: 'event',
        eventCategory: 'Kick out',
        eventAction: exit
    });
    window.dataLayer && dataLayer.push({
        event: 'event_data',
        event_data: {
            event_name: 'kick_out'
        }
    });
};
exports.gaEventOfflineFormDownload = function() {
    $('.offline-form-link').click(function() {
        ga && ga('send', {
            hitType: 'event',
            eventCategory: 'Offline form downloaded',
            eventAction: 'Offline form downloaded',
            eventLabel: window.location.pathname
        });
        window.dataLayer && dataLayer.push({
            event: 'event_data',
            event_data: {
                event_name: 'offline_form_all'
            }
        });
    });
};
exports.gaEventOfflineFormDownloadVoluntary = function() {
    $('.govuk-details .offline-form-link').click(function() {
        ga && ga('send', {
            hitType: 'event',
            eventCategory: 'Offline form downloaded',
            eventAction: 'Offline form downloaded - voluntary exit',
            eventLabel: window.location.pathname
        });
        window.dataLayer && dataLayer.push({
            event: 'event_data',
            event_data: {
                event_name: 'offline_form_voluntary'
            }
        });
    });
};
exports.gaEventContactLocalElectoralRegistrationOffice = function() {
    ga && ga('send', {
        hitType: 'event',
        eventCategory: 'Link click',
        eventAction: 'Contact local Electoral Registration Office',
        eventLabel: window.location.pathname
    });
    window.dataLayer && dataLayer.push({
        event: 'event_data',
        event_data: {
            event_name: 'contact_ero'
        }
    });
};
exports.gaEventSubmitButtonClick = function() {
    $('button[type="submit"]').click(function() {
        ga && ga('send', {
            hitType: 'event',
            eventCategory: 'Form submission',
            eventAction: 'Page submit click',
            eventLabel: window.location.pathname
        });
        window.dataLayer && dataLayer.push({
            event: 'event_data',
            event_data: {
                event_name: 'page_submission'
            }
        });
    });
};
exports.gaEventErrorPage = function(errorPageName) {
    window.dataLayer && dataLayer.push({
        event: 'event_data',
        event_data: {
            event_name: 'error_page'
        }
    });
    window.dataLayer && dataLayer.push({
        event: 'event_data',
        event_data: {
            event_name: "error_page_".concat(errorPageName)
        }
    });
};

},{}],"gQRIW":[function(require,module,exports,__globalThis) {
// Adapted from: https://github.com/hannalaakso/accessible-timeout-warning
exports.setTimeoutWarning = function setTimeoutWarning() {
    function TimeoutWarning($module) {
        this.$module = $module;
        this.$lastFocusedEl = null;
        this.$closeButton = $module.querySelector('.js-dialog-close');
        this.overLayClass = 'govuk-timeout-warning-overlay';
        this.timers = [];
        this.$countdown = $module.querySelector('.timer');
        this.$accessibleCountdown = $module.querySelector('.at-timer');
        this.idleMinutesBeforeTimeOut = $module.getAttribute('data-minutes-idle-timeout');
        this.timeOutRedirectUrl = $module.getAttribute('data-url-redirect');
        this.minutesTimeOutModalVisible = $module.getAttribute('data-minutes-modal-visible');
        this.translatedMinute = $module.getAttribute('data-translated-minute');
        this.translatedMinutes = $module.getAttribute('data-translated-minutes');
        this.translatedSecond = $module.getAttribute('data-translated-second');
        this.translatedSeconds = $module.getAttribute('data-translated-seconds');
        this.translatedBeforeTimer = $module.getAttribute('data-translated-before-timer');
        this.translatedAfterTimer = $module.getAttribute('data-translated-after-timer');
    }
    TimeoutWarning.prototype.init = function() {
        if (!this.$module || !this.dialogSupported()) return;
        this.startTimer();
        this.$closeButton.addEventListener('click', this.closeDialog.bind(this));
        this.$module.addEventListener('keydown', this.escClose.bind(this));
    };
    TimeoutWarning.prototype.dialogSupported = function() {
        if (typeof HTMLDialogElement === 'function') return true;
        try {
            window.dialogPolyfill.registerDialog(this.$module);
            return true;
        } catch (error) {
            return false;
        }
    };
    TimeoutWarning.prototype.startTimer = function() {
        var milliSecondsBeforeTimeOut = this.idleMinutesBeforeTimeOut * 60000;
        this.timers.push(setTimeout(this.openDialog.bind(this), milliSecondsBeforeTimeOut));
        this.timeOutInstantAsUnixMillis = Date.now() + milliSecondsBeforeTimeOut + 60000 * this.minutesTimeOutModalVisible;
    };
    TimeoutWarning.prototype.openDialog = function() {
        if (!this.isDialogOpen()) {
            document.querySelector('body').classList.add(this.overLayClass);
            this.saveLastFocusedEl();
            this.$module.showModal();
            this.startUiCountdown();
        }
    };
    // Starts a UI countdown timer. If timer is not cancelled before 0
    // reached + 4 seconds grace period, user is redirected.
    TimeoutWarning.prototype.startUiCountdown = function() {
        this.clearTimers(); // Clear any other modal timers that might have been running
        var $countdown = this.$countdown;
        var $accessibleCountdown = this.$accessibleCountdown;
        var timerRunOnce = false;
        var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        (function runTimer() {
            // We recompute at this point how long is left using the "wall clock" of Date.now().
            // This is necessary because we can't rely on "setTimeout(x)" coming back after
            // exactly x millis. In particular, if the current tab or window is in the background,
            // then it may "sleep", and a "setTimeout" may get invoked a long time after expected.
            var totalMillisLeft = this.timeOutInstantAsUnixMillis - Date.now();
            var totalSecondsLeft = Math.floor(totalMillisLeft / 1000);
            var minutesLeft = Math.floor(totalSecondsLeft / 60);
            var secondsLeft = totalSecondsLeft % 60;
            var timerExpired = minutesLeft < 1 && secondsLeft < 1;
            var minutesText = minutesLeft + '&nbsp;' + (minutesLeft !== 1 ? this.translatedMinutes : this.translatedMinute);
            var secondsText = '&nbsp;' + ("0" + secondsLeft).slice(-2) + '&nbsp;' + (secondsLeft !== 1 ? this.translatedSeconds : this.translatedSecond) + ',';
            // Attempt to convert numerics into text as iOS VoiceOver occasionally stalled when encountering numbers
            var atMinutesNumberAsText = this.numberToWords(minutesLeft);
            var atSecondsNumberAsText = this.numberToWords(secondsLeft);
            var atMinutesText = minutesLeft > 0 ? atMinutesNumberAsText + ' ' + (minutesLeft > 1 ? this.translatedMinutes : this.translatedMinute) : '';
            var atSecondsText = secondsLeft >= 1 ? ' ' + atSecondsNumberAsText + ' ' + (secondsLeft > 1 ? this.translatedSeconds : this.translatedSecond) : '';
            // Below string will get read out by screen readers every time the timeout refreshes (every 15 secs. See below).
            var text = this.translatedBeforeTimer + ' ' + minutesText + secondsText;
            var atText = this.translatedBeforeTimer + ' ' + atMinutesText;
            if (atSecondsText) {
                if (minutesLeft > 0) atText += ' and';
                atText += atSecondsText;
            }
            atText += ',';
            if (timerExpired) this.redirect();
            else {
                $countdown.innerHTML = text + ' ' + this.translatedAfterTimer;
                if (minutesLeft < 1 && secondsLeft < 20) $accessibleCountdown.setAttribute('aria-live', 'assertive');
                if (!timerRunOnce) {
                    // Read out the extra content only once. Don't read out on iOS VoiceOver which stalls on the longer text
                    if (iOS) $accessibleCountdown.innerHTML = atText;
                    else $accessibleCountdown.innerHTML = atText + ' ' + this.translatedAfterTimer;
                    timerRunOnce = true;
                } else if (secondsLeft % 15 === 0) // Update screen reader friendly content every 15 secs
                $accessibleCountdown.innerHTML = atText;
                // Sleep until the second counter needs updating.
                // If the time left is 5.9 sec, sleep for 0.9 sec
                // If the time left is 5.0 sec, sleep for 1 sec
                var sleepMillis = totalMillisLeft % 1000;
                if (sleepMillis === 0) sleepMillis = 1000;
                this.timers.push(setTimeout(runTimer.bind(this), sleepMillis));
            }
        }).bind(this)();
    };
    TimeoutWarning.prototype.saveLastFocusedEl = function() {
        this.$lastFocusedEl = document.activeElement;
        if (!this.$lastFocusedEl || this.$lastFocusedEl === document.body) this.$lastFocusedEl = null;
        else this.$lastFocusedEl = document.querySelector(':focus');
    };
    // Set focus back on last focused el when modal closed
    TimeoutWarning.prototype.setFocusOnLastFocusedEl = function() {
        if (this.$lastFocusedEl) window.setTimeout((function() {
            this.$lastFocusedEl.focus();
        }).bind(this), 0);
    };
    TimeoutWarning.prototype.isDialogOpen = function() {
        return this.$module['open'];
    };
    TimeoutWarning.prototype.closeDialog = function() {
        if (this.isDialogOpen()) {
            document.querySelector('body').classList.remove(this.overLayClass);
            this.$module.close();
            this.setFocusOnLastFocusedEl();
            this.clearTimers();
            this.refreshTimeout();
            this.startTimer();
        }
    };
    TimeoutWarning.prototype.refreshTimeout = function() {
        var xhr = new XMLHttpRequest();
        xhr.onreadystatechange = (function() {
            if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 400) // Session expired before server could refresh it
            this.redirect();
            else xhr.readyState === XMLHttpRequest.DONE && xhr.status;
        }).bind(this);
        xhr.open("POST", "/refresh-session-timeout", true);
        xhr.send();
        ga && ga('send', {
            hitType: 'event',
            eventCategory: 'Timeout',
            eventAction: 'Timeout extended',
            eventLabel: 'Timeout extended'
        });
        window.dataLayer && dataLayer.push({
            event: 'event_data',
            event_data: {
                event_name: 'timeout_extended'
            }
        });
    };
    // Clears modal timer
    TimeoutWarning.prototype.clearTimers = function() {
        this.timers.forEach(clearTimeout);
    };
    // Close modal when ESC pressed
    TimeoutWarning.prototype.escClose = function(event) {
        // get the target element
        if (this.isDialogOpen() && event.keyCode === 27) this.closeDialog();
    };
    TimeoutWarning.prototype.redirect = function() {
        ga && ga('send', {
            hitType: 'event',
            eventCategory: 'Timeout',
            eventAction: 'Session timed out',
            eventLabel: 'Session timed out'
        });
        window.dataLayer && dataLayer.push({
            event: 'event_data',
            event_data: {
                event_name: 'session_timed_out'
            }
        });
        window.location.replace(this.timeOutRedirectUrl);
    };
    TimeoutWarning.prototype.numberToWords = function(n) {
        var string = n.toString();
        var units;
        var tens;
        var scales;
        var start;
        var end;
        var chunks;
        var chunksLen;
        var chunk;
        var ints;
        var i;
        var word;
        var words;
        if (parseInt(string) === 0) return 'zero';
        /* Array of units as words */ units = [
            '',
            'one',
            'two',
            'three',
            'four',
            'five',
            'six',
            'seven',
            'eight',
            'nine',
            'ten',
            'eleven',
            'twelve',
            'thirteen',
            'fourteen',
            'fifteen',
            'sixteen',
            'seventeen',
            'eighteen',
            'nineteen'
        ];
        /* Array of tens as words */ tens = [
            '',
            '',
            'twenty',
            'thirty',
            'forty',
            'fifty',
            'sixty',
            'seventy',
            'eighty',
            'ninety'
        ];
        /* Array of scales as words */ scales = [
            '',
            'thousand',
            'million',
            'billion',
            'trillion',
            'quadrillion',
            'quintillion',
            'sextillion',
            'septillion',
            'octillion',
            'nonillion',
            'decillion',
            'undecillion',
            'duodecillion',
            'tredecillion',
            'quatttuor-decillion',
            'quindecillion',
            'sexdecillion',
            'septen-decillion',
            'octodecillion',
            'novemdecillion',
            'vigintillion',
            'centillion'
        ];
        /* Split user arguemnt into 3 digit chunks from right to left */ start = string.length;
        chunks = [];
        while(start > 0){
            end = start;
            chunks.push(string.slice(start = Math.max(0, start - 3), end));
        }
        /* Check if function has enough scale words to be able to stringify the user argument */ chunksLen = chunks.length;
        if (chunksLen > scales.length) return '';
        /* Stringify each integer in each chunk */ words = [];
        for(i = 0; i < chunksLen; i++){
            chunk = parseInt(chunks[i]);
            if (chunk) {
                /* Split chunk into array of individual integers */ ints = chunks[i].split('').reverse().map(parseFloat);
                /* If tens integer is 1, i.e. 10, then add 10 to units integer */ if (ints[1] === 1) ints[0] += 10;
                /* Add scale word if chunk is not zero and array item exists */ if (word = scales[i]) words.push(word);
                /* Add unit word if array item exists */ if (word = units[ints[0]]) words.push(word);
                /* Add tens word if array item exists */ if (word = tens[ints[1]]) words.push(word);
                /* Add hundreds word if array item exists */ if (word = units[ints[2]]) words.push(word + ' hundred');
            }
        }
        return words.reverse().join(' ');
    };
    var $timeoutWarning = document.querySelector('[data-module="govuk-timeout-warning"]');
    if ($timeoutWarning) new TimeoutWarning($timeoutWarning).init();
};

},{}],"3znqW":[function(require,module,exports,__globalThis) {
exports.manualAddress = function manualAddress() {
    var countyField = $('#county');
    var localAuthorityField = $("#local-authority");
    var nationField = $('#nation');
    var allLocalAuthorityOptions = localAuthorityField.html();
    filterLocalAuthoritiesByCounty();
    countyField.on('change', filterLocalAuthoritiesByCounty);
    filterLocalAuthoritiesByNation();
    nationField.on('change', filterLocalAuthoritiesByNation);
    function filterLocalAuthoritiesByCounty() {
        if (!countyField.length) return;
        var county = countyField.val();
        localAuthorityField.html(allLocalAuthorityOptions);
        if (county !== 'DEFAULT') $("#local-authority option").filter(function() {
            var item = $(this);
            return item.data('county') !== county && item.val() !== 'DEFAULT';
        }).remove();
    }
    function filterLocalAuthoritiesByNation() {
        if (!nationField.length) return;
        var nation = nationField.val();
        localAuthorityField.html(allLocalAuthorityOptions);
        if (nation !== 'DEFAULT') $("#local-authority option").filter(function() {
            var item = $(this);
            if (nation === 'Scotland') return item.data('county') !== 'SCOTTISH' && item.val() !== 'DEFAULT';
            if (nation === 'Wales') return item.val() !== 'DEFAULT' && !item.data('gsscode').startsWith('W');
            return item.val() !== 'DEFAULT' && !item.data('gsscode').startsWith('E');
        }).remove();
    }
};

},{}],"5JmtR":[function(require,module,exports,__globalThis) {
exports.addressAnalytics = function() {
    $('#manual-entry-button').click(function() {
        ga && ga('send', {
            hitType: 'event',
            eventCategory: 'Postcode not found',
            eventAction: 'Postcode not found in OS Places/ViaEuropa'
        });
        window.dataLayer && dataLayer.push({
            event: 'event_data',
            event_data: {
                event_name: 'postcode_not_found'
            }
        });
    });
};

},{}],"lvv9g":[function(require,module,exports,__globalThis) {
exports.contact = function() {
    $('#contact-form').submit(function(event) {
        var formData = new FormData(event.target);
        gaEventMultipleContactMethods(formData);
    });
};
function gaEventMultipleContactMethods(formData) {
    var numContactMethods = formData.getAll('contact').length;
    if (numContactMethods > 1) {
        ga && ga('send', {
            hitType: 'event',
            eventCategory: '/contact',
            eventAction: 'Multiple contact methods provided'
        });
        window.dataLayer && dataLayer.push({
            event: 'event_data',
            event_data: {
                event_name: 'multiple_contact_methods_provided'
            }
        });
    }
}

},{}],"1C2yv":[function(require,module,exports,__globalThis) {
exports.nino = function nino() {
    $('#nino-form').submit(function(event) {
        var formData = new FormData(event.target);
        gaEventContactEmail(formData);
        gaEventDontKnowNino(formData);
    });
};
function gaEventDontKnowNino(formData) {
    if (formData.get('reason-not-provided')) ga && ga('send', {
        hitType: 'event',
        eventCategory: '/nino',
        eventAction: 'NINo unknown'
    });
}
function gaEventContactEmail(formData) {
    if (formData.get('contact-email')) {
        ga && ga('send', {
            hitType: 'event',
            eventCategory: 'Email Address Collection',
            eventAction: 'NINO Email',
            eventLabel: 'NINO - Email Address Provided'
        });
        window.dataLayer && dataLayer.push({
            event: 'event_data',
            event_data: {
                event_name: 'unknown_ni_number'
            }
        });
    }
}

},{}],"eDLOo":[function(require,module,exports,__globalThis) {
exports.dateOfBirth = function dateOfBirth() {
    $('#dob-form').submit(function(event) {
        var formData = new FormData(event.target);
        gaEventContactEmail(formData);
        gaEventDontKnowDob(formData);
    });
};
function gaEventDontKnowDob(formData) {
    if (formData.get('reason-not-provided')) ga && ga('send', {
        hitType: 'event',
        eventCategory: '/date-of-birth',
        eventAction: "User doesn't know DOB"
    });
}
function gaEventContactEmail(formData) {
    if (formData.get('contact-email')) ga && ga('send', {
        hitType: 'event',
        eventCategory: 'Email Address Collection',
        eventAction: 'DOB Email',
        eventLabel: 'DOB - Email Address Provided'
    });
}

},{}],"7uULM":[function(require,module,exports,__globalThis) {
'use strict';
var pageContentsVerticalNavigation = require("ceb22905e8046d51");
exports.privacy = function() {
    pageContentsVerticalNavigation.start($('*[data-module=highlight-active-section-heading]'));
};

},{"ceb22905e8046d51":"5B12i"}],"5B12i":[function(require,module,exports,__globalThis) {
//  code adapted from https://github.com/alphagov/service-manual-frontend/blob/3daab95d11b7bb2677cd1642c7d0c6af69c696c9/app/assets/javascripts/modules/highlight-active-section-heading.js
//  The associated styles can be found in frontend/src/scss/styles.scss
'use strict';
exports.start = function($parentElement) {
    window.GOVUK = window.GOVUK || {};
    window.GOVUK.Modules = window.GOVUK.Modules || {};
    var $ = window.$;
    var $window = $(window);
    var self = window;
    var _hasResized = true;
    var _hasScrolled = true;
    var _interval = 50;
    var anchorIDs = [];
    self.getWindowDimensions = function() {
        return {
            height: $window.height(),
            width: $window.width()
        };
    };
    self.getWindowPositions = function() {
        return {
            scrollTop: $window.scrollTop()
        };
    };
    self.getElementOffset = function($el) {
        return $el.offset();
    };
    self.start = function($el) {
        $window.resize(self.hasResized);
        $window.scroll(self.hasScrolled);
        setInterval(self.checkResize, _interval);
        setInterval(self.checkScroll, _interval);
        self.$anchors = $el.find('.js-page-contents a');
        self.getAnchors();
        self.checkResize();
        self.checkScroll();
    };
    self.hasResized = function() {
        _hasResized = true;
        return _hasResized;
    };
    self.hasScrolled = function() {
        _hasScrolled = true;
        return _hasScrolled;
    };
    self.checkResize = function() {
        if (_hasResized) {
            _hasResized = false;
            _hasScrolled = true;
        }
    };
    self.checkScroll = function() {
        if (_hasScrolled) {
            _hasScrolled = false;
            var windowDimensions = self.getWindowDimensions();
            if (windowDimensions.width <= 768) self.removeActiveItem();
            else self.updateActiveNavItem();
        }
    };
    self.getAnchors = function() {
        $.each(self.$anchors, function(i) {
            var anchorID = $(this).attr('href');
            // e.g. anchorIDs['#meeting-the-digital-service-standard', '#understand-your-users', '#research-continually']
            anchorIDs.push(anchorID);
        });
    };
    self.getHeadingPosition = function($theID) {
        return $theID.offset();
    };
    self.getNextHeadingPosition = function($theNextID) {
        return $theNextID.offset();
    };
    self.getFooterPosition = function($theID) {
        return $theID.offset();
    };
    self.getDistanceBetweenHeadings = function(headingPosition, nextHeadingPosition) {
        var distanceBetweenHeadings = nextHeadingPosition - headingPosition;
        return distanceBetweenHeadings;
    };
    self.updateActiveNavItem = function() {
        var windowVerticalPosition = self.getWindowPositions().scrollTop;
        var footerPosition = self.getFooterPosition($('#footer'));
        $.each(self.$anchors, function(i) {
            var theID = anchorIDs[i];
            var theNextID = anchorIDs[i + 1];
            var $theID = $(theID);
            var $theNextID = $(theNextID);
            var headingPosition = self.getHeadingPosition($theID);
            if (!headingPosition) return;
            headingPosition = headingPosition.top;
            headingPosition = headingPosition - 53 // fix the offset from top of page
            ;
            if (theNextID) var nextHeadingPosition = self.getNextHeadingPosition($theNextID).top;
            var distanceBetweenHeadings = self.getDistanceBetweenHeadings(headingPosition, nextHeadingPosition);
            if (distanceBetweenHeadings) var isPastHeading = windowVerticalPosition >= headingPosition && windowVerticalPosition < headingPosition + distanceBetweenHeadings;
            else var isPastHeading = windowVerticalPosition >= headingPosition && windowVerticalPosition < footerPosition.top;
            if (isPastHeading) self.setActiveItem(theID);
        });
    };
    self.setActiveItem = function(theID) {
        self.$anchors.removeClass('active');
        self.$anchors.filter("[href='" + theID + "']").addClass('active');
    };
    self.removeActiveItem = function() {
        self.$anchors.removeClass('active');
    };
    self.start($parentElement);
};

},{}],"l0PXW":[function(require,module,exports,__globalThis) {
/**
 *  This file is similar to provide-photo.js. Bugs found here likely have to be fixed there too. Possibility of commonizing these in the future.
 */ var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _loader = require("../components/loader");
var _s3 = require("../s3");
var _uuid = require("uuid");
// This is duplicated from our S3 service, we cannot reference that here without pulling lots of unrelated files into the clientside bundle
var maxFileSizeInMB = 20;
exports.uploadDocuments = function(numDocsRequired, stillUploading, loaderContainerId, loaderStyleElementId, allowPartialCompletion, error__none_selected, error__too_big, error__filetypes, error__unknown, error__abort, error__document_label, screen_reader_alert__file_added, screen_reader_alert__file_removed, continue_without_uploading_more_button_text, continue_button_text, error_phrase) {
    addScreenReaderFileStatusAlert();
    // the js code only runs while still uploading
    if (!stillUploading) return;
    var errorMessages = {
        error__none_selected: error__none_selected,
        error__too_big: error__too_big,
        error__filetypes: error__filetypes,
        error__unknown: error__unknown,
        error__abort: error__abort,
        error__document_label: error__document_label
    };
    var spinner = new GOVUK.Loader();
    // containers
    var uploadFormId = 'upload-form';
    var uploadBoxId = 'upload-box';
    var uploadForm = document.getElementById(uploadFormId);
    // form inputs
    var labelSelectId = 'document-label-select';
    var fileUploadId = 'file-upload';
    var documentLabelSelect = document.getElementById(labelSelectId);
    var fileUpload = document.getElementById(fileUploadId);
    // error components
    var errors = {};
    var jsErrorSummary = document.querySelector(".govuk-error-summary");
    var jsErrorList = jsErrorSummary.querySelector("ul");
    var acceptedFileExtensions = [
        '.jpg',
        '.jpeg',
        '.png',
        '.gif',
        '.pdf',
        '.heic',
        '.heif'
    ];
    // submit button
    fileUpload.classList.add("hidden");
    fileUpload.addEventListener('change', uploadFile);
    var uploadButton = uploadForm.querySelector('button[name="upload-button"]');
    uploadButton.addEventListener('click', function(event) {
        return fileUpload.click();
    });
    uploadButton.id = 'upload-button';
    uploadButton.type = "button";
    var continueForm = document.getElementById("continue-form");
    var nextButton = continueForm.querySelector('button[name="submit-button"]');
    enableNextButton();
    disableNextButtonOnRemoveFile();
    function uploadFile(event) {
        event.preventDefault();
        disableNextButton();
        clearErrors();
        uploadForm.classList.add("govuk-visually-hidden");
        spinner.init({
            container: loaderContainerId,
            styleElementId: loaderStyleElementId,
            label: true
        });
        var documentLabelIsValid = validateDocumentLabel(documentLabelSelect.value);
        var file = fileUpload.files[0];
        var fileIsValid = validateFile(file);
        if (!documentLabelIsValid || !fileIsValid) {
            // Clear the selection so that the change event will fire when the user tries again
            resetFormInput();
            renderErrors();
            return false;
        }
        // testing browser support. if no support for the required js APIs
        // the form will just be posted naturally with no progress showing.
        var xhr = new XMLHttpRequest();
        if (!(xhr && 'upload' in xhr && 'onprogress' in xhr.upload) || !window.FormData) {
            uploadForm.submit();
            return;
        }
        xhr.upload.onprogress = progressHandler;
        xhr.onerror = errorHandler;
        xhr.onabort = abortHandler;
        xhr.onload = s3UploadCompleteHandler.bind(this, xhr, file.name);
        var formData = new FormData(uploadForm);
        // set to "" so not redirected automatically
        formData.set("success_action_redirect", "");
        xhr.open('POST', uploadForm.action);
        xhr.send(formData);
        return false;
    }
    function validateFile(file) {
        if (!file) {
            errors[uploadButton.id] = errorMessages.error__none_selected;
            return false;
        }
        if (file.size > maxFileSizeInMB * 1000000) {
            errors[uploadButton.id] = errorMessages.error__too_big;
            return false;
        }
        var nameLower = file.name.toLowerCase();
        if (!acceptedFileExtensions.find(function(ext) {
            return nameLower.endsWith(ext);
        })) {
            errors[uploadButton.id] = errorMessages.error__filetypes;
            return false;
        }
        return true;
    }
    function validateDocumentLabel(documentLabel) {
        if (!documentLabel) {
            errors[labelSelectId] = errorMessages.error__document_label;
            return false;
        }
        return true;
    }
    function progressHandler(e) {
        var progress = Math.floor(e.loaded / e.total * 100);
        spinner.updateMessage("Uploading... ".concat(progress, "%"));
        spinner.updateProgress(progress);
    }
    // Called when the upload to S3 has completed
    function s3UploadCompleteHandler(uploadXhr, fileName) {
        try {
            spinner.updateMessage("Processing");
            if (uploadXhr.status !== 204) // 'xhr.onerror' is only called if there's an error at the network level.
            // If the error only exists at the application level (e.g. an HTTP error code is sent), it will not be called.
            // So we need to check the status code here in order to show a validation message if s3 reject the file.
            throw new Error("Error status from S3: " + uploadXhr.status);
            // Tell the backend the name of the file that was just uploaded,
            // so the session state can be updated.
            // This allows us to avoid S3 "list" ops, which don't scale to high load.
            //
            // If the client browser fails or goes offline between the above op and
            // this then the image info will not get added to the session, and they
            // will need to upload it again
            // S3 can change the provided filename, for example spaces are trimmed.
            // We therefore get the final bucket + key info from the Location header
            var s3Location = uploadXhr.getResponseHeader("location");
            var bucketKey = (0, _s3.urlToBucketKey)(s3Location);
            // browser xhr support was already tested above
            var xhr = new XMLHttpRequest();
            xhr.onload = sessionUpdateCompleteHandler.bind(this, xhr);
            xhr.onerror = function(e) {
                return errorHandler(e);
            };
            xhr.onabort = function() {
                return abortHandler();
            };
            xhr.open('POST', document.location);
            var formData = {
                "s3-upload-complete": "true",
                bucket: bucketKey.bucket,
                key: bucketKey.key
            };
            xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
            // ask the browser to parse the html response into a DOM
            xhr.responseType = "document";
            xhr.send(new URLSearchParams(Object.entries(formData)).toString());
        } catch (e) {
            errorHandler(e);
        }
    }
    // Called when the after-upload session update XHR has completed
    function sessionUpdateCompleteHandler(xhr) {
        try {
            if (xhr.status !== 200) // 'xhr.onerror' is only called if there's an error at the network level.
            // If the error only exists at the application level (e.g. an HTTP error code is sent), it will not be called.
            // So we need to check the status code here in order to show a validation message if s3 reject the file.
            throw new Error("Error status from backend: " + xhr.status);
            var newHtml = xhr.responseXML;
            if (!newHtml) throw new Error("responseXML null. Not supported browser?");
            var numberOfDocsUploaded = document.getElementsByClassName("document-row").length;
            var uploadingLastDoc = numberOfDocsUploaded === numDocsRequired - 1;
            var uploadContainer = document.getElementById("doc-upload-container");
            uploadContainer.parentNode.insertBefore(newHtml.body, uploadContainer);
            screenReaderFileAlert(screen_reader_alert__file_added);
            // Update the UUID in the prepost location in case the user tries a file of the same name and label
            replaceUUIDInDocumentLabelSelectOptionsForNextUpload();
            // Clear the selection so that the change event will fire if the user tries a file of the same name
            resetFormInput();
            spinner.stop();
            enableNextButton();
            disableNextButtonOnRemoveFile();
            var submitButton = document.querySelector('button[name="submit-button"]');
            if (!uploadingLastDoc) {
                uploadForm.classList.remove("govuk-visually-hidden");
                if (allowPartialCompletion) submitButton.textContent = continue_without_uploading_more_button_text;
            } else {
                uploadContainer.classList.add("govuk-visually-hidden");
                submitButton.textContent = continue_button_text;
            }
        } catch (e) {
            errorHandler(e);
        }
    }
    function errorHandler(data) {
        console.error(data);
        errors[uploadBoxId] = errorMessages.error__unknown;
        renderErrors();
    }
    function abortHandler() {
        errors[uploadBoxId] = errorMessages.error__abort;
        renderErrors();
    }
    function renderErrors() {
        spinner.stop();
        enableNextButton();
        uploadForm.classList.remove("govuk-visually-hidden");
        updateTitleIfNotAlreadyInError();
        Object.entries(errors).forEach(function(param) {
            var _param = (0, _slicedToArray._)(param, 2), fieldId = _param[0], message = _param[1];
            addErrorSummaryItem(fieldId, message);
            addErrorToField(fieldId, message);
        });
        jsErrorSummary.style.display = 'block';
        jsErrorSummary.focus();
        document.body.scrollTop = document.documentElement.scrollTop = 0;
    }
    function updateTitleIfNotAlreadyInError() {
        var title = document.title;
        if (title && !title.startsWith("".concat(error_phrase, ":"))) document.title = "".concat(error_phrase, ": ").concat(title);
    }
    function clearErrors() {
        // Some pages have an error summary which is hidden by default, some don't. Setting to none works in both cases.
        jsErrorSummary.style.display = 'none';
        Object.keys(errors).forEach(function(fieldId) {
            jsErrorList.removeChild(document.getElementById(fieldId + "--top-error"));
            removeErrorFromField(fieldId);
            delete errors[fieldId];
        });
    }
    function addErrorSummaryItem(fieldId, errorMessage) {
        var listItem = document.createElement("li");
        var anchor = listItem.appendChild(document.createElement("a"));
        anchor.href = "#" + fieldId;
        anchor.textContent = errorMessage;
        listItem.id = fieldId + "--top-error";
        jsErrorList.appendChild(listItem);
    }
    function addErrorToField(fieldId, errorMessage) {
        var field = document.getElementById(fieldId);
        var container = field.parentNode;
        var spanId = field.id + "--span-error";
        var span = document.getElementById(spanId);
        if (span && span.lastChild) span.lastChild.textContent = errorMessage;
        else {
            span = document.createElement("span");
            span.id = spanId;
            span.className = 'govuk-error-message';
            var hiddenSpan = span.appendChild(document.createElement("span"));
            hiddenSpan.className = "govuk-visually-hidden";
            hiddenSpan.textContent = "".concat(error_phrase, ":");
            var errorSpan = span.appendChild(document.createElement("span"));
            errorSpan.textContent = errorMessage;
        }
        container.insertBefore(span, field);
        container.classList.add("govuk-form-group--error");
    }
    function removeErrorFromField(fieldId) {
        var field = document.getElementById(fieldId);
        var container = field.parentNode;
        var spanId = field.id + "--span-error";
        var span = document.getElementById(spanId);
        if (span) {
            container.removeChild(span);
            container.classList.remove("govuk-form-group--error");
        }
    }
    function addScreenReaderFileStatusAlert() {
        var urlSearchParams = new URLSearchParams(window.location.search);
        if (urlSearchParams.get("file-removed") === "true") screenReaderFileAlert(screen_reader_alert__file_removed);
    // no "file-added" case, as that's either handled directly in js,
    // see screen_reader_alert__file_added above, or we're no-js
    }
    function screenReaderFileAlert(alertMessage) {
        var alert = document.getElementById("hidden-alert-container");
        alert.innerHTML = alertMessage;
    }
    // We replace UUIDs to ensure that documents with the same name and label can be uploaded correctly
    // For non-JS users this is done in generateUniqueDocumentKeyPrefix in documentHelper.ts
    function replaceUUIDInDocumentLabelSelectOptionsForNextUpload() {
        var selectOptionsElt = document.getElementById("document-label-select").options;
        var newUUID = (0, _uuid.v4)();
        for(var i = 0; i < selectOptionsElt.length; i++){
            var option = selectOptionsElt[i];
            option.value = replaceUUIDInPresignedKey(selectOptionsElt[i].value, newUUID);
        }
    }
    function replaceUUIDInPresignedKey(presignedKey, newUUID) {
        // See pattern from arrayToSelectValuesWithPrefixForS3 in templating.ts
        // The key here will look like {session ID}/{document class}/{UUID}/{document label}/{file name}
        return presignedKey.replace(/\/[a-z0-9\-]+(\/[a-z0-9\-]+\/\$\{filename})/, "/".concat(newUUID, "$1"));
    }
    function resetFormInput() {
        fileUpload.value = "";
    }
    function enableNextButton() {
        nextButton.removeAttribute("disabled");
        nextButton.removeAttribute("aria-disabled");
    }
    function disableNextButton() {
        nextButton.setAttribute("disabled", "");
        nextButton.setAttribute("aria-disabled", true);
    }
    function disableNextButtonOnRemoveFile() {
        var removeFileButtons = document.getElementsByName('remove-file-button');
        removeFileButtons && removeFileButtons.forEach(function(button) {
            button.addEventListener('click', function() {
                disableNextButton();
            });
        });
    }
};

},{"@swc/helpers/_/_sliced_to_array":"jFaLC","../components/loader":"1sVIf","../s3":"9Relc","uuid":[["v4","jCUN9","default"]]}],"1sVIf":[function(require,module,exports,__globalThis) {
// Mostly copied from https://github.com/alphagov/govuk-design-system-backlog/issues/28, with some accessibility changes
// we should update to use the version that ends up in the design system if/when it gets there.
(function(global) {
    'use strict';
    var GOVUK = global.GOVUK || {};
    var prefixes = [
        'webkit',
        'Moz',
        'ms',
        'O'
    ]; // Vendor prefixes
    var animations = {}; // Animation rules keyed by their name
    var useCssAnimations; // Whether to use CSS animations or setTimeout
    var sheet; // A stylesheet to hold the @keyframe or VML rules.
    var defaults = {
        container: 'loader',
        styleElementId: null,
        // Multiple loader instances on the same page can re-use a <style> element.
        label: false,
        labelText: 'Loading, please wait.',
        size: 100,
        lines: 12,
        length: 7,
        width: 5,
        radius: 10,
        corners: 0.5,
        color: '#000',
        opacity: 0.25,
        rotate: 0,
        direction: 1,
        speed: 1,
        trail: 100,
        fps: 20 // Frames per second when using setTimeout()
    };
    function Loader() {}
    Loader.prototype.setContainer = function(container) {
        this.container = container;
    };
    // Utility function to create HTML elements. Optionally properties can be passed.
    Loader.prototype.createSvgElement = function(tag, prop) {
        var element;
        var n;
        element = document.createElementNS('http://www.w3.org/2000/svg', tag);
        for(n in prop)element.setAttribute(n, prop[n]);
        return element;
    };
    // Utility function to create SVG elements. Optionally properties can be passed.
    Loader.prototype.createHtmlElement = function(tag, prop) {
        var element, n;
        element = document.createElement(tag || 'div');
        for(n in prop)element.setAttribute(n, prop[n]);
        return element;
    };
    // Appends children to element
    Loader.prototype.insertElement = function(parent /* child1, child2, ... */ ) {
        for(var i = 1, n = arguments.length; i < n; i++)parent.appendChild(arguments[i]);
        return parent;
    };
    // Creates an opacity keyframe animation rule and returns its name.
    // Since most mobile Webkits have timing issues with animation-delay, we create separate rules for each line/segment.
    Loader.prototype.addAnimation = function(alpha, trail, i, lines) {
        var name = [
            'opacity',
            trail,
            ~~(alpha * 100),
            i,
            lines
        ].join('-');
        var start = 0.01 + i / lines * 100;
        var z = Math.max(1 - (1 - alpha) / trail * (100 - start), alpha);
        var prefix = useCssAnimations.substring(0, useCssAnimations.indexOf('Animation')).toLowerCase();
        var pre = prefix && '-' + prefix + '-' || '';
        if (!animations[name]) {
            if (!sheet) console.error("GOV Loader: Missing css sheet element");
            else {
                sheet.insertRule('@' + pre + 'keyframes ' + name + '{' + '0%{opacity:' + z + '}' + start + '%{opacity:' + alpha + '}' + (start + 0.02) + '%{opacity:1}' + (start + trail) % 100 + '%{opacity:' + alpha + '}' + '100%{opacity:' + z + '}' + '}', sheet.cssRules.length);
                animations[name] = 1;
            }
        }
        return name;
    };
    // Tries various vendor prefixes and returns the first supported property.
    Loader.prototype.vendor = function(el, prop) {
        var s = el.style;
        var pp;
        var i;
        prop = prop.charAt(0).toUpperCase() + prop.slice(1);
        if (s[prop] !== undefined) return prop;
        for(i = 0; i < prefixes.length; i++){
            pp = prefixes[i] + prop;
            if (s[pp] !== undefined) return pp;
        }
    };
    // Sets multiple style properties at once.
    Loader.prototype.css = function(el, prop) {
        for(var n in prop)el.style[Loader.prototype.vendor(el, n) || n] = prop[n];
        return el;
    };
    // Fills in default values.
    Loader.prototype.merge = function(obj) {
        for(var i = 1; i < arguments.length; i++){
            var def = arguments[i];
            for(var n in def)if (obj[n] === undefined) obj[n] = def[n];
        }
        return obj;
    };
    // Returns the line color from the given string or array.
    Loader.prototype.getColor = function(color, idx) {
        return typeof color === 'string' ? color : color[idx % color.length];
    };
    Loader.prototype.attach = function(options) {
        // this.stop()
        // Reference the loading container
        var container = document.getElementById(options.container);
        if (container) {
            // Create the loading element
            var element = Loader.prototype.createHtmlElement('div', {
                id: 'loader',
                "class": 'govuk-c-loader',
                role: 'progressbar',
                'aria-label': options.labelText,
                // 'aria-valuetext': options.labelText, //human readable text alternative of aria-valuenow
                tabindex: '0'
            });
            // Create the spinner
            var spinner;
            if (!options.useVml) // SVG version
            spinner = Loader.prototype.createSvgElement('svg', {
                version: '1.1',
                xmlns: 'http://www.w3.org/2000/svg',
                "class": 'govuk-c-loader__spinner',
                width: options.size,
                height: options.size,
                viewBox: '-50 -50 100 100',
                preserveAspectRatio: 'xMidYMid meet'
            });
            else // VML version
            spinner = Loader.prototype.createHtmlElement('div', {
                "class": 'govuk-c-loader__spinner',
                style: 'left: 50%; width: ' + options.size + 'px; height: ' + options.size + 'px; position: absolute; top: 50%;'
            });
            element.appendChild(spinner);
            // Create the label
            if (options.label) {
                var label = Loader.prototype.createHtmlElement('label', {
                    id: 'loading-label',
                    "class": 'govuk-c-loader__label',
                    role: 'status',
                    'aria-label': 'Uploading'
                });
                label.innerHTML = options.labelText;
                element.setAttribute('aria-labelledby', 'loading-label'); // for generic or updating messages
                element.appendChild(label);
                // Save label reference for updates
                this.label = label;
            }
            // Set ARIA attributes to show progress
            if (options.progress) {
                // element.setAttribute('role', 'slider')
                element.setAttribute('aria-valuemin', '0');
                element.setAttribute('aria-valuenow', '0');
                element.setAttribute('aria-valuemax', '100');
            }
            // Insert the loading elements
            container.insertBefore(element, container.firstChild || null);
            container.setAttribute('aria-busy', 'true');
            // Save references
            this.container = container;
            this.element = element;
            this.options = options;
            // Add lines to the spinner element
            Loader.prototype.lines(spinner, options);
            // If no CSS animation support, use setTimeout() instead
            if (!useCssAnimations) Loader.prototype.useJsAnimations(spinner, options);
        }
        return this;
    };
    Loader.prototype.useJsAnimations = function(element, options) {
        var i = 0;
        var start = (options.lines - 1) * (1 - options.direction) / 2;
        var alpha;
        var fps = options.fps;
        var f = fps / options.speed;
        var ostep = (1 - options.opacity) / (f * options.trail / 100);
        var astep = f / options.lines;
        (function animate() {
            i++;
            for(var j = 0; j < options.lines; j++){
                alpha = Math.max(1 - (i + (options.lines - j) * astep) % f * ostep, options.opacity);
                Loader.prototype.opacity(element, j * options.direction + start, alpha);
            }
            this.timeout = element && setTimeout(animate, ~~(1000 / fps));
        })();
    };
    Loader.prototype.lines = function(element, options) {
        var i = 0;
        var start = (options.lines - 1) * (1 - options.direction) / 2;
        var line;
        for(; i < options.lines; i++){
            line = Loader.prototype.css(Loader.prototype.createSvgElement('rect', {
                fill: options.color,
                width: options.length + options.width,
                height: options.width,
                rx: options.corners * options.width,
                ry: options.corners * options.width,
                transform: 'rotate(' + ~~(360 / options.lines * i + options.rotate) + ', 0, 2) translate(' + options.radius + ' 0)',
                opacity: options.opacity
            }), {
                animation: useCssAnimations && Loader.prototype.addAnimation(options.opacity, options.trail, start + i * options.direction, options.lines) + ' ' + 1 / options.speed + 's linear infinite'
            });
            Loader.prototype.insertElement(element, line);
        }
        return element;
    };
    // Internal method that adjusts the opacity of a single line.
    // Will be overwritten in VML fallback mode below.
    Loader.prototype.opacity = function(element, i, value) {
        if (i < element.childNodes.length) element.childNodes[i].setAttribute('opacity', value);
    };
    Loader.prototype.initVML = function(options) {
        // Utility function to create VML elements. Optionally properties can be passed.
        Loader.prototype.createVmlElement = function(tag, attr) {
            return Loader.prototype.createHtmlElement('<' + tag + ' xmlns="urn:schemas-microsoft.com:vml" class="loading-vml">', attr);
        };
        // No CSS transforms but VML support, add a CSS rule for VML elements:
        if (!sheet) console.error("GOV Loader: Missing css sheet element");
        else sheet.addRule('.loading-vml', 'behavior:url(#default#VML)');
        Loader.prototype.lines = function(element, options) {
            var r = options.length + options.width;
            var s = 2 * r;
            function createGroupElement() {
                return Loader.prototype.css(Loader.prototype.createVmlElement('group', {
                    coordsize: s + ' ' + s,
                    coordorigin: -r + ' ' + -r
                }), {
                    width: s,
                    height: s
                });
            }
            var margin = -(options.width + options.length) * 2 + 'px';
            var g = Loader.prototype.css(createGroupElement(), {
                position: 'absolute',
                top: margin,
                left: margin
            });
            var i;
            function seg(i, dx) {
                Loader.prototype.insertElement(g, Loader.prototype.insertElement(Loader.prototype.css(createGroupElement(), {
                    rotation: 360 / options.lines * i + 'deg',
                    left: ~~dx
                }), Loader.prototype.insertElement(Loader.prototype.css(Loader.prototype.createVmlElement('roundrect', {
                    arcsize: options.corners
                }), {
                    width: r,
                    height: options.width,
                    left: options.radius,
                    top: -options.width >> 1
                }), // Loader.prototype.createVmlElement('fill', {color: getColor(options.color, i), opacity: options.opacity}),
                Loader.prototype.createVmlElement('fill', {
                    color: options.color,
                    opacity: options.opacity
                }), Loader.prototype.createVmlElement('stroke', {
                    opacity: 0
                }) // transparent stroke to fix color bleeding upon opacity change
                )));
            }
            for(i = 1; i <= options.lines; i++)seg(i, -2);
            return Loader.prototype.insertElement(element, g);
        };
        Loader.prototype.opacity = function(element, i, value) {
            var c = element.firstChild;
            if (c && i < c.childNodes.length) {
                c = c.childNodes[i];
                c = c && c.firstChild;
                c = c && c.firstChild;
                if (c) c.opacity = value;
            }
        };
    };
    Loader.prototype.init = function(options) {
        if (options && options.container) {
            options = Loader.prototype.merge(options || {}, Loader.defaults, defaults);
            // Initialise style injection
            if (options.styleElementId) {
                var elt = document.getElementById(options.styleElementId);
                if (!elt || !elt.sheet) console.error("GOV Loader: Did not find style element");
                else sheet = elt.sheet;
            } else // inject a <style> element; will be blocked if CSP is in place
            sheet = function() {
                var element = Loader.prototype.createHtmlElement('style', {
                    type: 'text/css'
                });
                Loader.prototype.insertElement(document.getElementsByTagName('head')[0], element);
                return element.sheet || element.styleSheet;
            }();
            // Probe html group element for VML
            var probe = Loader.prototype.css(Loader.prototype.createHtmlElement('group'), {
                behavior: 'url(#default#VML)'
            });
            // Test probe element for transform support
            if (!Loader.prototype.vendor(probe, 'transform') && probe.adj) {
                Loader.prototype.initVML();
                options.useVml = true;
            } else useCssAnimations = Loader.prototype.vendor(probe, 'animation');
            Loader.prototype.attach(options);
        } else window.console.warn('Please specify a container for the loader');
        return this;
    };
    Loader.prototype.updateMessage = function(message) {
        this.label.innerHTML = message;
    };
    Loader.prototype.updateProgress = function(progress) {
        this.element.setAttribute('aria-valuenow', progress);
    };
    Loader.prototype.updateContainer = function(content) {
        this.container.innerHTML = content;
    };
    // Stops and removes the Loading
    Loader.prototype.stop = function(element) {
        if (!element) element = document.getElementById('loader');
        if (element) {
            clearTimeout(this.timeout);
            if (element.parentNode) {
                element.parentNode.removeAttribute('aria-busy');
                element.parentNode.removeChild(element);
            }
            element = undefined;
        }
        return this;
    };
    GOVUK.Loader = Loader;
    global.GOVUK = GOVUK;
})(window); // eslint-disable-line semi

},{}],"9Relc":[function(require,module,exports,__globalThis) {
// Given a URL for an Object in S3, extracts the "bucket" and "key" values,
// which are required for various S3 API ops.
// The key is url encoded by S3, including "/" chars, when it is used in the
// contexts we are interested in.
// S3 is sometimes inconsistent in this, and will frequently not escape some
// chars like "/" in S3 keys in some contexts. If "/" is not escaped in the
// URL, then this function will cope fine.
exports.urlToBucketKey = function(url) {
    // Most common URL type: the bucket is shown as a sub-domain of the S3 hostname.
    // The ignored part of the hostname is the AWS region, e.g. "eu-west-2".
    var bucketHostRe = new RegExp("^https://([^./]+).s3.[^./]+.amazonaws.com/(.+)$");
    var m = bucketHostRe.exec(url);
    if (m) return {
        bucket: m[1],
        key: s3KeyUrlDecode(m[2])
    };
    // Less commonly, the bucket may appear as a dirname in a S3 hostname.
    // This style is used by our local mock S3 server during local dev, so we
    // need to support it here for local dev to work.
    var bucketPathRe = new RegExp("^https?://[^/]+/([^/]+)/(.+)$");
    m = bucketPathRe.exec(url);
    if (m) return {
        bucket: m[1],
        key: s3KeyUrlDecode(m[2])
    };
    throw new Error("Unable to parse url as an S3 object URL");
};
function s3KeyUrlDecode(encodedKey) {
    return decodeURIComponent(encodedKey.replaceAll("+", " "));
}

},{}],"jCUN9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _nativeJs = require("./native.js");
var _nativeJsDefault = parcelHelpers.interopDefault(_nativeJs);
var _rngJs = require("./rng.js");
var _rngJsDefault = parcelHelpers.interopDefault(_rngJs);
var _stringifyJs = require("./stringify.js");
function v4(options, buf, offset) {
    if ((0, _nativeJsDefault.default).randomUUID && !buf && !options) return (0, _nativeJsDefault.default).randomUUID();
    options = options || {};
    var rnds = options.random || (options.rng || (0, _rngJsDefault.default))();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, _stringifyJs.unsafeStringify)(rnds);
}
exports.default = v4;

},{"./native.js":"agIuk","./rng.js":"jeH6A","./stringify.js":"2bI4V","@parcel/transformer-js/src/esmodule-helpers.js":"2qAMd"}],"agIuk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
exports.default = {
    randomUUID: randomUUID
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"2qAMd"}],"jeH6A":[function(require,module,exports,__globalThis) {
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return rng;
});
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return getRandomValues(rnds8);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"2qAMd"}],"2bI4V":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unsafeStringify", function() {
    return unsafeStringify;
});
var _validateJs = require("./validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var byteToHex = [];
for(var i = 0; i < 256; ++i)byteToHex.push((i + 0x100).toString(16).slice(1));
function unsafeStringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    //
    // Note to future-self: No, you can't remove the `toLowerCase()` call.
    // REF: https://github.com/uuidjs/uuid/pull/677#issuecomment-1757351351
    return (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase();
}
function stringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    var uuid = unsafeStringify(arr, offset);
    // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, _validateJsDefault.default)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
exports.default = stringify;

},{"./validate.js":"lfsPy","@parcel/transformer-js/src/esmodule-helpers.js":"2qAMd"}],"lfsPy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _regexJs = require("./regex.js");
var _regexJsDefault = parcelHelpers.interopDefault(_regexJs);
function validate(uuid) {
    return typeof uuid === 'string' && (0, _regexJsDefault.default).test(uuid);
}
exports.default = validate;

},{"./regex.js":"3HSCc","@parcel/transformer-js/src/esmodule-helpers.js":"2qAMd"}],"3HSCc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"2qAMd"}],"7yULf":[function(require,module,exports,__globalThis) {
/**
 * This file is similar to:
 *    - photo-upload.js
 *    - upload-documents.js
 *    - upload-documents-pre-selected.js
 *  Bugs found here likely have to be fixed there too.
 *  Possibility of commonizing these in the future.
 *
 *  This file (upload-documents-pre-selected.js) is currently used by:
 *    - VAC, Postal and Proxy "pre selected upload"
 *      frontend/src/forms/shared/upload-documents-pre-selected/upload-documents-pre-selected.njk
 */ var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _loader = require("../components/loader");
var _s3 = require("../s3");
exports.uploadDocumentsPreSelected = function(docTypesToUpload, maxFileSizeInMB, minFileSizeInKB, acceptedFileExtensions, error__none_selected, error__too_big, error__too_small, error__filetypes, error__unknown, error__abort, screen_reader_alert__file_added, screen_reader_alert__file_removed, allowPartialCompletion, button_text__continue, error_phrase) {
    // TODO:EIP1-7498 add something like preventDropFilesExceptOnDropArea();
    // should also allow drop files onto the whole card for each file type
    addScreenReaderFileStatusAlert();
    var continueForm = document.getElementById("continue-form");
    var nextButton = continueForm.querySelector('button[name="submit-button"]');
    disableNextButtonOnRemoveFile();
    // the js code only runs while still uploading
    if (docTypesToUpload.length === 0) return;
    var errorMessages = {
        error__none_selected: error__none_selected,
        error__too_big: error__too_big,
        error__too_small: error__too_small,
        error__filetypes: error__filetypes,
        error__unknown: error__unknown,
        error__abort: error__abort
    };
    var spinner = new GOVUK.Loader();
    enableNextButton();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var type = _step.value;
            var fileUpload = document.getElementById('file-upload-' + type);
            var uploadForm = document.getElementById('upload-form-' + type);
            var uploadFormOrFilePreviewElt = document.getElementById('upload-form-or-file-preview-' + type);
            var uploadButton = uploadForm.querySelector('button[name="upload-button"]');
            var formComponents = {
                type: type,
                uploadBoxId: 'upload-box-' + type,
                uploadForm: uploadForm,
                uploadButtonId: 'upload-button-' + type,
                fileUpload: fileUpload,
                spinnerId: 'spinner-container-id-' + type,
                uploadFormOrFilePreviewElt: uploadFormOrFilePreviewElt,
                fileHasBeenUploadedOk: false
            };
            fileUpload.classList.add("hidden");
            fileUpload.addEventListener('change', function(event) {
                return uploadFile(event, formComponents);
            });
            uploadButton.addEventListener('click', function() {
                return fileUpload.click();
            });
            uploadButton.id = formComponents.uploadButtonId;
            uploadButton.type = "button";
        };
        // containers
        for(var _iterator = docTypesToUpload[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // error components
    var errors = {};
    var jsErrorSummary = document.querySelector(".govuk-error-summary");
    var jsErrorList = jsErrorSummary.querySelector("ul");
    function uploadFile(event, formComponents) {
        event.preventDefault();
        disableNextButton();
        setDisabledForOtherUploadButtons(formComponents.type, true);
        clearErrors();
        formComponents.uploadForm.classList.add("govuk-visually-hidden");
        spinner.init({
            container: formComponents.spinnerId,
            styleElementId: "loading-spinner-styles",
            label: true
        });
        var file = formComponents.fileUpload.files[0];
        var fileIsValid = validateFile(file, formComponents.uploadButtonId);
        if (!fileIsValid) {
            renderErrorAndResetPageControls(formComponents);
            return false;
        }
        // testing browser support. if no support for the required js APIs
        // the form will just be posted naturally with no progress showing.
        var xhr = new XMLHttpRequest();
        if (!(xhr && 'upload' in xhr && 'onprogress' in xhr.upload) || !window.FormData) {
            formComponents.uploadForm.submit();
            return;
        }
        xhr.upload.onprogress = progressHandler;
        xhr.onerror = function(data) {
            return errorHandler(data, formComponents);
        };
        xhr.onabort = function() {
            return abortHandler(formComponents);
        };
        xhr.onload = s3UploadCompleteHandler.bind(this, xhr, formComponents, file.name);
        var formData = new FormData(formComponents.uploadForm);
        // set to "" so not redirected automatically
        formData.set("success_action_redirect", "");
        xhr.open('POST', formComponents.uploadForm.action);
        xhr.send(formData);
        return false;
    }
    function validateFile(file, uploadButtonId) {
        if (!file) {
            errors[uploadButtonId] = errorMessages.error__none_selected;
            return false;
        }
        if (file.size > maxFileSizeInMB * 1000000) {
            errors[uploadButtonId] = errorMessages.error__too_big;
            return false;
        }
        if (file.size < minFileSizeInKB * 1000) {
            errors[uploadButtonId] = errorMessages.error__too_small;
            return false;
        }
        var nameLower = file.name.toLowerCase();
        if (!acceptedFileExtensions.find(function(ext) {
            return nameLower.endsWith(ext);
        })) {
            errors[uploadButtonId] = errorMessages.error__filetypes;
            return false;
        }
        clearErrorSummaryItems();
        return true;
    }
    function progressHandler(e) {
        var progress = Math.floor(e.loaded / e.total * 100);
        spinner.updateMessage("Uploading... ".concat(progress, "%"));
        spinner.updateProgress(progress);
    }
    // Called when the upload to S3 has completed
    function s3UploadCompleteHandler(uploadXhr, formComponents, fileName) {
        try {
            spinner.updateMessage("Processing");
            if (uploadXhr.status !== 204) // 'xhr.onerror' is only called if there's an error at the network level.
            // If the error only exists at the application level (e.g. an HTTP error code is sent), it will not be called.
            // So we need to check the status code here in order to show a validation message if s3 reject the file.
            throw new Error("Error status from S3: " + uploadXhr.status);
            // Tell the backend the name of the file that was just uploaded,
            // so the session state can be updated.
            // This allows us to avoid S3 "list" ops, which don't scale to high load.
            //
            // If the client browser fails or goes offline between the above op and
            // this then the image info will not get added to the session, and they
            // will need to upload it again
            // S3 can change the provided filename, for example spaces are trimmed.
            // We therefore get the final bucket + key info from the Location header
            var s3Location = uploadXhr.getResponseHeader("location");
            var bucketKey = (0, _s3.urlToBucketKey)(s3Location);
            // browser xhr support was already tested above
            var xhr = new XMLHttpRequest();
            xhr.onload = sessionUpdateCompleteHandler.bind(this, xhr, formComponents);
            xhr.onerror = function(e) {
                return errorHandler(e, formComponents);
            };
            xhr.onabort = function() {
                return abortHandler(formComponents);
            };
            xhr.open('POST', document.location);
            var formData = {
                "s3-upload-complete": "true",
                bucket: bucketKey.bucket,
                key: bucketKey.key
            };
            xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
            // ask the browser to parse the html response into a DOM
            xhr.responseType = "document";
            xhr.send(new URLSearchParams(Object.entries(formData)).toString());
        } catch (e) {
            errorHandler(e, formComponents);
        }
    }
    // Called when the after-upload session update XHR has completed
    function sessionUpdateCompleteHandler(xhr, formComponents) {
        try {
            var _elt;
            if (xhr.status !== 200) // 'xhr.onerror' is only called if there's an error at the network level.
            // If the error only exists at the application level (e.g. an HTTP error code is sent), it will not be called.
            // So we need to check the status code here in order to show a validation message if s3 reject the file.
            throw new Error("Error status from backend: " + xhr.status);
            var newHtml = xhr.responseXML;
            if (!newHtml) throw new Error("responseXML null. Not supported browser?");
            var elt = formComponents.uploadFormOrFilePreviewElt;
            (_elt = elt).replaceChildren.apply(_elt, (0, _toConsumableArray._)(newHtml.body.childNodes));
            resetPageControls();
            setDisabledForOtherUploadButtons(formComponents.type, false);
            formComponents.fileHasBeenUploadedOk = true;
            screenReaderFileAlert(screen_reader_alert__file_added);
            allowPartialCompletion && updateContinueButtonText();
            disableNextButtonOnRemoveFile();
        } catch (e) {
            errorHandler(e, formComponents);
        }
    }
    function errorHandler(data, formComponents) {
        console.error(data);
        errors[formComponents.uploadBoxId] = errorMessages.error__unknown;
        renderErrorAndResetPageControls(formComponents);
    }
    function abortHandler(formComponents) {
        errors[formComponents.uploadBoxId] = errorMessages.error__abort;
        renderErrorAndResetPageControls(formComponents);
    }
    function renderErrors(uploadForm) {
        spinner.stop();
        uploadForm.classList.remove("govuk-visually-hidden");
        Object.entries(errors).forEach(function(param) {
            var _param = (0, _slicedToArray._)(param, 2), fieldId = _param[0], message = _param[1];
            addErrorSummaryItem(fieldId, message);
            addErrorToField(fieldId, message);
        });
        jsErrorSummary.style.display = 'block';
        jsErrorSummary.focus();
        document.body.scrollTop = document.documentElement.scrollTop = 0;
    }
    function clearErrorSummaryItems() {
        // Some pages have an error summary which is hidden by default, some don't. Setting to none works in both cases.
        jsErrorSummary.style.display = 'none';
        jsErrorList.childNodes.forEach(function(child) {
            jsErrorList.removeChild(child);
        });
    }
    function clearErrors() {
        Object.keys(errors).forEach(function(fieldId) {
            jsErrorList.removeChild(document.getElementById(fieldId + "--top-error"));
            removeErrorFromField(fieldId);
            delete errors[fieldId];
        });
    }
    function addErrorSummaryItem(fieldId, errorMessage) {
        var listItem = document.createElement("li");
        var anchor = listItem.appendChild(document.createElement("a"));
        anchor.href = "#" + fieldId;
        anchor.textContent = errorMessage;
        listItem.id = fieldId + "--top-error";
        jsErrorList.appendChild(listItem);
    }
    function addErrorToField(fieldId, errorMessage) {
        var field = document.getElementById(fieldId);
        var container = field.parentNode;
        var spanId = field.id + "--span-error";
        var span = document.getElementById(spanId);
        if (span && span.lastChild) span.lastChild.textContent = errorMessage;
        else {
            span = document.createElement("span");
            span.id = spanId;
            span.className = 'govuk-error-message';
            var hiddenSpan = span.appendChild(document.createElement("span"));
            hiddenSpan.className = "govuk-visually-hidden";
            hiddenSpan.textContent = "".concat(error_phrase, ":");
            var errorSpan = span.appendChild(document.createElement("span"));
            errorSpan.textContent = errorMessage;
        }
        container.insertBefore(span, field);
        container.classList.add("govuk-form-group--error");
    }
    function removeErrorFromField(fieldId) {
        var field = document.getElementById(fieldId);
        var container = field.parentNode;
        var spanId = field.id + "--span-error";
        var span = document.getElementById(spanId);
        if (span) {
            container.removeChild(span);
            container.classList.remove("govuk-form-group--error");
        }
    }
    function renderErrorAndResetPageControls(formComponents) {
        resetPageControls();
        formComponents.fileUpload.value = "";
        renderErrors(formComponents.uploadForm);
        setDisabledForOtherUploadButtons(formComponents.type, false);
        updateTitleIfNotAlreadyInError();
        jsErrorSummary.style.display = 'block';
        jsErrorSummary.focus();
        document.body.scrollTop = document.documentElement.scrollTop = 0;
    }
    function updateTitleIfNotAlreadyInError() {
        var title = document.title;
        if (title && !title.startsWith("".concat(error_phrase, ":"))) document.title = "".concat(error_phrase, ": ").concat(title);
    }
    // Hide the spinner and re-enable the next button
    function resetPageControls() {
        spinner.stop();
        enableNextButton();
        clearErrorSummaryItems();
    }
    function enableNextButton() {
        nextButton.removeAttribute("disabled");
        nextButton.removeAttribute("aria-disabled");
    }
    function disableNextButton() {
        nextButton.setAttribute("disabled", "");
        nextButton.setAttribute("aria-disabled", true);
    }
    function setDisabledForOtherUploadButtons(currentType, value) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = docTypesToUpload.filter(function(docType) {
                return docType !== currentType;
            })[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var type = _step.value;
                var uploadForm = document.getElementById('upload-form-' + type);
                if (uploadForm) uploadForm.querySelector('button[name="upload-button"]').disabled = value;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    function addScreenReaderFileStatusAlert() {
        var urlSearchParams = new URLSearchParams(window.location.search);
        if (urlSearchParams.get("file-removed") === "true") screenReaderFileAlert(screen_reader_alert__file_removed);
    // no "file-added" case, as that's either handled directly in js,
    // see screen_reader_alert__file_added above, or we're no-js
    }
    function screenReaderFileAlert(alertMessage) {
        var alert = document.getElementById("hidden-alert-container");
        alert.innerHTML = alertMessage;
    }
    function updateContinueButtonText() {
        // No need to update button on file removal, as page refreshes
        nextButton.innerHTML = button_text__continue;
    }
    function disableNextButtonOnRemoveFile() {
        var removeFileButtons = document.getElementsByName('remove-file-button');
        removeFileButtons && removeFileButtons.forEach(function(button) {
            button.addEventListener('click', function() {
                disableNextButton();
            });
        });
    }
};

},{"@swc/helpers/_/_sliced_to_array":"jFaLC","@swc/helpers/_/_to_consumable_array":"6XR2l","../components/loader":"1sVIf","../s3":"9Relc"}],"7HrKf":[function(require,module,exports,__globalThis) {
var accessibleAutocomplete = require("8ec6ed74b80bc6aa");
var getListOfCountriesForQuery = require("88e7b0371a17e36e").getListOfCountriesForQuery;
var onConfirmHandlers = new Map();
function addCountryOrNationalityAutocomplete(selectElementName, countryListAssetLocation, includeUk) {
    var countryOrNatSelects = document.getElementsByClassName(selectElementName);
    fetch(countryListAssetLocation).then(function(res) {
        if (!res.ok) throw new Error("Failed to load country or nationality JSON: ".concat(res.statusText));
        return res.json();
    }).then(function(countryData) {
        if (includeUk) countryData.push(UKAutocompleteData);
        Array.from(countryOrNatSelects).forEach(function(countryOrNatSelect) {
            var autocompleteId = countryOrNatSelect.id;
            var onConfirmHandler = setSelectWithCountryOrInvalid(countryOrNatSelect, autocompleteId);
            onConfirmHandlers.set(autocompleteId, onConfirmHandler);
            accessibleAutocomplete.enhanceSelectElement({
                selectElement: countryOrNatSelect,
                source: getListOfCountriesForQuery(countryData),
                minLength: 2,
                onConfirm: onConfirmHandler
            });
            copyClassesFromSelectToAutoComplete(countryOrNatSelect, autocompleteId);
            addExtraAccessibilityAttributes(autocompleteId);
        });
        setupFormSubmitHandler();
    });
}
function copyClassesFromSelectToAutoComplete(selectElt, inputId) {
    /* Sadly accessible-autocomplete.enhanceSelectElement() does not do not copy
    * over all the required classes from the select to the completing input.
    * This has been raised as an issue, and may be fixed in the future.
    * We can't fix this by wrapping the whole input group in a width class as that
    * would unnecessarily narrow any long error messages. */ var autocompleteInput = document.getElementById(inputId);
    if (autocompleteInput) {
        var autocompleteWrapper = autocompleteInput && autocompleteInput.closest && autocompleteInput.closest(".autocomplete__wrapper");
        if (autocompleteWrapper && autocompleteWrapper.classList) for(var j = 0; j < selectElt.classList.length; j++){
            var clazz = selectElt.classList[j];
            if (/-autocomplete$/.test(clazz) || "govuk-select" === clazz) ;
            else // The classes will be error or width classes, need to go on the wrapper
            // so they don't get dropped when the input class gets modified at runtime
            autocompleteWrapper.classList.add(clazz);
        }
    }
}
function setSelectWithCountryOrInvalid(nationalitySelect, autocompleteId) {
    return function(countryActivelySelected) {
        /* At time of writing, if you enter something not in the list, the default implementation of "onConfirm" posts the previously selected value.
        * This is unideal and counterintuitive, and we should instead throw a validation error. This has been raised as an issue in the accessible-autocomplete project.
        * To fix this, if you type in a country not in the list, we add a new option to the select element "invalid-option-selected" and select this.
        * This means that POST'ing will cause a validation error as "invalid-option-selected" is not a valid country.
        * It'll then clear what the user has entered, as this "invalid-option-selected" option will not be present in the select on re-render. */ var countryInInputBox = document.getElementById(autocompleteId).value;
        /* We need to consider both "countryActivelySelected" and "countryInInputBox", as this function will be run with
           countryActivelySelected = undefined if you just click in and out of the box, even if a valid country is in the box.
           On the other hand, if you actively select a country, this function will be run before the value in the input box
           has been updated, hence countryActivelySelected is required
        * */ var chosenCountry = countryActivelySelected || countryInInputBox;
        // If the input box is empty, chosenCountry will be undefined, which is one of the options in nationalitySelect.options
        var chosenCountryIsInOptionsListOrEmpty = Array.from(nationalitySelect.options).some(function(option) {
            return option.value === chosenCountry && option.value !== "invalid-option-selected";
        });
        var invalidOption = nationalitySelect.querySelector("option[value='invalid-option-selected']");
        if (chosenCountryIsInOptionsListOrEmpty) {
            if (invalidOption) nationalitySelect.removeChild(invalidOption);
            nationalitySelect.value = chosenCountry;
        } else if (!invalidOption) {
            var newOption = document.createElement("option");
            newOption.value = "invalid-option-selected";
            // Not user facing text so doesn't need to be welsh translated
            newOption.textContent = "Invalid Option Selected";
            nationalitySelect.appendChild(newOption);
            nationalitySelect.value = "invalid-option-selected";
        }
    };
}
/*
* This was picked up in an accessibility audit (see https://mhclgdigital.atlassian.net/browse/EIP1-12476).
* Remove if accessible-autocomplete updates to include this by default.
* */ function addExtraAccessibilityAttributes(autocompleteId) {
    var countryLabel = document.querySelector("label.govuk-label[for='".concat(autocompleteId, "']"));
    var countryCombobox = document.getElementById("".concat(autocompleteId));
    var countryList = document.getElementById("".concat(autocompleteId, "__listbox"));
    countryLabel.setAttribute("id", "".concat(autocompleteId, "-combo-label"));
    countryCombobox.setAttribute("aria-controls", "".concat(autocompleteId, "__listbox"));
    countryList.setAttribute("aria-labelledby", "".concat(autocompleteId, "-combo-label"));
}
// The onConfirm function is called when you click away from the country autocomplete component, but not if you submit the form without
// doing so, e.g. by pressing the enter key. Hence, we need to also call it manually on form submit.
function setupFormSubmitHandler() {
    var autocompleteInputs = Array.from(document.querySelectorAll('.autocomplete__input'));
    autocompleteInputs.forEach(function(input) {
        var form = input.closest('form');
        if (form && !form.hasAttribute('data-autocomplete-submit-handler')) {
            form.setAttribute('data-autocomplete-submit-handler', 'true');
            form.addEventListener('submit', function() {
                onConfirmHandlers.forEach(function(handler, autocompleteId) {
                    var autocompleteInput = document.getElementById(autocompleteId);
                    if (autocompleteInput && form.contains(autocompleteInput)) handler();
                });
            });
        }
    });
}
exports.nationalityAutocomplete = function countryAutocomplete(assetRoot, includeUk) {
    addCountryOrNationalityAutocomplete("nationality-autocomplete", "".concat(assetRoot, "/shared/js/nationalities-autocomplete.json"), includeUk);
};
exports.countryOfResidenceAutocomplete = function countryOfResidenceAutocomplete(assetRoot, includeUk) {
    addCountryOrNationalityAutocomplete("country-of-residence-autocomplete", "".concat(assetRoot, "/shared/js/countries-of-residence-autocomplete.json"), includeUk);
};
var UKAutocompleteData = {
    canonicalName: "United Kingdom (including the Channel Islands or Isle of Man)",
    aliases: [
        "An Rywvaneth Unys",
        "Britain",
        "GB",
        "Great Britain",
        "R\xecoghachd Aonaichte",
        "R\xedocht Aontaithe",
        "U.K.",
        "UK",
        "United Kingdom of Great Britain and Northern Ireland",
        "Unitit Kinrick",
        "Y Deyrnas Unedig",
        "England",
        "Scotland",
        "Wales",
        "Northern Ireland"
    ]
};

},{"8ec6ed74b80bc6aa":"byrO5","88e7b0371a17e36e":"8JpHN"}],"byrO5":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
(function webpackUniversalModuleDefinition(e, t) {
    module.exports = t();
})(window, function() {
    return function(n) {
        var r = {};
        function o(e) {
            if (r[e]) return r[e].exports;
            var t = r[e] = {
                i: e,
                l: !1,
                exports: {}
            };
            return n[e].call(t.exports, t, t.exports, o), t.l = !0, t.exports;
        }
        return o.m = n, o.c = r, o.d = function(e, t, n) {
            o.o(e, t) || Object.defineProperty(e, t, {
                enumerable: !0,
                get: n
            });
        }, o.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, o.t = function(t, e) {
            if (1 & e && (t = o(t)), 8 & e) return t;
            if (4 & e && "object" == (typeof t === "undefined" ? "undefined" : (0, _typeOf._)(t)) && t && t.__esModule) return t;
            var _$n = Object.create(null);
            if (o.r(_$n), Object.defineProperty(_$n, "default", {
                enumerable: !0,
                value: t
            }), 2 & e && "string" != typeof t) for(var r in t)o.d(_$n, r, (function(e) {
                return t[e];
            }).bind(null, r));
            return _$n;
        }, o.n = function(e) {
            var t = e && e.__esModule ? function t() {
                return e["default"];
            } : function() {
                return e;
            };
            return o.d(t, "a", t), t;
        }, o.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, o.p = "/", o(o.s = 37);
    }([
        function(e, t, n) {
            var m = n(1), v = n(6), y = n(7), g = n(16), _ = n(18), b = "prototype", w = function w1(e, t, n) {
                var r, o, i, u, a = e & w.F, s = e & w.G, l = e & w.S, c = e & w.P, p = e & w.B, f = s ? m : l ? m[t] || (m[t] = {}) : (m[t] || {})[b], d = s ? v : v[t] || (v[t] = {}), h = d[b] || (d[b] = {});
                for(r in s && (n = t), n)i = ((o = !a && f && f[r] !== undefined) ? f : n)[r], u = p && o ? _(i, m) : c && "function" == typeof i ? _(Function.call, i) : i, f && g(f, r, i, e & w.U), d[r] != i && y(d, r, u), c && h[r] != i && (h[r] = i);
            };
            m.core = v, w.F = 1, w.G = 2, w.S = 4, w.P = 8, w.B = 16, w.W = 32, w.U = 64, w.R = 128, e.exports = w;
        },
        function(e, t) {
            var n = e.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
            "number" == typeof __g && (__g = n);
        },
        function(e, t) {
            e.exports = function(e) {
                return "object" == (typeof e === "undefined" ? "undefined" : (0, _typeOf._)(e)) ? null !== e : "function" == typeof e;
            };
        },
        function(e, t, n) {
            e.exports = !n(4)(function() {
                return 7 != Object.defineProperty({}, "a", {
                    get: function get() {
                        return 7;
                    }
                }).a;
            });
        },
        function(e, t) {
            e.exports = function(e) {
                try {
                    return !!e();
                } catch (t) {
                    return !0;
                }
            };
        },
        function(e, t, n) {
            "use strict";
            n.r(t), n.d(t, "h", function() {
                return r;
            }), n.d(t, "createElement", function() {
                return r;
            }), n.d(t, "cloneElement", function() {
                return i;
            }), n.d(t, "Component", function() {
                return g;
            }), n.d(t, "render", function() {
                return _;
            }), n.d(t, "rerender", function() {
                return f;
            }), n.d(t, "options", function() {
                return E;
            });
            var s = function s() {}, E = {}, l = [], c = [];
            function r(e, t) {
                var _$n, _$r, o, _$i, u = c;
                for(_$i = arguments.length; 2 < _$i--;)l.push(arguments[_$i]);
                for(t && null != t.children && (l.length || l.push(t.children), delete t.children); l.length;)if ((_$r = l.pop()) && _$r.pop !== undefined) for(_$i = _$r.length; _$i--;)l.push(_$r[_$i]);
                else "boolean" == typeof _$r && (_$r = null), (o = "function" != typeof e) && (null == _$r ? _$r = "" : "number" == typeof _$r ? _$r = String(_$r) : "string" != typeof _$r && (o = !1)), o && _$n ? u[u.length - 1] += _$r : u === c ? u = [
                    _$r
                ] : u.push(_$r), _$n = o;
                var a = new s;
                return a.nodeName = e, a.children = u, a.attributes = null == t ? undefined : t, a.key = null == t ? undefined : t.key, E.vnode !== undefined && E.vnode(a), a;
            }
            function M(e, t) {
                for(var _$n in t)e[_$n] = t[_$n];
                return e;
            }
            var o = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout;
            function i(e, t) {
                return r(e.nodeName, M(M({}, e.attributes), t), 2 < arguments.length ? [].slice.call(arguments, 2) : e.children);
            }
            var p = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i, u = [];
            function a(e) {
                !e._dirty && (e._dirty = !0) && 1 == u.push(e) && (E.debounceRendering || o)(f);
            }
            function f() {
                var e, _$t = u;
                for(u = []; e = _$t.pop();)e._dirty && V(e);
            }
            function N(e, t) {
                return e.normalizedNodeName === t || e.nodeName.toLowerCase() === t.toLowerCase();
            }
            function I(e) {
                var _$t = M({}, e.attributes);
                _$t.children = e.children;
                var _$n = e.nodeName.defaultProps;
                if (_$n !== undefined) for(var _$r in _$n)_$t[_$r] === undefined && (_$t[_$r] = _$n[_$r]);
                return _$t;
            }
            function k(e) {
                var _$t = e.parentNode;
                _$t && _$t.removeChild(e);
            }
            function v(e, t, n, r, o) {
                if ("className" === t && (t = "class"), "key" === t) ;
                else if ("ref" === t) n && n(null), r && r(e);
                else if ("class" !== t || o) {
                    if ("style" === t) {
                        if (r && "string" != typeof r && "string" != typeof n || (e.style.cssText = r || ""), r && "object" == (typeof r === "undefined" ? "undefined" : (0, _typeOf._)(r))) {
                            if ("string" != typeof n) for(var _$i in n)_$i in r || (e.style[_$i] = "");
                            for(var _$i in r)e.style[_$i] = "number" == typeof r[_$i] && !1 === p.test(_$i) ? r[_$i] + "px" : r[_$i];
                        }
                    } else if ("dangerouslySetInnerHTML" === t) r && (e.innerHTML = r.__html || "");
                    else if ("o" == t[0] && "n" == t[1]) {
                        var u = t !== (t = t.replace(/Capture$/, ""));
                        t = t.toLowerCase().substring(2), r ? n || e.addEventListener(t, d, u) : e.removeEventListener(t, d, u), (e._listeners || (e._listeners = {}))[t] = r;
                    } else if ("list" !== t && "type" !== t && !o && t in e) {
                        try {
                            e[t] = null == r ? "" : r;
                        } catch (s) {}
                        null != r && !1 !== r || "spellcheck" == t || e.removeAttribute(t);
                    } else {
                        var a = o && t !== (t = t.replace(/^xlink:?/, ""));
                        null == r || !1 === r ? a ? e.removeAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase()) : e.removeAttribute(t) : "function" != typeof r && (a ? e.setAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase(), r) : e.setAttribute(t, r));
                    }
                } else e.className = r || "";
            }
            function d(e) {
                return this._listeners[e.type](E.event && E.event(e) || e);
            }
            var A = [], P = 0, j = !1, L = !1;
            function T() {
                for(var e; e = A.pop();)E.afterMount && E.afterMount(e), e.componentDidMount && e.componentDidMount();
            }
            function B(e, t, n, r, o, i) {
                P++ || (j = null != o && o.ownerSVGElement !== undefined, L = null != e && !("__preactattr_" in e));
                var u = D(e, t, n, r, i);
                return o && u.parentNode !== o && o.appendChild(u), --P || (L = !1, i || T()), u;
            }
            function D(e, t, n, r, o) {
                var _$i = e, u = j;
                if (null != t && "boolean" != typeof t || (t = ""), "string" == typeof t || "number" == typeof t) return e && e.splitText !== undefined && e.parentNode && (!e._component || o) ? e.nodeValue != t && (e.nodeValue = t) : (_$i = document.createTextNode(t), e && (e.parentNode && e.parentNode.replaceChild(_$i, e), F(e, !0))), _$i["__preactattr_"] = !0, _$i;
                var a = t.nodeName;
                if ("function" == typeof a) return function d(e, t, n, r) {
                    var _$o = e && e._component, _$i = _$o, u = e, a = _$o && e._componentConstructor === t.nodeName, s = a, l = I(t);
                    for(; _$o && !s && (_$o = _$o._parentComponent);)s = _$o.constructor === t.nodeName;
                    _$o && s && (!r || _$o._component) ? (U(_$o, l, 3, n, r), e = _$o.base) : (_$i && !a && (q(_$i), e = u = null), _$o = R(t.nodeName, l, n), e && !_$o.nextBase && (_$o.nextBase = e, u = null), U(_$o, l, 1, n, r), e = _$o.base, u && e !== u && (u._component = null, F(u, !1)));
                    return e;
                }(e, t, n, r);
                if (j = "svg" === a || "foreignObject" !== a && j, a = String(a), (!e || !N(e, a)) && (_$i = function h(e, t) {
                    var _$n = t ? document.createElementNS("http://www.w3.org/2000/svg", e) : document.createElement(e);
                    return _$n.normalizedNodeName = e, _$n;
                }(a, j), e)) {
                    for(; e.firstChild;)_$i.appendChild(e.firstChild);
                    e.parentNode && e.parentNode.replaceChild(_$i, e), F(e, !0);
                }
                var s = _$i.firstChild, l = _$i["__preactattr_"], c = t.children;
                if (null == l) {
                    l = _$i["__preactattr_"] = {};
                    for(var p = _$i.attributes, _$f = p.length; _$f--;)l[p[_$f].name] = p[_$f].value;
                }
                return !L && c && 1 === c.length && "string" == typeof c[0] && null != s && s.splitText !== undefined && null == s.nextSibling ? s.nodeValue != c[0] && (s.nodeValue = c[0]) : (c && c.length || null != s) && function S(e, t, n, r, o) {
                    var _$i, u, a, s, l, c = e.childNodes, p = [], _$f = {}, d = 0, h = 0, m = c.length, v = 0, y = t ? t.length : 0;
                    if (0 !== m) for(var _$g = 0; _$g < m; _$g++){
                        var _$_ = c[_$g], b = _$_["__preactattr_"], w = y && b ? _$_._component ? _$_._component.__key : b.key : null;
                        null != w ? (d++, _$f[w] = _$_) : (b || (_$_.splitText !== undefined ? !o || _$_.nodeValue.trim() : o)) && (p[v++] = _$_);
                    }
                    if (0 !== y) for(var _$g = 0; _$g < y; _$g++){
                        s = t[_$g], l = null;
                        var w = s.key;
                        if (null != w) d && _$f[w] !== undefined && (l = _$f[w], _$f[w] = undefined, d--);
                        else if (h < v) {
                            for(_$i = h; _$i < v; _$i++)if (p[_$i] !== undefined && (x = u = p[_$i], C = o, "string" == typeof (O = s) || "number" == typeof O ? x.splitText !== undefined : "string" == typeof O.nodeName ? !x._componentConstructor && N(x, O.nodeName) : C || x._componentConstructor === O.nodeName)) {
                                l = u, p[_$i] = undefined, _$i === v - 1 && v--, _$i === h && h++;
                                break;
                            }
                        }
                        l = D(l, s, n, r), a = c[_$g], l && l !== e && l !== a && (null == a ? e.appendChild(l) : l === a.nextSibling ? k(a) : e.insertBefore(l, a));
                    }
                    var x, O, C;
                    if (d) for(var _$g in _$f)_$f[_$g] !== undefined && F(_$f[_$g], !1);
                    for(; h <= v;)(l = p[v--]) !== undefined && F(l, !1);
                }(_$i, c, n, r, L || null != l.dangerouslySetInnerHTML), function m(e, t, n) {
                    var _$r;
                    for(_$r in n)t && null != t[_$r] || null == n[_$r] || v(e, _$r, n[_$r], n[_$r] = undefined, j);
                    for(_$r in t)"children" === _$r || "innerHTML" === _$r || _$r in n && t[_$r] === ("value" === _$r || "checked" === _$r ? e[_$r] : n[_$r]) || v(e, _$r, n[_$r], n[_$r] = t[_$r], j);
                }(_$i, t.attributes, l), j = u, _$i;
            }
            function F(e, t) {
                var _$n = e._component;
                _$n ? q(_$n) : (null != e["__preactattr_"] && e["__preactattr_"].ref && e["__preactattr_"].ref(null), !1 !== t && null != e["__preactattr_"] || k(e), h(e));
            }
            function h(e) {
                for(e = e.lastChild; e;){
                    var _$t = e.previousSibling;
                    F(e, !0), e = _$t;
                }
            }
            var m = [];
            function R(e, t, n) {
                var _$r, o = m.length;
                for(e.prototype && e.prototype.render ? (_$r = new e(t, n), g.call(_$r, t, n)) : ((_$r = new g(t, n)).constructor = e, _$r.render = y); o--;)if (m[o].constructor === e) return _$r.nextBase = m[o].nextBase, m.splice(o, 1), _$r;
                return _$r;
            }
            function y(e, t, n) {
                return this.constructor(e, n);
            }
            function U(e, t, n, r, o) {
                e._disable || (e._disable = !0, e.__ref = t.ref, e.__key = t.key, delete t.ref, delete t.key, "undefined" == typeof e.constructor.getDerivedStateFromProps && (!e.base || o ? e.componentWillMount && e.componentWillMount() : e.componentWillReceiveProps && e.componentWillReceiveProps(t, r)), r && r !== e.context && (e.prevContext || (e.prevContext = e.context), e.context = r), e.prevProps || (e.prevProps = e.props), e.props = t, e._disable = !1, 0 !== n && (1 !== n && !1 === E.syncComponentUpdates && e.base ? a(e) : V(e, 1, o)), e.__ref && e.__ref(e));
            }
            function V(e, t, n, r) {
                if (!e._disable) {
                    var o, _$i, u, a = e.props, s = e.state, l = e.context, c = e.prevProps || a, p = e.prevState || s, _$f = e.prevContext || l, d = e.base, h = e.nextBase, m = d || h, v = e._component, y = !1, _$g = _$f;
                    if (e.constructor.getDerivedStateFromProps && (s = M(M({}, s), e.constructor.getDerivedStateFromProps(a, s)), e.state = s), d && (e.props = c, e.state = p, e.context = _$f, 2 !== t && e.shouldComponentUpdate && !1 === e.shouldComponentUpdate(a, s, l) ? y = !0 : e.componentWillUpdate && e.componentWillUpdate(a, s, l), e.props = a, e.state = s, e.context = l), e.prevProps = e.prevState = e.prevContext = e.nextBase = null, e._dirty = !1, !y) {
                        o = e.render(a, s, l), e.getChildContext && (l = M(M({}, l), e.getChildContext())), d && e.getSnapshotBeforeUpdate && (_$g = e.getSnapshotBeforeUpdate(c, p));
                        var _$_, b, w = o && o.nodeName;
                        if ("function" == typeof w) {
                            var x = I(o);
                            (_$i = v) && _$i.constructor === w && x.key == _$i.__key ? U(_$i, x, 1, l, !1) : (_$_ = _$i, e._component = _$i = R(w, x, l), _$i.nextBase = _$i.nextBase || h, _$i._parentComponent = e, U(_$i, x, 0, l, !1), V(_$i, 1, n, !0)), b = _$i.base;
                        } else u = m, (_$_ = v) && (u = e._component = null), (m || 1 === t) && (u && (u._component = null), b = function B(t, n, r, o, i, u) {
                            P++ || (j = null != i && i.ownerSVGElement !== undefined, L = null != t && !("__preactattr_" in t));
                            var a = D(t, n, r, o, u);
                            return i && a.parentNode !== i && i.appendChild(a), --P || (L = !1, u || T()), a;
                        }(u, o, l, n || !d, m && m.parentNode, !0));
                        if (m && b !== m && _$i !== v) {
                            var O = m.parentNode;
                            O && b !== O && (O.replaceChild(b, m), _$_ || (m._component = null, F(m, !1)));
                        }
                        if (_$_ && q(_$_), (e.base = b) && !r) {
                            for(var C = e, S = e; S = S._parentComponent;)(C = S).base = b;
                            b._component = C, b._componentConstructor = C.constructor;
                        }
                    }
                    for(!d || n ? A.unshift(e) : y || (e.componentDidUpdate && e.componentDidUpdate(c, p, _$g), E.afterUpdate && E.afterUpdate(e)); e._renderCallbacks.length;)e._renderCallbacks.pop().call(e);
                    P || r || T();
                }
            }
            function q(e) {
                E.beforeUnmount && E.beforeUnmount(e);
                var _$t = e.base;
                e._disable = !0, e.componentWillUnmount && e.componentWillUnmount(), e.base = null;
                var _$n = e._component;
                _$n ? q(_$n) : _$t && (_$t["__preactattr_"] && _$t["__preactattr_"].ref && _$t["__preactattr_"].ref(null), k(e.nextBase = _$t), m.push(e), h(_$t)), e.__ref && e.__ref(null);
            }
            function g(e, t) {
                this._dirty = !0, this.context = t, this.props = e, this.state = this.state || {}, this._renderCallbacks = [];
            }
            function _(e, t, n) {
                return B(n, e, {}, !1, t, !1);
            }
            M(g.prototype, {
                setState: function setState(e, t) {
                    this.prevState || (this.prevState = this.state), this.state = M(M({}, this.state), "function" == typeof e ? e(this.state, this.props) : e), t && this._renderCallbacks.push(t), a(this);
                },
                forceUpdate: function forceUpdate(e) {
                    e && this._renderCallbacks.push(e), V(this, 2);
                },
                render: function _() {}
            });
            var b = {
                h: r,
                createElement: r,
                cloneElement: i,
                Component: g,
                render: _,
                rerender: f,
                options: E
            };
            t["default"] = b;
        },
        function(e, t) {
            var n = e.exports = {
                version: "2.5.7"
            };
            "number" == typeof __e && (__e = n);
        },
        function(e, t, n) {
            var r = n(8), o = n(40);
            e.exports = n(3) ? function(e, t, n) {
                return r.f(e, t, o(1, n));
            } : function(e, t, n) {
                return e[t] = n, e;
            };
        },
        function(e, t, n) {
            var o = n(9), i = n(38), u = n(39), a = Object.defineProperty;
            t.f = n(3) ? Object.defineProperty : function(e, t, n) {
                if (o(e), t = u(t, !0), o(n), i) try {
                    return a(e, t, n);
                } catch (r) {}
                if ("get" in n || "set" in n) throw TypeError("Accessors not supported!");
                return "value" in n && (e[t] = n.value), e;
            };
        },
        function(e, t, n) {
            var r = n(2);
            e.exports = function(e) {
                if (!r(e)) throw TypeError(e + " is not an object!");
                return e;
            };
        },
        function(e, t) {
            var n = 0, r = Math.random();
            e.exports = function(e) {
                return "Symbol(".concat(e === undefined ? "" : e, ")_", (++n + r).toString(36));
            };
        },
        function(e, t, n) {
            var r = n(22);
            e.exports = Object("z").propertyIsEnumerable(0) ? Object : function(e) {
                return "String" == r(e) ? e.split("") : Object(e);
            };
        },
        function(e, t) {
            e.exports = function(e) {
                if (e == undefined) throw TypeError("Can't call method on  " + e);
                return e;
            };
        },
        function(e, t, n) {
            "use strict";
            var r = n(4);
            e.exports = function(e, t) {
                return !!e && r(function() {
                    t ? e.call(null, function() {}, 1) : e.call(null);
                });
            };
        },
        function(e, t, n) {
            var r = n(0);
            r(r.S + r.F, "Object", {
                assign: n(41)
            });
        },
        function(e, t, n) {
            var r = n(2), o = n(1).document, i = r(o) && r(o.createElement);
            e.exports = function(e) {
                return i ? o.createElement(e) : {};
            };
        },
        function(e, t, n) {
            var i = n(1), u = n(7), a = n(17), s = n(10)("src"), r = "toString", o = Function[r], l = ("" + o).split(r);
            n(6).inspectSource = function(e) {
                return o.call(e);
            }, (e.exports = function(e, t, n, r) {
                var o = "function" == typeof n;
                o && (a(n, "name") || u(n, "name", t)), e[t] !== n && (o && (a(n, s) || u(n, s, e[t] ? "" + e[t] : l.join(String(t)))), e === i ? e[t] = n : r ? e[t] ? e[t] = n : u(e, t, n) : (delete e[t], u(e, t, n)));
            })(Function.prototype, r, function() {
                return "function" == typeof this && this[s] || o.call(this);
            });
        },
        function(e, t) {
            var n = {}.hasOwnProperty;
            e.exports = function(e, t) {
                return n.call(e, t);
            };
        },
        function(e, t, n) {
            var i = n(19);
            e.exports = function(r, o, e) {
                if (i(r), o === undefined) return r;
                switch(e){
                    case 1:
                        return function(e) {
                            return r.call(o, e);
                        };
                    case 2:
                        return function(e, t) {
                            return r.call(o, e, t);
                        };
                    case 3:
                        return function(e, t, n) {
                            return r.call(o, e, t, n);
                        };
                }
                return function() {
                    return r.apply(o, arguments);
                };
            };
        },
        function(e, t) {
            e.exports = function(e) {
                if ("function" != typeof e) throw TypeError(e + " is not a function!");
                return e;
            };
        },
        function(e, t, n) {
            var r = n(42), o = n(28);
            e.exports = Object.keys || function(e) {
                return r(e, o);
            };
        },
        function(e, t, n) {
            var r = n(11), o = n(12);
            e.exports = function(e) {
                return r(o(e));
            };
        },
        function(e, t) {
            var n = {}.toString;
            e.exports = function(e) {
                return n.call(e).slice(8, -1);
            };
        },
        function(e, t, n) {
            var s = n(21), l = n(24), c = n(43);
            e.exports = function(a) {
                return function(e, t, n) {
                    var r, o = s(e), i = l(o.length), u = c(n, i);
                    if (a && t != t) {
                        for(; u < i;)if ((r = o[u++]) != r) return !0;
                    } else for(; u < i; u++)if ((a || u in o) && o[u] === t) return a || u || 0;
                    return !a && -1;
                };
            };
        },
        function(e, t, n) {
            var r = n(25), o = Math.min;
            e.exports = function(e) {
                return 0 < e ? o(r(e), 9007199254740991) : 0;
            };
        },
        function(e, t) {
            var n = Math.ceil, r = Math.floor;
            e.exports = function(e) {
                return isNaN(e = +e) ? 0 : (0 < e ? r : n)(e);
            };
        },
        function(e, t, n) {
            var r = n(27)("keys"), o = n(10);
            e.exports = function(e) {
                return r[e] || (r[e] = o(e));
            };
        },
        function(e, t, n) {
            var r = n(6), o = n(1), i = "__core-js_shared__", u = o[i] || (o[i] = {});
            (e.exports = function(e, t) {
                return u[e] || (u[e] = t !== undefined ? t : {});
            })("versions", []).push({
                version: r.version,
                mode: n(44) ? "pure" : "global",
                copyright: "\xa9 2018 Denis Pushkarev (zloirock.ru)"
            });
        },
        function(e, t) {
            e.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
        },
        function(e, t, n) {
            var r = n(12);
            e.exports = function(e) {
                return Object(r(e));
            };
        },
        function(e, t, n) {
            var r = n(8).f, o = Function.prototype, i = /^\s*function ([^ (]*)/;
            "name" in o || n(3) && r(o, "name", {
                configurable: !0,
                get: function get() {
                    try {
                        return ("" + this).match(i)[1];
                    } catch (e) {
                        return "";
                    }
                }
            });
        },
        function(e, t, n) {
            "use strict";
            var r = n(0), o = n(32)(1);
            r(r.P + r.F * !n(13)([].map, !0), "Array", {
                map: function map(e) {
                    return o(this, e, arguments[1]);
                }
            });
        },
        function(e, t, n) {
            var _ = n(18), b = n(11), w = n(29), x = n(24), r = n(47);
            e.exports = function(p, e) {
                var f = 1 == p, d = 2 == p, h = 3 == p, m = 4 == p, v = 6 == p, y = 5 == p || v, g = e || r;
                return function(e, t, n) {
                    for(var r, o, i = w(e), u = b(i), a = _(t, n, 3), s = x(u.length), l = 0, c = f ? g(e, s) : d ? g(e, 0) : undefined; l < s; l++)if ((y || l in u) && (o = a(r = u[l], l, i), p)) {
                        if (f) c[l] = o;
                        else if (o) switch(p){
                            case 3:
                                return !0;
                            case 5:
                                return r;
                            case 6:
                                return l;
                            case 2:
                                c.push(r);
                        }
                        else if (m) return !1;
                    }
                    return v ? -1 : h || m ? m : c;
                };
            };
        },
        function(e, t, n) {
            var r = n(22);
            e.exports = Array.isArray || function(e) {
                return "Array" == r(e);
            };
        },
        function(e, t, n) {
            var r = n(27)("wks"), o = n(10), i = n(1).Symbol, u = "function" == typeof i;
            (e.exports = function(e) {
                return r[e] || (r[e] = u && i[e] || (u ? i : o)("Symbol." + e));
            }).store = r;
        },
        function(e, t, n) {
            "use strict";
            var r = n(0), o = n(23)(!1), i = [].indexOf, u = !!i && 1 / [
                1
            ].indexOf(1, -0) < 0;
            r(r.P + r.F * (u || !n(13)(i)), "Array", {
                indexOf: function indexOf(e) {
                    return u ? i.apply(this, arguments) || 0 : o(this, e, arguments[1]);
                }
            });
        },
        function(e, t, n) {
            var r = n(0);
            r(r.S, "Object", {
                create: n(52)
            });
        },
        function(e, t, n) {
            "use strict";
            t.__esModule = !0, t["default"] = void 0, n(14), n(30), n(31), n(35), n(49), n(50);
            var r = n(5), o = function s(e) {
                return e && e.__esModule ? e : {
                    "default": e
                };
            }(n(51));
            function i(e) {
                if (!e.element) throw new Error("element is not defined");
                if (!e.id) throw new Error("id is not defined");
                if (!e.source) throw new Error("source is not defined");
                Array.isArray(e.source) && (e.source = u(e.source)), (0, r.render)((0, r.createElement)(o["default"], e), e.element);
            }
            var u = function u(n) {
                return function(t, e) {
                    e(n.filter(function(e) {
                        return -1 !== e.toLowerCase().indexOf(t.toLowerCase());
                    }));
                };
            };
            i.enhanceSelectElement = function(n) {
                if (!n.selectElement) throw new Error("selectElement is not defined");
                if (!n.source) {
                    var e = [].filter.call(n.selectElement.options, function(e) {
                        return e.value || n.preserveNullOptions;
                    });
                    n.source = e.map(function(e) {
                        return e.textContent || e.innerText;
                    });
                }
                if (n.onConfirm = n.onConfirm || function(t) {
                    var e = [].filter.call(n.selectElement.options, function(e) {
                        return (e.textContent || e.innerText) === t;
                    })[0];
                    e && (e.selected = !0);
                }, n.selectElement.value || n.defaultValue === undefined) {
                    var _$t = n.selectElement.options[n.selectElement.options.selectedIndex];
                    n.defaultValue = _$t.textContent || _$t.innerText;
                }
                n.name === undefined && (n.name = ""), n.id === undefined && (n.selectElement.id === undefined ? n.id = "" : n.id = n.selectElement.id), n.autoselect === undefined && (n.autoselect = !0);
                var r = document.createElement("div");
                n.selectElement.parentNode.insertBefore(r, n.selectElement), i(Object.assign({}, n, {
                    element: r
                })), n.selectElement.style.display = "none", n.selectElement.id = n.selectElement.id + "-select";
            };
            var a = i;
            t["default"] = a;
        },
        function(e, t, n) {
            e.exports = !n(3) && !n(4)(function() {
                return 7 != Object.defineProperty(n(15)("div"), "a", {
                    get: function get() {
                        return 7;
                    }
                }).a;
            });
        },
        function(e, t, n) {
            var o = n(2);
            e.exports = function(e, t) {
                if (!o(e)) return e;
                var _$n, r;
                if (t && "function" == typeof (_$n = e.toString) && !o(r = _$n.call(e))) return r;
                if ("function" == typeof (_$n = e.valueOf) && !o(r = _$n.call(e))) return r;
                if (!t && "function" == typeof (_$n = e.toString) && !o(r = _$n.call(e))) return r;
                throw TypeError("Can't convert object to primitive value");
            };
        },
        function(e, t) {
            e.exports = function(e, t) {
                return {
                    enumerable: !(1 & e),
                    configurable: !(2 & e),
                    writable: !(4 & e),
                    value: t
                };
            };
        },
        function(e, t, n) {
            "use strict";
            var f = n(20), d = n(45), h = n(46), m = n(29), v = n(11), o = Object.assign;
            e.exports = !o || n(4)(function() {
                var _$e = {}, t = {}, _$n = Symbol(), r = "abcdefghijklmnopqrst";
                return _$e[_$n] = 7, r.split("").forEach(function(e) {
                    t[e] = e;
                }), 7 != o({}, _$e)[_$n] || Object.keys(o({}, t)).join("") != r;
            }) ? function(e, t) {
                for(var _$n = m(e), r = arguments.length, o = 1, i = d.f, u = h.f; o < r;)for(var a, s = v(arguments[o++]), l = i ? f(s).concat(i(s)) : f(s), c = l.length, p = 0; p < c;)u.call(s, a = l[p++]) && (_$n[a] = s[a]);
                return _$n;
            } : o;
        },
        function(e, t, n) {
            var u = n(17), a = n(21), s = n(23)(!1), l = n(26)("IE_PROTO");
            e.exports = function(e, t) {
                var _$n, r = a(e), o = 0, i = [];
                for(_$n in r)_$n != l && u(r, _$n) && i.push(_$n);
                for(; t.length > o;)u(r, _$n = t[o++]) && (~s(i, _$n) || i.push(_$n));
                return i;
            };
        },
        function(e, t, n) {
            var r = n(25), o = Math.max, i = Math.min;
            e.exports = function(e, t) {
                return (e = r(e)) < 0 ? o(e + t, 0) : i(e, t);
            };
        },
        function(e, t) {
            e.exports = !1;
        },
        function(e, t) {
            t.f = Object.getOwnPropertySymbols;
        },
        function(e, t) {
            t.f = ({}).propertyIsEnumerable;
        },
        function(e, t, n) {
            var r = n(48);
            e.exports = function(e, t) {
                return new (r(e))(t);
            };
        },
        function(e, t, n) {
            var r = n(2), o = n(33), i = n(34)("species");
            e.exports = function(e) {
                var t;
                return o(e) && ("function" != typeof (t = e.constructor) || t !== Array && !o(t.prototype) || (t = undefined), r(t) && null === (t = t[i]) && (t = undefined)), t === undefined ? Array : t;
            };
        },
        function(e, t, n) {
            "use strict";
            var r = n(0), o = n(32)(2);
            r(r.P + r.F * !n(13)([].filter, !0), "Array", {
                filter: function filter(e) {
                    return o(this, e, arguments[1]);
                }
            });
        },
        function(e, t, n) {
            var r = n(0);
            r(r.S, "Array", {
                isArray: n(33)
            });
        },
        function(e, t, n) {
            "use strict";
            t.__esModule = !0, t["default"] = void 0, n(14), n(36), n(30), n(31), n(35), n(55), n(58);
            var $ = n(5), J = o(n(60)), r = o(n(61));
            function o(e) {
                return e && e.__esModule ? e : {
                    "default": e
                };
            }
            function X() {
                return (X = Object.assign || function(e) {
                    for(var _$t = 1; _$t < arguments.length; _$t++){
                        var _$n = arguments[_$t];
                        for(var r in _$n)Object.prototype.hasOwnProperty.call(_$n, r) && (e[r] = _$n[r]);
                    }
                    return e;
                }).apply(this, arguments);
            }
            function i(e) {
                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
            }
            var u = {
                13: "enter",
                27: "escape",
                32: "space",
                38: "up",
                40: "down"
            };
            function Y() {
                return "undefined" != typeof navigator && !(!navigator.userAgent.match(/(iPod|iPhone|iPad)/g) || !navigator.userAgent.match(/AppleWebKit/g));
            }
            var a = function(n) {
                function e(e) {
                    var _$t;
                    return (_$t = n.call(this, e) || this).elementReferences = {}, _$t.state = {
                        focused: null,
                        hovered: null,
                        menuOpen: !1,
                        options: e.defaultValue ? [
                            e.defaultValue
                        ] : [],
                        query: e.defaultValue,
                        validChoiceMade: !1,
                        selected: null,
                        ariaHint: !0
                    }, _$t.handleComponentBlur = _$t.handleComponentBlur.bind(i(i(_$t))), _$t.handleKeyDown = _$t.handleKeyDown.bind(i(i(_$t))), _$t.handleUpArrow = _$t.handleUpArrow.bind(i(i(_$t))), _$t.handleDownArrow = _$t.handleDownArrow.bind(i(i(_$t))), _$t.handleEnter = _$t.handleEnter.bind(i(i(_$t))), _$t.handlePrintableKey = _$t.handlePrintableKey.bind(i(i(_$t))), _$t.handleListMouseLeave = _$t.handleListMouseLeave.bind(i(i(_$t))), _$t.handleOptionBlur = _$t.handleOptionBlur.bind(i(i(_$t))), _$t.handleOptionClick = _$t.handleOptionClick.bind(i(i(_$t))), _$t.handleOptionFocus = _$t.handleOptionFocus.bind(i(i(_$t))), _$t.handleOptionMouseDown = _$t.handleOptionMouseDown.bind(i(i(_$t))), _$t.handleOptionMouseEnter = _$t.handleOptionMouseEnter.bind(i(i(_$t))), _$t.handleInputBlur = _$t.handleInputBlur.bind(i(i(_$t))), _$t.handleInputChange = _$t.handleInputChange.bind(i(i(_$t))), _$t.handleInputFocus = _$t.handleInputFocus.bind(i(i(_$t))), _$t.pollInputElement = _$t.pollInputElement.bind(i(i(_$t))), _$t.getDirectInputChanges = _$t.getDirectInputChanges.bind(i(i(_$t))), _$t;
                }
                (function r(e, t) {
                    e.prototype = Object.create(t.prototype), (e.prototype.constructor = e).__proto__ = t;
                })(e, n);
                var _$t = e.prototype;
                return _$t.isQueryAnOption = function(e, t) {
                    var _$n = this;
                    return -1 !== t.map(function(e) {
                        return _$n.templateInputValue(e).toLowerCase();
                    }).indexOf(e.toLowerCase());
                }, _$t.componentDidMount = function() {
                    this.pollInputElement();
                }, _$t.componentWillUnmount = function() {
                    clearTimeout(this.$pollInput);
                }, _$t.pollInputElement = function() {
                    var _$e = this;
                    this.getDirectInputChanges(), this.$pollInput = setTimeout(function() {
                        _$e.pollInputElement();
                    }, 100);
                }, _$t.getDirectInputChanges = function() {
                    var _$e = this.elementReferences[-1];
                    _$e && _$e.value !== this.state.query && this.handleInputChange({
                        target: {
                            value: _$e.value
                        }
                    });
                }, _$t.componentDidUpdate = function(e, t) {
                    var _$n = this.state.focused, r = null === _$n, _$o = t.focused !== _$n;
                    _$o && !r && this.elementReferences[_$n].focus();
                    var i = -1 === _$n, u = _$o && null === t.focused;
                    if (i && u) {
                        var a = this.elementReferences[_$n];
                        a.setSelectionRange(0, a.value.length);
                    }
                }, _$t.hasAutoselect = function() {
                    return !Y() && this.props.autoselect;
                }, _$t.templateInputValue = function(e) {
                    var _$t = this.props.templates && this.props.templates.inputValue;
                    return _$t ? _$t(e) : e;
                }, _$t.templateSuggestion = function(e) {
                    var _$t = this.props.templates && this.props.templates.suggestion;
                    return _$t ? _$t(e) : e;
                }, _$t.handleComponentBlur = function(e) {
                    var _$t, _$n = this.state, r = _$n.options, _$o = _$n.query, i = _$n.selected;
                    this.props.confirmOnBlur ? (_$t = e.query || _$o, this.props.onConfirm(r[i])) : _$t = _$o, this.setState({
                        focused: null,
                        menuOpen: e.menuOpen || !1,
                        query: _$t,
                        selected: null,
                        validChoiceMade: this.isQueryAnOption(_$t, r)
                    });
                }, _$t.handleListMouseLeave = function(e) {
                    this.setState({
                        hovered: null
                    });
                }, _$t.handleOptionBlur = function(e, t) {
                    var _$n = this.state, r = _$n.focused, _$o = _$n.menuOpen, i = _$n.options, u = _$n.selected, a = null === e.relatedTarget, s = e.relatedTarget === this.elementReferences[-1], l = r !== t && -1 !== r;
                    if (!l && a || !(l || s)) {
                        var c = _$o && Y();
                        this.handleComponentBlur({
                            menuOpen: c,
                            query: this.templateInputValue(i[u])
                        });
                    }
                }, _$t.handleInputBlur = function(e) {
                    var _$t = this.state, _$n = _$t.focused, r = _$t.menuOpen, _$o = _$t.options, i = _$t.query, u = _$t.selected;
                    if (!(-1 !== _$n)) {
                        var a = r && Y(), s = Y() ? i : this.templateInputValue(_$o[u]);
                        this.handleComponentBlur({
                            menuOpen: a,
                            query: s
                        });
                    }
                }, _$t.handleInputChange = function(e) {
                    var _$n = this, _$t = this.props, r = _$t.minLength, _$o = _$t.source, i = _$t.showAllValues, u = this.hasAutoselect(), a = e.target.value, s = 0 === a.length, l = this.state.query.length !== a.length, c = a.length >= r;
                    this.setState({
                        query: a,
                        ariaHint: s
                    }), i || !s && l && c ? _$o(a, function(e) {
                        var _$t = 0 < e.length;
                        _$n.setState({
                            menuOpen: _$t,
                            options: e,
                            selected: u && _$t ? 0 : -1,
                            validChoiceMade: !1
                        });
                    }) : !s && c || this.setState({
                        menuOpen: !1,
                        options: []
                    });
                }, _$t.handleInputClick = function(e) {
                    this.handleInputChange(e);
                }, _$t.handleInputFocus = function(e) {
                    var _$t = this.state, _$n = _$t.query, r = _$t.validChoiceMade, _$o = _$t.options, i = this.props.minLength, u = !r && _$n.length >= i && 0 < _$o.length;
                    u ? this.setState(function(e) {
                        var _$t = e.menuOpen;
                        return {
                            focused: -1,
                            menuOpen: u || _$t,
                            selected: -1
                        };
                    }) : this.setState({
                        focused: -1
                    });
                }, _$t.handleOptionFocus = function(e) {
                    this.setState({
                        focused: e,
                        hovered: null,
                        selected: e
                    });
                }, _$t.handleOptionMouseEnter = function(e, t) {
                    Y() || this.setState({
                        hovered: t
                    });
                }, _$t.handleOptionClick = function(e, t) {
                    var _$n = this.state.options[t], r = this.templateInputValue(_$n);
                    this.props.onConfirm(_$n), this.setState({
                        focused: -1,
                        hovered: null,
                        menuOpen: !1,
                        query: r,
                        selected: -1,
                        validChoiceMade: !0
                    }), this.forceUpdate();
                }, _$t.handleOptionMouseDown = function(e) {
                    e.preventDefault();
                }, _$t.handleUpArrow = function(e) {
                    e.preventDefault();
                    var _$t = this.state, _$n = _$t.menuOpen, r = _$t.selected;
                    -1 !== r && _$n && this.handleOptionFocus(r - 1);
                }, _$t.handleDownArrow = function(e) {
                    var _$t = this;
                    if (e.preventDefault(), this.props.showAllValues && !1 === this.state.menuOpen) e.preventDefault(), this.props.source("", function(e) {
                        _$t.setState({
                            menuOpen: !0,
                            options: e,
                            selected: 0,
                            focused: 0,
                            hovered: null
                        });
                    });
                    else if (!0 === this.state.menuOpen) {
                        var _$n = this.state, r = _$n.menuOpen, _$o = _$n.options, i = _$n.selected;
                        i !== _$o.length - 1 && r && this.handleOptionFocus(i + 1);
                    }
                }, _$t.handleSpace = function(e) {
                    var _$t = this;
                    this.props.showAllValues && !1 === this.state.menuOpen && "" === this.state.query && (e.preventDefault(), this.props.source("", function(e) {
                        _$t.setState({
                            menuOpen: !0,
                            options: e
                        });
                    })), -1 !== this.state.focused && (e.preventDefault(), this.handleOptionClick(e, this.state.focused));
                }, _$t.handleEnter = function(e) {
                    this.state.menuOpen && (e.preventDefault(), 0 <= this.state.selected && this.handleOptionClick(e, this.state.selected));
                }, _$t.handlePrintableKey = function(e) {
                    var _$t = this.elementReferences[-1];
                    e.target === _$t || _$t.focus();
                }, _$t.handleKeyDown = function(e) {
                    switch(u[e.keyCode]){
                        case "up":
                            this.handleUpArrow(e);
                            break;
                        case "down":
                            this.handleDownArrow(e);
                            break;
                        case "space":
                            this.handleSpace(e);
                            break;
                        case "enter":
                            this.handleEnter(e);
                            break;
                        case "escape":
                            this.handleComponentBlur({
                                query: this.state.query
                            });
                            break;
                        default:
                            (function t(e) {
                                return 47 < e && e < 58 || 32 === e || 8 === e || 64 < e && e < 91 || 95 < e && e < 112 || 185 < e && e < 193 || 218 < e && e < 223;
                            })(e.keyCode) && this.handlePrintableKey(e);
                    }
                }, _$t.render = function() {
                    var _$e, i = this, _$t = this.props, _$n = _$t.cssNamespace, r = _$t.displayMenu, u = _$t.id, _$o = _$t.minLength, a = _$t.name, s = _$t.placeholder, l = _$t.required, c = _$t.showAllValues, p = _$t.tNoResults, f = _$t.tStatusQueryTooShort, d = _$t.tStatusNoResults, h = _$t.tStatusSelectedOption, m = _$t.tStatusResults, v = _$t.tAssistiveHint, y = _$t.dropdownArrow, g = this.state, _ = g.focused, b = g.hovered, w = g.menuOpen, x = g.options, O = g.query, C = g.selected, S = g.ariaHint, E = g.validChoiceMade, M = this.hasAutoselect(), N = -1 === _, I = 0 === x.length, k = 0 !== O.length, A = O.length >= _$o, P = this.props.showNoOptionsFound && N && I && k && A, j = _$n + "__wrapper", L = _$n + "__input", T = null !== _ ? " " + L + "--focused" : "", B = this.props.showAllValues ? " " + L + "--show-all-values" : " " + L + "--default", D = _$n + "__dropdown-arrow-down", F = -1 !== _ && null !== _, R = _$n + "__menu", U = R + "--" + r, V = R + "--" + (w || P ? "visible" : "hidden"), q = _$n + "__option", W = _$n + "__hint", H = this.templateInputValue(x[C]), K = H && 0 === H.toLowerCase().indexOf(O.toLowerCase()) && M ? O + H.substr(O.length) : "", Q = u + "__assistiveHint", z = S ? {
                        "aria-describedby": Q
                    } : null;
                    return c && "string" == typeof (_$e = y({
                        className: D
                    })) && (_$e = (0, $.createElement)("div", {
                        className: _$n + "__dropdown-arrow-down-wrapper",
                        dangerouslySetInnerHTML: {
                            __html: _$e
                        }
                    })), (0, $.createElement)("div", {
                        className: j,
                        onKeyDown: this.handleKeyDown
                    }, (0, $.createElement)(J["default"], {
                        id: u,
                        length: x.length,
                        queryLength: O.length,
                        minQueryLength: _$o,
                        selectedOption: this.templateInputValue(x[C]),
                        selectedOptionIndex: C,
                        validChoiceMade: E,
                        isInFocus: null !== this.state.focused,
                        tQueryTooShort: f,
                        tNoResults: d,
                        tSelectedOption: h,
                        tResults: m
                    }), K && (0, $.createElement)("span", null, (0, $.createElement)("input", {
                        className: W,
                        readonly: !0,
                        tabIndex: "-1",
                        value: K
                    })), (0, $.createElement)("input", X({
                        "aria-expanded": w ? "true" : "false",
                        "aria-activedescendant": !!F && u + "__option--" + _,
                        "aria-owns": u + "__listbox",
                        "aria-autocomplete": this.hasAutoselect() ? "both" : "list"
                    }, z, {
                        autoComplete: "off",
                        className: "" + L + T + B,
                        id: u,
                        onClick: function onClick(e) {
                            return i.handleInputClick(e);
                        },
                        onBlur: this.handleInputBlur
                    }, function G(e) {
                        return {
                            onInput: e
                        };
                    }(this.handleInputChange), {
                        onFocus: this.handleInputFocus,
                        name: a,
                        placeholder: s,
                        ref: function ref(e) {
                            i.elementReferences[-1] = e;
                        },
                        type: "text",
                        role: "combobox",
                        required: l,
                        value: O
                    })), _$e, (0, $.createElement)("ul", {
                        className: R + " " + U + " " + V,
                        onMouseLeave: function onMouseLeave(e) {
                            return i.handleListMouseLeave(e);
                        },
                        id: u + "__listbox",
                        role: "listbox"
                    }, x.map(function(e, t) {
                        var _$n = (-1 === _ ? C === t : _ === t) && null === b ? " " + q + "--focused" : "", r = t % 2 ? " " + q + "--odd" : "", _$o = Y() ? "<span id=" + u + "__option-suffix--" + t + ' style="border:0;clip:rect(0 0 0 0);height:1px;marginBottom:-1px;marginRight:-1px;overflow:hidden;padding:0;position:absolute;whiteSpace:nowrap;width:1px"> ' + (t + 1) + " of " + x.length + "</span>" : "";
                        return (0, $.createElement)("li", {
                            "aria-selected": _ === t ? "true" : "false",
                            className: "" + q + _$n + r,
                            dangerouslySetInnerHTML: {
                                __html: i.templateSuggestion(e) + _$o
                            },
                            id: u + "__option--" + t,
                            key: t,
                            onBlur: function onBlur(e) {
                                return i.handleOptionBlur(e, t);
                            },
                            onClick: function onClick(e) {
                                return i.handleOptionClick(e, t);
                            },
                            onMouseDown: i.handleOptionMouseDown,
                            onMouseEnter: function onMouseEnter(e) {
                                return i.handleOptionMouseEnter(e, t);
                            },
                            ref: function ref(e) {
                                i.elementReferences[t] = e;
                            },
                            role: "option",
                            tabIndex: "-1",
                            "aria-posinset": t + 1,
                            "aria-setsize": x.length
                        });
                    }), P && (0, $.createElement)("li", {
                        className: q + " " + q + "--no-results"
                    }, p())), (0, $.createElement)("span", {
                        id: Q,
                        style: {
                            display: "none"
                        }
                    }, v()));
                }, e;
            }($.Component);
            (t["default"] = a).defaultProps = {
                autoselect: !1,
                cssNamespace: "autocomplete",
                defaultValue: "",
                displayMenu: "inline",
                minLength: 0,
                name: "input-autocomplete",
                placeholder: "",
                onConfirm: function onConfirm() {},
                confirmOnBlur: !0,
                showNoOptionsFound: !0,
                showAllValues: !1,
                required: !1,
                tNoResults: function tNoResults() {
                    return "No results found";
                },
                tAssistiveHint: function tAssistiveHint() {
                    return "When autocomplete results are available use up and down arrows to review and enter to select.  Touch device users, explore by touch or with swipe gestures.";
                },
                dropdownArrow: r["default"]
            };
        },
        function(e, t, r) {
            var o = r(9), i = r(53), u = r(28), a = r(26)("IE_PROTO"), s = function s() {}, l = "prototype", c = function c1() {
                var _$e, t = r(15)("iframe"), n = u.length;
                for(t.style.display = "none", r(54).appendChild(t), t.src = "javascript:", (_$e = t.contentWindow.document).open(), _$e.write("<script>document.F=Object<\/script>"), _$e.close(), c = _$e.F; n--;)delete c[l][u[n]];
                return c();
            };
            e.exports = Object.create || function(e, t) {
                var n;
                return null !== e ? (s[l] = o(e), n = new s, s[l] = null, n[a] = e) : n = c(), t === undefined ? n : i(n, t);
            };
        },
        function(e, t, n) {
            var u = n(8), a = n(9), s = n(20);
            e.exports = n(3) ? Object.defineProperties : function(e, t) {
                a(e);
                for(var _$n, r = s(t), o = r.length, i = 0; i < o;)u.f(e, _$n = r[i++], t[_$n]);
                return e;
            };
        },
        function(e, t, n) {
            var r = n(1).document;
            e.exports = r && r.documentElement;
        },
        function(e, t, n) {
            var r = n(0);
            r(r.P, "Function", {
                bind: n(56)
            });
        },
        function(e, t, n) {
            "use strict";
            var i = n(19), u = n(2), a = n(57), s = [].slice, l = {};
            e.exports = Function.bind || function(t) {
                var _$n = i(this), r = s.call(arguments, 1), o = function o1() {
                    var _$e = r.concat(s.call(arguments));
                    return this instanceof o ? function(e, t, n) {
                        if (!(t in l)) {
                            for(var r = [], o = 0; o < t; o++)r[o] = "a[" + o + "]";
                            l[t] = Function("F,a", "return new F(" + r.join(",") + ")");
                        }
                        return l[t](e, n);
                    }(_$n, _$e.length, _$e) : a(_$n, _$e, t);
                };
                return u(_$n.prototype) && (o.prototype = _$n.prototype), o;
            };
        },
        function(e, t) {
            e.exports = function(e, t, n) {
                var r = n === undefined;
                switch(t.length){
                    case 0:
                        return r ? e() : e.call(n);
                    case 1:
                        return r ? e(t[0]) : e.call(n, t[0]);
                    case 2:
                        return r ? e(t[0], t[1]) : e.call(n, t[0], t[1]);
                    case 3:
                        return r ? e(t[0], t[1], t[2]) : e.call(n, t[0], t[1], t[2]);
                    case 4:
                        return r ? e(t[0], t[1], t[2], t[3]) : e.call(n, t[0], t[1], t[2], t[3]);
                }
                return e.apply(n, t);
            };
        },
        function(e, t, n) {
            n(59)("match", 1, function(r, o, e) {
                return [
                    function(e) {
                        "use strict";
                        var t = r(this), _$n = e == undefined ? undefined : e[o];
                        return _$n !== undefined ? _$n.call(e, t) : new RegExp(e)[o](String(t));
                    },
                    e
                ];
            });
        },
        function(e, t, n) {
            "use strict";
            var a = n(7), s = n(16), l = n(4), c = n(12), p = n(34);
            e.exports = function(t, e, n) {
                var r = p(t), o = n(c, r, ""[t]), i = o[0], u = o[1];
                l(function() {
                    var _$e = {};
                    return _$e[r] = function() {
                        return 7;
                    }, 7 != ""[t](_$e);
                }) && (s(String.prototype, t, i), a(RegExp.prototype, r, 2 == e ? function(e, t) {
                    return u.call(e, this, t);
                } : function(e) {
                    return u.call(e, this);
                }));
            };
        },
        function(e, t, n) {
            "use strict";
            t.__esModule = !0, t["default"] = void 0, n(36);
            var _ = n(5);
            var r = function r(o, i, u) {
                var a;
                return function() {
                    var e = this, _$t = arguments, _$n = function n() {
                        a = null, u || o.apply(e, _$t);
                    }, r = u && !a;
                    clearTimeout(a), a = setTimeout(_$n, i), r && o.apply(e, _$t);
                };
            }, o = function(o) {
                function e() {
                    for(var _$e, _$t = arguments.length, _$n = new Array(_$t), r = 0; r < _$t; r++)_$n[r] = arguments[r];
                    return (_$e = o.call.apply(o, [
                        this
                    ].concat(_$n)) || this).state = {
                        bump: !1,
                        debounced: !1
                    }, _$e;
                }
                (function n(e, t) {
                    e.prototype = Object.create(t.prototype), (e.prototype.constructor = e).__proto__ = t;
                })(e, o);
                var _$t = e.prototype;
                return _$t.componentWillMount = function() {
                    var _$e = this;
                    this.debounceStatusUpdate = r(function() {
                        if (!_$e.state.debounced) {
                            var _$t = !_$e.props.isInFocus || _$e.props.validChoiceMade;
                            _$e.setState(function(e) {
                                return {
                                    bump: !e.bump,
                                    debounced: !0,
                                    silenced: _$t
                                };
                            });
                        }
                    }, 1400);
                }, _$t.componentWillReceiveProps = function(e) {
                    e.queryLength;
                    this.setState({
                        debounced: !1
                    });
                }, _$t.render = function() {
                    var _$e = this.props, _$t = _$e.id, _$n = _$e.length, r = _$e.queryLength, _$o = _$e.minQueryLength, i = _$e.selectedOption, u = _$e.selectedOptionIndex, a = _$e.tQueryTooShort, s = _$e.tNoResults, l = _$e.tSelectedOption, c = _$e.tResults, p = this.state, f = p.bump, d = p.debounced, h = p.silenced, m = r < _$o, v = 0 === _$n, y = i ? l(i, _$n, u) : "", g = null;
                    return g = m ? a(_$o) : v ? s() : c(_$n, y), this.debounceStatusUpdate(), (0, _.createElement)("div", {
                        style: {
                            border: "0",
                            clip: "rect(0 0 0 0)",
                            height: "1px",
                            marginBottom: "-1px",
                            marginRight: "-1px",
                            overflow: "hidden",
                            padding: "0",
                            position: "absolute",
                            whiteSpace: "nowrap",
                            width: "1px"
                        }
                    }, (0, _.createElement)("div", {
                        id: _$t + "__status--A",
                        role: "status",
                        "aria-atomic": "true",
                        "aria-live": "polite"
                    }, !h && d && f ? g : ""), (0, _.createElement)("div", {
                        id: _$t + "__status--B",
                        role: "status",
                        "aria-atomic": "true",
                        "aria-live": "polite"
                    }, h || !d || f ? "" : g));
                }, e;
            }(_.Component);
            (t["default"] = o).defaultProps = {
                tQueryTooShort: function tQueryTooShort(e) {
                    return "Type in " + e + " or more characters for results";
                },
                tNoResults: function tNoResults() {
                    return "No search results";
                },
                tSelectedOption: function tSelectedOption(e, t, n) {
                    return e + " " + (n + 1) + " of " + t + " is highlighted";
                },
                tResults: function tResults(e, t) {
                    return e + " " + (1 === e ? "result" : "results") + " " + (1 === e ? "is" : "are") + " available. " + t;
                }
            };
        },
        function(e, t, n) {
            "use strict";
            t.__esModule = !0, t["default"] = void 0;
            var r = n(5), o = function i(e) {
                var _$t = e.className;
                return (0, r.createElement)("svg", {
                    version: "1.1",
                    xmlns: "http://www.w3.org/2000/svg",
                    className: _$t,
                    focusable: "false"
                }, (0, r.createElement)("g", {
                    stroke: "none",
                    fill: "none",
                    "fill-rule": "evenodd"
                }, (0, r.createElement)("polygon", {
                    fill: "#000000",
                    points: "0 0 22 0 11 17"
                })));
            };
            t["default"] = o;
        }
    ])["default"];
});

},{"@swc/helpers/_/_type_of":"lkAFj"}],"8JpHN":[function(require,module,exports,__globalThis) {
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
exports.getListOfCountriesForQuery = function getListOfCountriesForQuery(countryData) {
    return function(query, populateResults) {
        var trimmedQuery = (query || '').toLocaleLowerCase().trim();
        if (!trimmedQuery) return populateResults([]);
        var individualWordsInQuery = words(trimmedQuery);
        var canonicalNamesMatched = [];
        var altNamesMatched = [];
        var anyOrderWordMatches = [];
        var canonicalNamesFuzzyMatched = [];
        countryData.forEach(function(entry) {
            var canonicalNameTrimmed = entry.canonicalName.toLocaleLowerCase().trim();
            if (isPrefix(trimmedQuery, canonicalNameTrimmed)) canonicalNamesMatched.push(entry.canonicalName);
            else if (entry.aliases.some(function(alias) {
                return isPrefix(trimmedQuery, alias.toLocaleLowerCase().trim());
            })) altNamesMatched.push(entry.canonicalName);
            else if (allWordsInQueryMatchTargetWord(individualWordsInQuery, canonicalNameTrimmed) || entry.aliases.some(function(alias) {
                return allWordsInQueryMatchTargetWord(individualWordsInQuery, alias.toLocaleLowerCase().trim());
            })) anyOrderWordMatches.push(entry.canonicalName);
            else if (isFuzzyMatch(trimmedQuery.toLocaleLowerCase(), canonicalNameTrimmed.toLocaleLowerCase())) canonicalNamesFuzzyMatched.push(entry.canonicalName);
        });
        // Remove duplicates while preserving order
        var seenMatches = new Set();
        var results = (0, _toConsumableArray._)(canonicalNamesMatched).concat((0, _toConsumableArray._)(altNamesMatched), (0, _toConsumableArray._)(anyOrderWordMatches), (0, _toConsumableArray._)(canonicalNamesFuzzyMatched)).filter(function(name) {
            if (seenMatches.has(name)) return false;
            seenMatches.add(name);
            return true;
        });
        populateResults(results);
        return results;
    };
};
function words(str) {
    // Supports non-latin scripts
    return (str || '').toLowerCase().trim().replace(RegExp("[\\p{P}\\p{S}]", "gu"), ' ').split(/\s+/).filter(function(w) {
        return w;
    });
}
function isPrefix(query, target) {
    return target.startsWith(query);
}
function allWordsInQueryMatchTargetWord(queryWords, target) {
    var targetWords = words(target);
    return queryWords.every(function(qw) {
        return targetWords.some(function(tw) {
            return tw.startsWith(qw);
        });
    });
}
function isFuzzyMatch(query, target) {
    // Avoids over fuzzy matching very short strings
    if (query.length <= 4 || target.length <= 3) return false;
    // Fuzzy matches if one letter different, added or removed
    for(var i = 0; i < query.length; i++){
        var queryChar = query[i];
        var targetChar = target[i];
        if (i >= target.length || targetChar !== queryChar) {
            var earlierMatch = query.substring(0, i);
            var endOfQueryNotIncludingCurrentLetter = query.substring(i + 1);
            var endOfQueryIncludingCurrentLetter = query.substring(i);
            var queryWithLetterReplaced = earlierMatch + targetChar + endOfQueryNotIncludingCurrentLetter;
            var queryWithLetterRemoved = earlierMatch + endOfQueryNotIncludingCurrentLetter;
            var queryWithLetterAdded = earlierMatch + targetChar + endOfQueryIncludingCurrentLetter;
            return isPrefix(queryWithLetterReplaced, target) || isPrefix(queryWithLetterRemoved, target) || isPrefix(queryWithLetterAdded, target);
        }
    }
    return true;
}
exports.isFuzzyMatch = isFuzzyMatch;

},{"@swc/helpers/_/_to_consumable_array":"6XR2l"}],"eDJCS":[function(require,module,exports,__globalThis) {
exports.nationalityButtons = function nationalityButtons() {
    var $removeCountryFieldButton = $('.remove-country-field');
    var $addAdditionalCountryFieldButton = $('.add-additional-country');
    // Configure 'remove' buttons
    $removeCountryFieldButton.click(function(event) {
        event.preventDefault();
        var wrapper = $(event.currentTarget).closest('.additional-country-form-group');
        var autocompleteId = wrapper.find('input:text').attr('id');
        setAutocompleteEmpty(autocompleteId);
        removeErrorClassesFromAutocomplete(autocompleteId);
        wrapper.addClass("hide");
        updateButtonVisibility();
    });
    // Configure 'add country' button
    $addAdditionalCountryFieldButton.click(function(event) {
        event.preventDefault();
        var firsthidden = getHiddenCountryFields().first();
        firsthidden.parent().append(firsthidden);
        firsthidden.removeClass("hide");
        updateButtonVisibility();
        firsthidden.find('input').focus();
    });
    // Set initial display states
    function hideIfEmptyAndErrorFree(element) {
        var $element = $(element);
        var hasError = !!$element.closest('.additional-country-form-group').find('.govuk-error-message').length;
        if (!$element.val() && !hasError) $element.closest('.additional-country-form-group').addClass("hide");
    }
    $('#added-country-2, #added-country-3').each(function(_, element) {
        return hideIfEmptyAndErrorFree(element);
    });
    updateButtonVisibility();
    function updateButtonVisibility() {
        if (getHiddenCountryFields().length === 0) $addAdditionalCountryFieldButton.hide();
        else $addAdditionalCountryFieldButton.show();
        if (getVisibleCountryFields().length > 1) $removeCountryFieldButton.show();
        else $removeCountryFieldButton.hide();
    }
    function getHiddenCountryFields() {
        return $('#different-country-html').find('.additional-country-form-group.hide');
    }
    function getVisibleCountryFields() {
        return $('#different-country-html').find('.additional-country-form-group:not(.hide)');
    }
};
function removeErrorClassesFromAutocomplete(autocompleteId) {
    var $select = $('#' + autocompleteId + '-select');
    if ($select.length) {
        $select.prevAll('.govuk-error-message').first().remove();
        $select.closest('.govuk-form-group').removeClass('govuk-form-group--error');
    }
    var $autocompleteInputWrapper = $('#' + autocompleteId).parent();
    if ($autocompleteInputWrapper.length) $autocompleteInputWrapper.removeClass('govuk-select--error');
}
function setAutocompleteEmpty(autocompleteId) {
    var input = document.getElementById(autocompleteId);
    if (input) input.value = '';
    var selectElt = document.getElementById(autocompleteId + '-select');
    if (selectElt) selectElt.value = '';
}

},{}],"lkTgn":[function(require,module,exports,__globalThis) {
// Prevent multiple form submissions by pressing enter or clicking the submit button
// The govukButton component has a preventDoubleClick property, but this only debounces in a one-second window,
// and is therefore not sufficient for our needs
var forms = document.querySelectorAll('form');
// only take the last form on the page, as document upload pages can have multiple forms on them, and this could
// otherwise interfere with their behavior. The 'continue' button is always in the last form on a page.
var lastForm = forms[forms.length - 1];
var hasSubmitted = false;
lastForm && lastForm.addEventListener('submit', function(e) {
    if (hasSubmitted) // prevent multiple form submissions by keyboard
    e.preventDefault();
    hasSubmitted = true;
    var buttons = document.querySelectorAll('.govuk-button');
    // We need the button to disable after the form submission has gone through otherwise the name and value of the button are lost on submission.
    setTimeout(function() {
        return buttons.forEach(function(button) {
            button.setAttribute('disabled', '');
            button.setAttribute('aria-disabled', true);
        });
    }, 0);
});

},{}],"gNFpA":[function(require,module,exports,__globalThis) {
exports.duplicateApplication = function() {
    $("#exit-button").click(function() {
        sendGAEvent("Exited after duplicate warning");
    });
    $("#continue-button").click(function() {
        if ($("#resubmit").is(":checked")) sendGAEvent("Submitted application after duplicate warning");
    });
    $('input[name="js-enabled"]').val("true");
};
function sendGAEvent(eventName) {
    ga && ga('send', {
        hitType: 'event',
        eventCategory: '/duplicate-application',
        eventAction: eventName
    });
    window.dataLayer && dataLayer.push({
        event: 'event_data',
        event_data: {
            event_name: 'duplicate_application'
        }
    });
}

},{}],"fEH4m":[function(require,module,exports,__globalThis) {
/**
 *  This file is similar to:
 *    - photo-upload.js
 *    - upload-documents.js
 *    - upload-documents-pre-selected.js
 *  Bugs found here likely have to be fixed there too.
 *  Possibility of commonizing these in the future.
 *
 *  This file (photo-upload.js) is currently used by:
 *    - VAC photo upload
 *      frontend/src/forms/provide-photo/provide-photo.njk
 *    - Postal and Proxy signature upload
 *      frontend/src/forms/absent-voting/upload-an-image.njk
 */ var _loader = require("../components/loader");
var _s3 = require("../s3");
exports.photoUpload = function(noPreviousUpload, fileUploadId, errorSummaryId, loaderContainerId, loaderStyleElementId, maxFileSizeInMB, minFileSizeInKB, acceptedFileExtensions, error__none_selected, error__too_big, error__too_small, error__filetypes, error__unknown, error__abort, screen_reader_alert__file_added, screen_reader_alert__file_removed, error_phrase) {
    var allowNoUpload = arguments.length > 17 && arguments[17] !== void 0 ? arguments[17] : false, continueButtonTextOnUpload = arguments.length > 18 ? arguments[18] : void 0;
    preventDropFilesExceptOnDropArea();
    addScreenReaderFileStatusAlert();
    var continueForm = document.getElementById("continue-form");
    var nextButton = continueForm.querySelector('button[name="submit-button"]');
    disableNextButtonOnRemoveFile();
    // The js code below only runs when the upload form is shown.
    if (!noPreviousUpload) return;
    var errorMessages = {
        error__none_selected: error__none_selected,
        error__too_big: error__too_big,
        error__too_small: error__too_small,
        error__filetypes: error__filetypes,
        error__unknown: error__unknown,
        error__abort: error__abort
    };
    var dropAreaWrapper = document.getElementById('drop-area-wrapper');
    dropAreaWrapper.classList.remove("hidden");
    var spinner = new GOVUK.Loader();
    var s3UploadForm = document.getElementById('file-upload-form');
    s3UploadForm.classList.add("hidden");
    var fileHasBeenUploadedOk = false;
    var dropAreaId = 'drop-area';
    var dropArea = document.getElementById(dropAreaId);
    var upload = document.getElementById(fileUploadId);
    var uploadButtonWrapperId = "upload-button-wrapper";
    var uploadButton = document.querySelector('button[name="upload-button"]');
    enableNextButton();
    var jsErrorSummary = document.getElementById(errorSummaryId);
    var jsErrorList = jsErrorSummary.querySelector("ul");
    uploadButton.addEventListener('click', function(ev) {
        upload.click();
    });
    upload.addEventListener('change', uploadFile);
    dropArea.addEventListener('drop', updateFiles);
    nextButton.addEventListener('click', onNextClick);
    function updateFiles(event) {
        dropAreaWrapper.classList.remove("drop-area-wrapper--active");
        event.preventDefault();
        var files = event.dataTransfer.files;
        if (files.length === 0) // You can trigger this event with no files by dropping things like other page elements
        return;
        else if (files.length !== 1) {
            renderErrorAndResetPageControls("Please only upload one file.");
            return;
        }
        upload.files = files;
        uploadFile(event);
    }
    [
        'dragenter',
        'dragover',
        'dragleave',
        'drop'
    ].forEach(function(eventName) {
        dropArea.addEventListener(eventName, function(event) {
            event.preventDefault();
            // Adds active state class to the drop area when item is dragged into
            // the drop zone.
            if (eventName === 'dragenter' || eventName === 'dragover') dropAreaWrapper.classList.add("drop-area-wrapper--active");
            // Removes active state class to the drop area when item is dragged out
            // from the drop zone.
            if (eventName === 'dragleave') dropAreaWrapper.classList.remove("drop-area-wrapper--active");
        });
    });
    function trackSignatureUploadError(error) {
        ga && ga('send', {
            hitType: 'event',
            eventCategory: 'Signature upload error',
            eventAction: error
        });
        window.dataLayer && dataLayer.push({
            event: 'event_data',
            event_data: {
                event_name: error
            }
        });
    }
    function onNextClick(event) {
        if (fileHasBeenUploadedOk || allowNoUpload) return true;
        else {
            // The user has clicked "continue" without selecting a file
            event.preventDefault();
            renderErrorAndResetPageControls(errorMessages.error__none_selected);
            trackSignatureUploadError("no_image_selected");
        }
    }
    function uploadFile(event) {
        event.preventDefault();
        var file = upload.files[0];
        var fileIsValid = validateFile(file);
        if (fileIsValid) {
            disableNextButton();
            dropAreaWrapper.classList.add("hidden");
            spinner.init({
                container: loaderContainerId,
                styleElementId: loaderStyleElementId,
                label: true
            });
            // testing browser support. if no support for the required js APIs
            // the form will just be posted naturally with no progress showing.
            var xhr = new XMLHttpRequest();
            if (!(xhr && 'upload' in xhr && 'onprogress' in xhr.upload) || !window.FormData) {
                s3UploadForm.submit();
                return;
            }
            xhr.upload.onprogress = progressHandler;
            xhr.onload = s3UploadCompleteHandler.bind(this, xhr, file.name);
            xhr.onerror = xhrErrorHandler;
            xhr.onabort = xhrAbortHandler;
            var formData = new FormData(s3UploadForm);
            // set to "" so not redirected automatically
            formData.set("success_action_redirect", "");
            xhr.open('POST', s3UploadForm.action);
            xhr.send(formData);
        }
        return false;
    }
    function validateFile(file) {
        if (!file) {
            renderErrorAndResetPageControls(errorMessages.error__none_selected);
            trackSignatureUploadError("no_image_selected");
            return false;
        }
        if (file.size > maxFileSizeInMB * 1000000) {
            renderErrorAndResetPageControls(errorMessages.error__too_big);
            trackSignatureUploadError("image_too_big");
            return false;
        }
        if (file.size < minFileSizeInKB * 1000) {
            renderErrorAndResetPageControls(errorMessages.error__too_small);
            trackSignatureUploadError("image_too_small");
            return false;
        }
        var nameLower = file.name.toLowerCase();
        if (!acceptedFileExtensions.find(function(ext) {
            return nameLower.endsWith(ext);
        })) {
            renderErrorAndResetPageControls(errorMessages.error__filetypes);
            trackSignatureUploadError("invalid_file_type");
            return false;
        }
        clearErrorSummaryItems();
        return true;
    }
    function progressHandler(e) {
        var progress = Math.floor(e.loaded / e.total * 100);
        spinner.updateMessage("Uploading... ".concat(progress, "%"));
        spinner.updateProgress(progress);
    }
    // Called when the upload to S3 has completed
    function s3UploadCompleteHandler(uploadXhr, fileName) {
        try {
            spinner.updateMessage("Processing");
            if (uploadXhr.status !== 204) // 'xhr.onerror' is only called if there's an error at the network level.
            // If the error only exists at the application level (e.g. an HTTP error code is sent), it will not be called.
            // So we need to check the status code here in order to show a validation message if s3 reject the file.
            throw new Error("Error status from S3: " + uploadXhr.status);
            // Tell the backend the name of the file that was just uploaded,
            // so the session state can be updated.
            // This allows us to avoid S3 "list" ops, which don't scale to high load.
            //
            // If the client browser fails or goes offline between the above op and
            // this then the image info will not get added to the session, and they
            // will need to upload it again
            // S3 can change the provided filename, for example spaces are trimmed.
            // We therefore get the final bucket + key info from the Location header
            var s3Location = uploadXhr.getResponseHeader("location");
            var bucketKey = (0, _s3.urlToBucketKey)(s3Location);
            // browser xhr support was already tested above
            var xhr = new XMLHttpRequest();
            xhr.onload = sessionUpdateCompleteHandler.bind(this, xhr);
            xhr.onerror = xhrErrorHandler;
            xhr.onabort = xhrAbortHandler;
            xhr.open('POST', document.location);
            var formData = {
                "s3-upload-complete": "true",
                bucket: bucketKey.bucket,
                key: bucketKey.key
            };
            xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
            // It would be nice to use responseType = "document" here to
            // ask the browser to parse the html response into a DOM
            // but that prevents us from reading a 400 response in JSON, so we
            // set this to text and do the DOM parsing using innerHTML
            xhr.responseType = "text";
            xhr.send(new URLSearchParams(Object.entries(formData)).toString());
        } catch (e) {
            console.log(e);
            renderErrorAndResetPageControls(errorMessages.error__unknown);
        }
    }
    // Called when the after-upload session update XHR has completed
    function sessionUpdateCompleteHandler(xhr) {
        try {
            if (xhr.status === 400) // Certain validation errors like image dimensions are checked server side
            // These will appear at key "photo-upload", see validateUploadedPhotoAndConvertIfRequired
            // Errors under other keys will be technical issues like failure to
            // parse the AWS response keys, so fall through to the generic error below.
            {
                if (xhr.getResponseHeader("content-type") === "application/json" || xhr.getResponseHeader("content-type") === "application/json; charset=utf-8") {
                    var body = JSON.parse(xhr.responseText);
                    if (body["errors"] && body["errors"]["photo-upload"] && body["errors"]["photo-upload"]["text"]) {
                        renderErrorAndResetPageControls(body["errors"]["photo-upload"]["text"]);
                        return;
                    }
                }
            }
            if (xhr.status !== 200) // 'xhr.onerror' is only called if there's an error at the network level.
            // If the error only exists at the application level (e.g. an HTTP error code is sent), it will not be called.
            // So we need to check the status code here in order to show a validation message if s3 reject the file.
            throw new Error("Error status from backend: " + xhr.status);
            var newHtml = xhr.responseText;
            if (!newHtml) throw new Error("responseText null. Not supported browser?");
            var elt = document.getElementById("upload-form-or-file-preview");
            elt.innerHTML = newHtml;
            resetPageControls();
            fileHasBeenUploadedOk = true;
            screenReaderFileAlert(screen_reader_alert__file_added);
            updateContinueButtonText();
            disableNextButtonOnRemoveFile();
        } catch (e) {
            console.log(e);
            renderErrorAndResetPageControls(errorMessages.error__unknown);
        }
    }
    // Error handler shared between the two XHR requests.
    // Set the UI to show a generic error message.
    // The buttons are set to enabled to allow the user to try again.
    function xhrErrorHandler(data) {
        console.error(data);
        renderErrorAndResetPageControls(errorMessages.error__unknown);
    }
    // Abort handler shared between the two XHR requests.
    // Set the UI to show a generic error message.
    // The buttons are set to enabled to allow the user to try again.
    function xhrAbortHandler() {
        renderErrorAndResetPageControls(errorMessages.error__abort);
    }
    function renderErrorAndResetPageControls(errorMessage) {
        dropAreaWrapper.classList.remove("hidden");
        upload.value = "";
        resetPageControls();
        addErrorSummaryItem(uploadButtonWrapperId, errorMessage);
        addErrorToUploadButton(errorMessage);
        updateTitleIfNotAlreadyInError();
        jsErrorSummary.style.display = 'block';
        jsErrorSummary.focus();
        document.body.scrollTop = document.documentElement.scrollTop = 0;
    }
    function updateTitleIfNotAlreadyInError() {
        var title = document.title;
        if (!title.startsWith("".concat(error_phrase, ":"))) document.title = "".concat(error_phrase, ": ").concat(title);
    }
    // Hide the spinner and re-enable the next button
    function resetPageControls() {
        spinner.stop();
        enableNextButton();
        clearErrorSummaryItems();
    }
    function clearErrorSummaryItems() {
        // Some pages have an error summary which is hidden by default, some don't. Setting to none works in both cases.
        jsErrorSummary.style.display = 'none';
        jsErrorList.childNodes.forEach(function(child) {
            jsErrorList.removeChild(child);
        });
    }
    function enableNextButton() {
        nextButton.removeAttribute("disabled");
        nextButton.removeAttribute("aria-disabled");
    }
    function disableNextButton() {
        nextButton.setAttribute("disabled", "");
        nextButton.setAttribute("aria-disabled", true);
    }
    function addErrorSummaryItem(fieldId, errorMessage) {
        var listItem = document.createElement("li");
        var anchor = listItem.appendChild(document.createElement("a"));
        anchor.href = "#" + fieldId;
        anchor.textContent = errorMessage;
        jsErrorList.appendChild(listItem);
    }
    function addErrorToUploadButton(errorMessage) {
        var inputContainer = uploadButton.parentNode;
        var errorContainerId = uploadButtonWrapperId + "-error";
        var span = document.getElementById(errorContainerId);
        if (span && span.lastChild) span.lastChild.textContent = errorMessage;
        else {
            span = document.createElement("span");
            span.id = errorContainerId;
            span.className = 'govuk-error-message';
            var hiddenSpan = span.appendChild(document.createElement("span"));
            hiddenSpan.className = "govuk-visually-hidden";
            hiddenSpan.textContent = "".concat(error_phrase, ":");
            var errorSpan = span.appendChild(document.createElement("span"));
            errorSpan.textContent = errorMessage;
        }
        inputContainer.insertBefore(span, uploadButton);
        inputContainer.classList.add("govuk-form-group--error");
    }
    // Prevent users from dropping files on the page except on the
    // dropArea. If you drop a file on a page element which isn't expecting
    // it then most browsers will just open the file, which might be
    // very confusing for our users.
    function preventDropFilesExceptOnDropArea() {
        window.addEventListener("dragenter", function(e) {
            if (!dropArea.contains(e.target)) {
                e.preventDefault();
                e.dataTransfer.effectAllowed = "none";
                e.dataTransfer.dropEffect = "none";
            }
        }, false);
        window.addEventListener("dragover", function(e) {
            if (!dropArea.contains(e.target)) {
                e.preventDefault();
                e.dataTransfer.effectAllowed = "none";
                e.dataTransfer.dropEffect = "none";
            }
        });
        window.addEventListener("drop", function(e) {
            if (!dropArea.contains(e.target)) {
                e.preventDefault();
                e.dataTransfer.effectAllowed = "none";
                e.dataTransfer.dropEffect = "none";
            }
        });
    }
    // On page load, look for query params set by postback redirects and
    // display a screen reader alert if applicable
    function addScreenReaderFileStatusAlert() {
        var urlSearchParams = new URLSearchParams(window.location.search);
        if (urlSearchParams.get("file-removed") === "true") screenReaderFileAlert(screen_reader_alert__file_removed);
    // no "file-added" case, as that's either handled directly in js,
    // see screen_reader_alert__file_added above, or we're no-js
    }
    function screenReaderFileAlert(alertMessage) {
        var alert = document.getElementById("hidden-alert-container");
        alert.innerHTML = alertMessage;
    }
    function updateContinueButtonText() {
        if (continueButtonTextOnUpload) nextButton.textContent = continueButtonTextOnUpload;
    }
    function disableNextButtonOnRemoveFile() {
        var removeFileButtons = document.getElementsByName('remove-file-button');
        removeFileButtons && removeFileButtons.forEach(function(button) {
            button.addEventListener('click', function() {
                disableNextButton();
            });
        });
    }
};

},{"../components/loader":"1sVIf","../s3":"9Relc"}],"1kSxw":[function(require,module,exports,__globalThis) {
var _loader = require("../components/loader");
exports.photoCheck = function(loaderContainerId, loaderStyleElementId) {
    var loader = document.getElementById(loaderContainerId);
    var sigImage = document.getElementById('signature-image');
    var continueButton = document.getElementById("check-form").querySelector('.govuk-button');
    var spinner = new GOVUK.Loader();
    if (!isImageLoadedOrError(sigImage)) {
        showElement(loader);
        hideElement(sigImage);
        disableButton(continueButton);
        spinner.init({
            container: loaderContainerId,
            styleElementId: loaderStyleElementId,
            label: true
        });
        spinner.updateMessage('Loading...');
        sigImage.addEventListener('load', imageOnLoad);
        setTimeout(function() {
            return enableButton(continueButton);
        }, 5000);
    }
    function imageOnLoad() {
        hideElement(loader);
        spinner.stop();
        showElement(sigImage);
        enableButton(continueButton);
    }
    function disableButton(button) {
        button.setAttribute('disabled', '');
        button.setAttribute('aria-disabled', true);
    }
    function enableButton(button) {
        button.removeAttribute('disabled');
        button.removeAttribute('aria-disabled');
    }
    function hideElement(element) {
        element.classList.add('hidden');
    }
    function showElement(element) {
        element.classList.remove('hidden');
    }
    function isImageLoadedOrError(imgElement) {
        // 'complete' is true if the image has loaded or is broken
        // Many examples on the web add (naturalHeight !== 0) here to exclude broken images
        // but we want to turn off the spinner and re-enable the continue button in that case
        // so we haven't added it here.
        return imgElement.complete;
    }
};

},{"../components/loader":"1sVIf"}],"9tPHN":[function(require,module,exports,__globalThis) {
exports.confirmation = function() {
    $('.change-link').click(function() {
        ga && ga('send', {
            hitType: 'event',
            eventCategory: '/confirmation',
            eventAction: 'Change link clicked'
        });
        window.dataLayer && dataLayer.push({
            event: 'event_data',
            event_data: {
                event_name: 'change_link_clicked'
            }
        });
    });
    $('input[name="js-enabled"]').val("true");
};

},{}],"bVALN":[function(require,module,exports,__globalThis) {
exports.name = function() {
    $('#name-form').submit(function(event) {
        var formData = new FormData(event.target);
        gaEventMiddleName(formData);
    });
};
function gaEventMiddleName(formData) {
    if (formData.get('middle-names')) ga && ga('send', {
        hitType: 'event',
        eventCategory: '/name',
        eventAction: "Middle name entered"
    });
}

},{}],"4seUS":[function(require,module,exports,__globalThis) {
exports.survey = function(radioGroupName) {
    var duplicateSection = document.getElementById('why-more-than-once-section');
    if (!duplicateSection) return;
    var howManySubmitsRadios = Array.from(document.querySelectorAll('input[type="radio"][name="'.concat(radioGroupName, '"]')));
    if (!howManySubmitsRadios.length) return;
    function shouldShowWhySubmittedMoreThanOnceSection() {
        var selectedOption = howManySubmitsRadios.find(function(r) {
            return r.checked;
        });
        return selectedOption && (selectedOption.value === '2' || selectedOption.value === '3-or-more');
    }
    function update() {
        duplicateSection.style.display = shouldShowWhySubmittedMoreThanOnceSection() ? '' : 'none';
    }
    howManySubmitsRadios.forEach(function(radio) {
        radio.addEventListener('change', update);
    });
    update();
};

},{}],"3MPZP":[function(require,module,exports,__globalThis) {
exports.init = function() {
    window.registerToVote = {
        nationality: require("d90d837c44ffa5c7").nationality,
        nameChangePage: require("eb83bb5287793baf").nameChange,
        otherAddress: require("a19329df9700a74").otherAddress,
        previousAddress: require("555ce8e7642993ad").previousAddress,
        openRegister: require("f4f068fb1e55c33b").openRegister,
        identityCard: require("7f4d1c13e9f5a824").identityCard,
        identityCardRequest: require("a6024226c06613f9").identityCardRequest,
        identityCardDelivery: require("1a8ddcf03a71167b").identityCardDelivery,
        voteInPerson: require("9bec2b2f6b28f622").voteInPerson,
        complete: require("74afe502d8dfd603").complete,
        lastRegisteredToVote: require("4e704e43e3eabd2f").lastRegisteredToVote,
        waysToVote: require("9295c13502892445").waysToVote,
        overseasVotingApplication: require("1a8ba64ffcb53ef7").overseasVotingApplication,
        passport: require("923a450e85b6d31d").passport,
        forcesStatement: require("d7f07803c2e44c4c").forcesStatement,
        addressFirstAnalytics: require("f7767619322dac1b").addressFirstAnalytics,
        forcesService: require("e3225e593b3457b5").forcesService,
        contactAddress: require("ea4a9dba252c4ae0").contactAddress,
        crownStatement: require("e533523187eafbe4").crownStatement
    };
};

},{"d90d837c44ffa5c7":"jkfoZ","eb83bb5287793baf":"fairc","a19329df9700a74":"1liaf","555ce8e7642993ad":"7HSFs","f4f068fb1e55c33b":"ciY1E","7f4d1c13e9f5a824":"26qcF","a6024226c06613f9":"ivRVu","1a8ddcf03a71167b":"cXPjr","9bec2b2f6b28f622":"1rUon","74afe502d8dfd603":"jdjJ6","4e704e43e3eabd2f":"jX4QY","9295c13502892445":"e3hL2","1a8ba64ffcb53ef7":"9WYpr","923a450e85b6d31d":"3aXL5","d7f07803c2e44c4c":"akpue","f7767619322dac1b":"7Qlbl","e3225e593b3457b5":"ePYZy","ea4a9dba252c4ae0":"jVQQA","e533523187eafbe4":"iBBGO"}],"jkfoZ":[function(require,module,exports,__globalThis) {
var compact = require("5cd49ad483eccab5");
exports.nationality = function nationality() {
    $('#add-additional-country-button').click(function() {
        ga && ga('send', {
            hitType: 'event',
            eventCategory: '/nationality',
            eventAction: 'Add additional country click',
            eventLabel: 'Nationality - Add additional country clicked'
        });
    });
    $('#nationality-form').submit(function(event) {
        var formData = new FormData(event.target);
        gaEventMultipleNationalities(formData);
        gaEventContactEmail(formData);
    });
};
function gaEventMultipleNationalities(formData) {
    var numAdditionalNationalities = compact([
        formData.get('added-country-1'),
        formData.get('added-country-2'),
        formData.get('added-country-3')
    ]).length;
    var numUkNationalities = formData.getAll('nationality').filter(function(nat) {
        return nat !== 'other';
    }).length;
    var numNationalities = numAdditionalNationalities + numUkNationalities;
    if (numNationalities > 1) ga && ga('send', {
        hitType: 'event',
        eventCategory: '/nationality',
        eventAction: 'Multiple nationalities provided'
    });
}
function gaEventContactEmail(formData) {
    if (formData.get('contact-email')) ga && ga('send', {
        hitType: 'event',
        eventCategory: 'Email Address Collection',
        eventAction: 'Nationality Email',
        eventLabel: 'Nationality - Email Address Provided'
    });
}

},{"5cd49ad483eccab5":"gHp4f"}],"gHp4f":[function(require,module,exports,__globalThis) {
/**
 * Creates an array with all falsey values removed. The values `false`, `null`,
 * `0`, `""`, `undefined`, and `NaN` are falsey.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to compact.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.compact([0, 1, false, 2, '', 3]);
 * // => [1, 2, 3]
 */ function compact(array) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (value) result[resIndex++] = value;
    }
    return result;
}
module.exports = compact;

},{}],"fairc":[function(require,module,exports,__globalThis) {
exports.name = function() {
    $('#name-form').submit(function(event) {
        var formData = new FormData(event.target);
        gaEventEverChangedName(formData);
    });
};
function gaEventEverChangedName(formData) {
    var nameChange = formData.get('name-change');
    if (nameChange === 'yes') ga && ga('send', {
        hitType: 'event',
        eventCategory: '/name',
        eventAction: 'Name change',
        eventLabel: "Name has been changed"
    });
    if (nameChange === 'no') ga && ga('send', {
        hitType: 'event',
        eventCategory: '/name',
        eventAction: 'Name change',
        eventLabel: "Name has not been changed"
    });
    if (nameChange === 'prefer-not-to-say') ga && ga('send', {
        hitType: 'event',
        eventCategory: '/name',
        eventAction: 'Name change',
        eventLabel: "Prefer not to say"
    });
}

},{}],"1liaf":[function(require,module,exports,__globalThis) {
exports.otherAddress = function() {
    $('#other-address-form').submit(function(event) {
        var formData = new FormData(event.target);
        gaEventHasOtherAddress(formData);
    });
};
function gaEventHasOtherAddress(formData) {
    var otherAddress = formData.get('other-address');
    if (otherAddress === "none") ga && ga('send', {
        hitType: 'event',
        eventCategory: '/other-address',
        eventAction: 'No',
        eventLabel: "No other address"
    });
    if (otherAddress === 'secondHome') ga && ga('send', {
        hitType: 'event',
        eventCategory: '/other-address',
        eventAction: 'Yes',
        eventLabel: "Has second home"
    });
    if (otherAddress === 'student') ga && ga('send', {
        hitType: 'event',
        eventCategory: '/other-address',
        eventAction: 'Yes',
        eventLabel: "Has student address"
    });
}

},{}],"7HSFs":[function(require,module,exports,__globalThis) {
exports.previousAddress = function() {
    $('#previous-address-form').submit(function(event) {
        var formData = new FormData(event.target);
        gaEventHasPreviousAddress(formData);
    });
};
function gaEventHasPreviousAddress(formData) {
    var previousAddress = formData.get('previous-address');
    if (previousAddress === "no") ga && ga('send', {
        hitType: 'event',
        eventCategory: '/previous-address',
        eventAction: 'No',
        eventLabel: "No previous address"
    });
    if (previousAddress === "yes-uk") ga && ga('send', {
        hitType: 'event',
        eventCategory: '/previous-address',
        eventAction: 'Yes',
        eventLabel: "Moved from UK address"
    });
    if (previousAddress === "dont-know") ga && ga('send', {
        hitType: 'event',
        eventCategory: '/previous-address',
        eventAction: "Don't know",
        eventLabel: "Don't know if moved since last registration (NI)"
    });
    if (previousAddress === "yes-abroad") ga && ga('send', {
        hitType: 'event',
        eventCategory: '/previous-address',
        eventAction: 'Yes',
        eventLabel: "Moved from abroad address"
    });
}

},{}],"ciY1E":[function(require,module,exports,__globalThis) {
exports.openRegister = function() {
    $('#open-register-form').submit(function(event) {
        var formData = new FormData(event.target);
        gaEventOpenRegisterOptOut(formData);
    });
};
function gaEventOpenRegisterOptOut(formData) {
    var openRegister = formData.get('open-register-opt-in');
    if (openRegister === "no") ga && ga('send', {
        hitType: 'event',
        eventCategory: '/open-register',
        eventAction: 'Open register opt out'
    });
}

},{}],"26qcF":[function(require,module,exports,__globalThis) {
exports.identityCard = function() {
    $('#identity-card-form').submit(function(event) {
        var formData = new FormData(event.target);
        gaEventIdentityCard(formData);
    });
};
function gaEventIdentityCard(formData) {
    var identityCard = formData.get('postal-vote');
    if (identityCard === 'yes') ga && ga('send', {
        hitType: 'event',
        eventCategory: 'Has ID (NI)',
        eventAction: 'Yes'
    });
    if (identityCard === 'no') ga && ga('send', {
        hitType: 'event',
        eventCategory: 'Has ID (NI)',
        eventAction: 'No'
    });
}

},{}],"ivRVu":[function(require,module,exports,__globalThis) {
exports.identityCardRequest = function() {
    $('#identity-card-request-form').submit(function(event) {
        var formData = new FormData(event.target);
        var requestIdentityCard = formData.get('identity-card');
        if (requestIdentityCard === 'yes') ga && ga('send', {
            hitType: 'event',
            eventCategory: 'Request EIC',
            eventAction: 'Yes'
        });
        if (requestIdentityCard === 'no') ga && ga('send', {
            hitType: 'event',
            eventCategory: 'Request EIC',
            eventAction: 'No'
        });
    });
};

},{}],"cXPjr":[function(require,module,exports,__globalThis) {
exports.identityCardDelivery = function() {
    $('#identity-card-delivery-form').submit(function(event) {
        var formData = new FormData(event.target);
        var deliveryMethod = formData.get('delivery-method');
        if (deliveryMethod === "email") ga && ga('send', {
            hitType: 'event',
            eventCategory: 'EIC delivery method',
            eventAction: 'Email'
        });
        if (deliveryMethod === 'post') ga && ga('send', {
            hitType: 'event',
            eventCategory: 'EIC delivery method',
            eventAction: 'Post'
        });
    });
};

},{}],"1rUon":[function(require,module,exports,__globalThis) {
exports.voteInPerson = function() {
    $('#vote-in-person-form').submit(function(event) {
        var formData = new FormData(event.target);
        gaEventVoteInPerson(formData);
        gaEventReason(formData);
    });
};
function gaEventVoteInPerson(formData) {
    var requestProxy = formData.get('proxy-vote');
    if (requestProxy === 'yes') ga && ga('send', {
        hitType: 'event',
        eventCategory: 'Request postal or proxy vote (NI)',
        eventAction: 'Yes'
    });
    if (requestProxy === 'no') ga && ga('send', {
        hitType: 'event',
        eventCategory: 'Request postal or proxy vote (NI)',
        eventAction: 'No'
    });
}
function gaEventReason(formData) {
    var reason = formData.get('reason');
    if (reason === "medical") ga && ga('send', {
        hitType: 'event',
        eventCategory: 'Reason for postal or proxy voting (NI)',
        eventAction: 'Medical'
    });
    if (reason === 'educational') ga && ga('send', {
        hitType: 'event',
        eventCategory: 'Reason for postal or proxy voting (NI)',
        eventAction: 'Educational'
    });
    if (reason === 'employment') ga && ga('send', {
        hitType: 'event',
        eventCategory: 'Reason for postal or proxy voting (NI)',
        eventAction: 'Employment'
    });
}

},{}],"jdjJ6":[function(require,module,exports,__globalThis) {
exports.complete = function(journeyInfo) {
    $('.about-your-application-link').click(function() {
        ga && ga('send', {
            hitType: 'event',
            eventCategory: '/complete',
            eventAction: "'About your application' clicked"
        });
    });
    $('.what-did-you-think-link').click(function() {
        ga && ga('send', {
            hitType: 'event',
            eventCategory: '/complete',
            eventAction: "'What did you think' clicked"
        });
    });
    $('#apply-postal-vote').click(function() {
        ga && ga('send', {
            hitType: 'event',
            eventCategory: '/complete',
            eventAction: "'Apply for postal vote' link clicked. Application type: ".concat(journeyInfo.type)
        });
    });
    $('#apply-proxy-vote').click(function() {
        ga && ga('send', {
            hitType: 'event',
            eventCategory: '/complete',
            eventAction: "'Apply for proxy vote' link clicked. Application type: ".concat(journeyInfo.type)
        });
    });
    $('#find-out-more-postal-vote').click(function() {
        ga && ga('send', {
            hitType: 'event',
            eventCategory: '/complete',
            eventAction: "'Find out more about postal voting' link clicked. Application type: ".concat(journeyInfo.type)
        });
    });
    $('#find-out-more-proxy-vote').click(function() {
        ga && ga('send', {
            hitType: 'event',
            eventCategory: '/complete',
            eventAction: "'Find out more about proxy voting' link clicked. Application type: ".concat(journeyInfo.type)
        });
    });
    $('#check-photo-id-link').click(function() {
        ga && ga('send', {
            hitType: 'event',
            eventCategory: '/complete',
            eventAction: "'Check what photo ID you need' link clicked. Application type: ".concat(journeyInfo.type)
        });
    });
    $('#voting-abroad-link').click(function() {
        ga && ga('send', {
            hitType: 'event',
            eventCategory: '/complete',
            eventAction: "'Voting if you live abroad' link clicked. Application type: ".concat(journeyInfo.type)
        });
    });
    gaEventJourneyCompleted(journeyInfo);
};
function gaEventJourneyCompleted(param) {
    var type = param.type, isWelshLocale = param.isWelshLocale, isNI = param.isNI;
    var journeyDescription = isWelshLocale ? "Welsh journey" : (isNI ? 'NI ' : '') + type;
    ga && ga('send', {
        hitType: 'event',
        eventCategory: 'Journey complete',
        eventAction: journeyDescription
    });
}

},{}],"jX4QY":[function(require,module,exports,__globalThis) {
exports.lastRegisteredToVote = function() {
    $('#last-registered-to-vote-form').submit(function(event) {
        var formData = new FormData(event.target);
        gaEventHowLastRegistered(formData);
    });
};
function gaEventHowLastRegistered(formData) {
    var howLastRegistered = formData.get('how-last-registered');
    if (howLastRegistered === 'ordinary') ga && ga('send', {
        hitType: 'event',
        eventCategory: 'How last registered',
        eventAction: 'UK resident'
    });
    if (howLastRegistered === 'overseas') ga && ga('send', {
        hitType: 'event',
        eventCategory: 'How last registered',
        eventAction: 'British or Irish citizen living abroad'
    });
    if (howLastRegistered === 'forces') ga && ga('send', {
        hitType: 'event',
        eventCategory: 'How last registered',
        eventAction: 'Member of the armed forces'
    });
    if (howLastRegistered === 'crown') ga && ga('send', {
        hitType: 'event',
        eventCategory: 'How last registered',
        eventAction: 'Crown servant'
    });
    if (howLastRegistered === 'council') ga && ga('send', {
        hitType: 'event',
        eventCategory: 'How last registered',
        eventAction: 'British Council employee'
    });
    if (howLastRegistered === 'not-sure') ga && ga('send', {
        hitType: 'event',
        eventCategory: 'How last registered',
        eventAction: 'Not sure'
    });
}

},{}],"e3hL2":[function(require,module,exports,__globalThis) {
exports.waysToVote = function() {
    $('#way-to-vote-form').submit(function(event) {
        var formData = new FormData(event.target);
        gaEventWayToVote(formData);
    });
};
function gaEventWayToVote(formData) {
    var wayToVote = formData.get('way-to-vote');
    if (wayToVote === "proxy") ga && ga('send', {
        hitType: 'event',
        eventCategory: 'Way to vote',
        eventAction: 'Proxy'
    });
    if (wayToVote === 'post') ga && ga('send', {
        hitType: 'event',
        eventCategory: 'Way to vote',
        eventAction: 'Post'
    });
    if (wayToVote === 'in-person') ga && ga('send', {
        hitType: 'event',
        eventCategory: 'Way to vote',
        eventAction: 'In-person'
    });
}

},{}],"9WYpr":[function(require,module,exports,__globalThis) {
exports.overseasVotingApplication = function(voteType) {
    $('#overseas-voting-application-form').submit(function(event) {
        var formData = new FormData(event.target);
        gaEventOverseasVotingApplication(formData);
        gaEventDeliveryMethod(formData);
    });
    function gaEventOverseasVotingApplication(formData) {
        var formRequired = formData.get("".concat(voteType, "-form"));
        if (formRequired === "yes") ga && ga('send', {
            hitType: 'event',
            eventCategory: "Overseas ".concat(voteType, " vote form required"),
            eventAction: 'Yes'
        });
        if (formRequired === "no") ga && ga('send', {
            hitType: 'event',
            eventCategory: "Overseas ".concat(voteType, " vote form required"),
            eventAction: 'No'
        });
    }
    function gaEventDeliveryMethod(formData) {
        var deliveryMethod = formData.get('delivery-method');
        if (deliveryMethod === "email") ga && ga('send', {
            hitType: 'event',
            eventCategory: "Overseas ".concat(voteType, " vote form delivery method"),
            eventAction: 'Email'
        });
        if (deliveryMethod === 'post') ga && ga('send', {
            hitType: 'event',
            eventCategory: "Overseas ".concat(voteType, " vote form delivery method"),
            eventAction: 'Post'
        });
    }
};

},{}],"3aXL5":[function(require,module,exports,__globalThis) {
exports.passport = function() {
    $('#passport-form').submit(function(event) {
        var formData = new FormData(event.target);
        gaEventHasPassport(formData);
        gaEventBornInUk(formData);
    });
};
function gaEventHasPassport(formData) {
    var hasUkPassport = formData.get('has-uk-passport');
    if (hasUkPassport === "yes") ga && ga('send', {
        hitType: 'event',
        eventCategory: 'Has UK passport',
        eventAction: 'yes'
    });
    if (hasUkPassport === "no") ga && ga('send', {
        hitType: 'event',
        eventCategory: 'Has UK passport',
        eventAction: 'no'
    });
}
function gaEventBornInUk(formData) {
    var bornInUk = formData.get('born-inside-uk');
    if (bornInUk === "yes") ga && ga('send', {
        hitType: 'event',
        eventCategory: 'Born inside UK',
        eventAction: 'yes'
    });
    if (bornInUk === "no") ga && ga('send', {
        hitType: 'event',
        eventCategory: 'Born inside UK',
        eventAction: 'no'
    });
}

},{}],"akpue":[function(require,module,exports,__globalThis) {
exports.forcesStatement = function forcesStatement() {
    $('#forces-statement-form').submit(function(event) {
        var formData = new FormData(event.target);
        var statement = formData.getAll('statement');
        if (statement.length === 2) ga && ga('send', {
            hitType: 'event',
            eventCategory: 'Forces statement',
            eventAction: 'Both options chosen'
        });
        if (statement.includes('armed-forces')) ga && ga('send', {
            hitType: 'event',
            eventCategory: 'Forces statement',
            eventAction: 'Member of forces'
        });
        if (statement.includes('spouse-forces')) ga && ga('send', {
            hitType: 'event',
            eventCategory: 'Forces statement',
            eventAction: 'Spouse member of forces'
        });
    });
};

},{}],"7Qlbl":[function(require,module,exports,__globalThis) {
exports.addressFirstAnalytics = function() {
    $('#address-first-form').submit(function(event) {
        var formData = new FormData(event.target);
        var hasUkAddress = formData.get('has-uk-address');
        if (hasUkAddress === "resident") ga && ga('send', {
            hitType: 'event',
            eventCategory: 'Has UK address',
            eventAction: 'Yes',
            eventLabel: "Resident"
        });
        if (hasUkAddress === 'not-resident') ga && ga('send', {
            hitType: 'event',
            eventCategory: 'Has UK address',
            eventAction: 'Yes',
            eventLabel: "Not resident"
        });
        if (hasUkAddress === 'no-connection') ga && ga('send', {
            hitType: 'event',
            eventCategory: 'Has UK address',
            eventAction: 'No'
        });
    });
};

},{}],"ePYZy":[function(require,module,exports,__globalThis) {
exports.forcesService = function() {
    $('#forces-service-form').submit(function(event) {
        var formData = new FormData(event.target);
        var service = formData.get('service');
        if (service === "navy") ga && ga('send', {
            hitType: 'event',
            eventCategory: 'Forces service',
            eventAction: 'Navy'
        });
        if (service === 'army') ga && ga('send', {
            hitType: 'event',
            eventCategory: 'Forces service',
            eventLabel: "Army"
        });
        if (service === 'raf') ga && ga('send', {
            hitType: 'event',
            eventCategory: 'Forces service',
            eventAction: 'RAF'
        });
    });
};

},{}],"jVQQA":[function(require,module,exports,__globalThis) {
exports.contactAddress = function() {
    $('#contact-address-form').submit(function(event) {
        var formData = new FormData(event.target);
        var type = formData.get('type');
        if (type === "uk") ga && ga('send', {
            hitType: 'event',
            eventCategory: 'Contact address',
            eventAction: 'UK'
        });
        if (type === 'bfpo') ga && ga('send', {
            hitType: 'event',
            eventCategory: 'Contact address',
            eventLabel: "BFPO"
        });
        if (type === 'other') ga && ga('send', {
            hitType: 'event',
            eventCategory: 'Contact address',
            eventAction: 'Other'
        });
    });
};

},{}],"iBBGO":[function(require,module,exports,__globalThis) {
exports.crownStatement = function() {
    $('#crown-statement-form').submit(function(event) {
        var formData = new FormData(event.target);
        var statement = formData.getAll('statement');
        if (statement.length > 1) ga && ga('send', {
            hitType: 'event',
            eventCategory: 'Crown statement',
            eventAction: 'Multiple options chosen'
        });
        if (statement.includes('crown-servant')) ga && ga('send', {
            hitType: 'event',
            eventCategory: 'Crown statement',
            eventAction: 'Crown servant',
            eventLabel: 'User'
        });
        if (statement.includes('spouse-crown')) ga && ga('send', {
            hitType: 'event',
            eventCategory: 'Crown statement',
            eventAction: 'Crown servant',
            eventLabel: 'Spouse'
        });
        if (statement.includes('british-council')) ga && ga('send', {
            hitType: 'event',
            eventCategory: 'Crown statement',
            eventAction: 'British council',
            eventLabel: 'User'
        });
        if (statement.includes('spouse-council')) ga && ga('send', {
            hitType: 'event',
            eventCategory: 'Crown statement',
            eventAction: 'British council',
            eventLabel: 'Spouse'
        });
    });
};

},{}]},["blONj"], "blONj", "parcelRequire0111", {})

//# sourceMappingURL=bundle.js.map
